const zhCN = {
    page:{
        "SYS001":{
            "你好":"你{0}好{1}",
            "内容有修改":"内容有修改，是否确认关闭？",
            "修改":"修改",
            "保存并继续":"保存并继续",
            "修改成功":"修改成功",
            "查询":"查询",
            "保存":"保存",
            "模块信息":"模块信息",
            "添加成功":"添加成功",
            "模块编码":"模块编码",
            "创建人":"创建人",
            "修改异常":"修改异常",
            "模块编码必须为三位大写字母":"模块编码必须为三位大写字母",
            "删除异常":"删除异常",
            "修改人":"修改人",
            "获取模块列表异常":"获取模块列表异常",
            "确定要删除吗":"确定要删除吗",
            "删除成功":"删除成功",
            "模块名称":"模块名称",
            "删除":"删除",
            "关闭":"关闭",
            "重置":"重置",
            "启用":"启用",
            "模块应用场景":"模块应用场景",
            "新增模块":"新增模块",
            "修改时间":"修改时间",
            "请选择一行数据":"请选择一行数据",
            "一级模块":"一级模块",
            "新增":"新增",
            "模块功能说明":"模块功能说明",
            "确定":"确定",
            "提示":"提示",
            "导出":"导出",
            "请输入":"请输入",
            "取消":"取消",
            "创建时间":"创建时间",
            "不能为空":"不能为空",
            "添加异常":"添加异常",
            "修改模块":"修改模块",
        },
        "omsMain":{
            "只能上传jpg/png/word/excel/pdf文件":"只能上传jpg/png/word/excel/pdf文件",
			"当前打印服务已是最新版本！":"当前打印服务已是最新版本！",
			"问题处理":"问题处理",
			"状态":"状态",
			"密码修改成功":"密码修改成功",
			"正在创建":"正在创建",
			"密码长度不能少于12位":"密码长度不能少于12位",
			"转单回车查询详情":"转单回车查询详情",
			"您因长时间未进行操作导致页面过期":"您因长时间未进行操作导致页面过期",
			"首次登陆修改密码":"首次登陆修改密码",
			"保存":"保存",
			"我":"我",
			"失败原因":"失败原因",
			"请输入回复内容!":"请输入回复内容!",
			"用户名":"用户名",
			"修改密码":"修改密码",
			"密码不得少于":"密码不得少于",
			" 条未读消息":" 条未读消息",
			"欢迎您":"欢迎您",
			"原密码":"原密码",
			"获取文件路径异常":"获取文件路径异常",
			"导出列表":"导出列表",
			"密码不能是完全相同的字符":"密码不能是完全相同的字符",
			"调用表信息":"调用表信息",
			"你有 ":"你有 ",
			"新密码":"新密码",
			"控件":"控件",
			"操作":"操作",
			"密码修改失败,密码有误！":"密码修改失败,密码有误！",
			"该问题件没有图片！":"该问题件没有图片！",
			"确认密码":"确认密码",
			"为确保用户安全":"为确保用户安全",
			"在此回复处理问题件":"在此回复处理问题件",
			"注意":"注意",
			"选项表明细查询失败":"选项表明细查询失败",
			"新密码和确认密码必须相同":"新密码和确认密码必须相同",
			"任务名称":"任务名称",
			"输入运单":"输入运单",
			"添加附件":"添加附件",
			"是否确定退出控制中心":"是否确定退出控制中心",
			"登录":"登录",
			"登录窗口":"登录窗口",
			"序号":"序号",
			"登录验证成功":"登录验证成功",
			"请做好密码修改":"请做好密码修改",
			"退出控制中心":"退出控制中心",
			"文件大小不能大于5MB":"文件大小不能大于5MB",
			"位":"位",
			"创建成功":"创建成功",
			"沟通记录":"沟通记录",
			"关闭":"关闭",
			"选项表明细查询成功":"选项表明细查询成功",
			"创建失败":"创建失败",
			"导出任务列表":"导出任务列表",
			"首次登陆后":"首次登陆后",
			"下载":"下载",
			"发送":"发送",
			"不允许出现连续数字或完全相同的字符":"不允许出现连续数字或完全相同的字符",
			"初始化密码容易被他人破解":"初始化密码容易被他人破解",
			"密码不能是连续数字":"密码不能是连续数字",
			"确定":"确定",
			"提示":"提示",
			"消息":"消息",
			"最新回复时间":"最新回复时间",
			"可添加附件":"可添加附件",
			"密码":"密码",
			"回复失败，请重新回复!":"回复失败，请重新回复!",
			"清除":"清除",
			"取消":"取消",
			"请输入密码":"请输入密码",
			"创建时间":"创建时间",
			"确认":"确认",
			"新密码不能与原密码相同":"新密码不能与原密码相同",
			"pos打印数据":"pos打印数据",
			"发送至邮箱": "发送至邮箱",
			"导出报表已自动发送到当前账号绑定的邮箱": "导出报表已自动发送到当前账号绑定的邮箱"
        },
		"tmsMain":{
			"只能上传jpg/png/word/excel/pdf文件":"只能上传jpg/png/word/excel/pdf文件",
			"当前打印服务已是最新版本！":"当前打印服务已是最新版本！",
			"问题处理":"问题处理",
			"状态":"状态",
			"密码修改成功":"密码修改成功",
			"正在创建":"正在创建",
			"密码长度不能少于12位":"密码长度不能少于12位",
			"转单回车查询详情":"转单回车查询详情",
			"您因长时间未进行操作导致页面过期":"您因长时间未进行操作导致页面过期",
			"首次登陆修改密码":"首次登陆修改密码",
			"保存":"保存",
			"我":"我",
			"失败原因":"失败原因",
			"请输入回复内容!":"请输入回复内容!",
			"用户名":"用户名",
			"修改密码":"修改密码",
			"密码不得少于":"密码不得少于",
			" 条未读消息":" 条未读消息",
			"欢迎您":"欢迎您",
			"原密码":"原密码",
			"获取文件路径异常":"获取文件路径异常",
			"导出列表":"导出列表",
			"密码不能是完全相同的字符":"密码不能是完全相同的字符",
			"调用表信息":"调用表信息",
			"你有 ":"你有 ",
			"新密码":"新密码",
			"控件":"控件",
			"操作":"操作",
			"密码修改失败,密码有误！":"密码修改失败,密码有误！",
			"该问题件没有图片！":"该问题件没有图片！",
			"确认密码":"确认密码",
			"为确保用户安全":"为确保用户安全",
			"在此回复处理问题件":"在此回复处理问题件",
			"注意":"注意",
			"选项表明细查询失败":"选项表明细查询失败",
			"新密码和确认密码必须相同":"新密码和确认密码必须相同",
			"任务名称":"任务名称",
			"输入运单":"输入运单",
			"添加附件":"添加附件",
			"是否确定退出控制中心":"是否确定退出控制中心",
			"登录":"登录",
			"登录窗口":"登录窗口",
			"序号":"序号",
			"登录验证成功":"登录验证成功",
			"请做好密码修改":"请做好密码修改",
			"退出控制中心":"退出控制中心",
			"文件大小不能大于5MB":"文件大小不能大于5MB",
			"位":"位",
			"创建成功":"创建成功",
			"沟通记录":"沟通记录",
			"关闭":"关闭",
			"选项表明细查询成功":"选项表明细查询成功",
			"创建失败":"创建失败",
			"导出任务列表":"导出任务列表",
			"首次登陆后":"首次登陆后",
			"下载":"下载",
			"发送":"发送",
			"不允许出现连续数字或完全相同的字符":"不允许出现连续数字或完全相同的字符",
			"初始化密码容易被他人破解":"初始化密码容易被他人破解",
			"密码不能是连续数字":"密码不能是连续数字",
			"确定":"确定",
			"提示":"提示",
			"消息":"消息",
			"最新回复时间":"最新回复时间",
			"可添加附件":"可添加附件",
			"密码":"密码",
			"回复失败，请重新回复!":"回复失败，请重新回复!",
			"清除":"清除",
			"取消":"取消",
			"请输入密码":"请输入密码",
			"创建时间":"创建时间",
			"确认":"确认",
			"新密码不能与原密码相同":"新密码不能与原密码相同",
			"pos打印数据":"pos打印数据"
		},
        "OMSHOME":{
            "草稿订单":"草稿订单",
			"只能上传jpg/png/word/excel/pdf文件":"只能上传jpg/png/word/excel/pdf文件",
			"报价查询":"报价查询",
			"问题处理":"问题处理",
			"问题状态":"问题状态",
			"公告消息":"公告消息",
			"问题件":"问题件",
			"正在研发中，敬请期待！":"正在研发中，敬请期待！",
			"运单号码":"运单号码",
			"姓名":"姓名",
			"我":"我",
			"请输入回复内容!":"请输入回复内容!",
			"收件邮编":"收件邮编",
			"请选择目的地":"请选择目的地",
			"算":"算",
			"待处理问题件":"待处理问题件",
			"问题描述":"问题描述",
			"包装类型":"包装类型",
			"业务看板":"业务看板",
			"获取文件路径异常":"获取文件路径异常",
			"订单导入":"订单导入",
			"发货记录如何使用":"发货记录如何使用",
			"导航":"导航",
			"待审核订单":"待审核订单",
			"该问题件没有图片！":"该问题件没有图片！",
			"在此回复处理问题件":"在此回复处理问题件",
			"您的专属服务信息":"您的专属服务信息",
			"货物重量":"货物重量",
			"请选择启运地":"请选择启运地",
			"添加附件":"添加附件",
			"业务类型":"业务类型",
			"起运地":"起运地",
			"轨迹查询":"轨迹查询",
			"请输入货物重量":"请输入货物重量",
			"帮助中心":"帮助中心",
			"账单管理":"账单管理",
			"电话":"电话",
			"运单查询":"运单查询",
			"文件大小不能大于5MB":"文件大小不能大于5MB",
			"沟通记录":"沟通记录",
			"已出货订单":"已出货订单",
			"关闭":"关闭",
			"您当前没有操作权限！":"您当前没有操作权限！",
			"待出货订单":"待出货订单",
			"试":"试",
			"目的地":"目的地",
			"已收货订单":"已收货订单",
			"订单列表":"订单列表",
			"待收货订单":"待收货订单",
			"平台操作说明书":"平台操作说明书",
			"职务":"职务",
			"发送":"发送",
			"登记日期":"登记日期",
			"询":"询",
			"查":"查",
			"恒巽":"恒巽",
			"订单导入操作指引":"订单导入操作指引",
			"最新回复时间":"最新回复时间",
			"可添加附件":"可添加附件",
			"暂无公告消息":"暂无公告消息",
			"打单":"打单",
			"回复失败，请重新回复!":"回复失败，请重新回复!"
        },
        "OMS002":{
			"单位":"单位",
            "请输入收件城市":"请输入收件城市",
				"请完善收件人信息":"请完善收件人信息",
				"省":"省",
				"请选择税金支付":"请选择税金支付",
				"订单保存并预报成功，订单号码： <":"订单保存并预报成功，订单号码： <",
				"寄件邮箱":"寄件邮箱",
				"税金支付不能为空":"税金支付不能为空",
				"添加":"添加",
				"原产地":"原产地",
				"指定路线":"指定路线",
				"寄件州":"寄件州",
				"收件州/省":"收件州/省",
				"收件税号":"收件税号",
				"选择":"选择",
				"保存":"保存",
				"最多":"最多",
				"总价":"总价",
				"列":"列",
				"清空":"清空",
				"包装类型":"包装类型",
				"请输入寄件城市":"请输入寄件城市",
				"获取文件路径异常":"获取文件路径异常",
				"单价不能为空":"单价不能为空",
				"操作":"操作",
				"货物重量不能为空":"货物重量不能为空",
				"请输入收件地址":"请输入收件地址",
				"请输入内容":"请输入内容",
				"否":"否",
				"行邮税号":"行邮税号",
				"付款方式":"付款方式",
				"寄件人":"寄件人",
				"其他":"其他",
				"基本信息":"基本信息",
				"是":"是",
				"件数":"件数",
				"查看订单":"查看订单",
				"平台类型":"平台类型",
				"不能上传jsp,bat,sh,js,exe文件":"不能上传jsp,bat,sh,js,exe文件",
				"寄件税号":"寄件税号",
				"选择常用收件人":"选择常用收件人",
				"请输入寄件地址":"请输入寄件地址",
				"请输入货物重量":"请输入货物重量",
				"收件人信息":"收件人信息",
				"继续编辑":"继续编辑",
				"收件城市":"收件城市",
				"序号":"序号",
				"指定路线不能为空":"指定路线不能为空",
				"单价":"单价",
				"自定义信息":"自定义信息",
				"行":"行",
				"必填":"必填",
				"注意以下几点要求":"注意以下几点要求",
				"删除":"删除",
				"数量":"数量",
				"目的地":"目的地",
				"请完善寄件人信息":"请完善寄件人信息",
				"请输入寄件邮编":"请输入寄件邮编",
				"保存成功":"保存成功",
				"列与列直接用":"列与列直接用",
				"数量不能为空":"数量不能为空",
				"寄件国家":"寄件国家",
				"英文品名不能为空":"英文品名不能为空",
				"请输入0-9999之间的重量":"请输入0-9999之间的重量",
				"信息复制到剪贴板即可":"信息复制到剪贴板即可",
				"请输入寄件国家":"请输入寄件国家",
				"转单号码":"转单号码",
				"提示":"提示",
				"文件大小不能大于10MB":"文件大小不能大于10MB",
				"商品图片地址":"商品图片地址",
				"请选择目的地！":"请选择目的地！",
				"字符以内":"字符以内",
				"订单保存到草稿成功，订单号码： <":"订单保存到草稿成功，订单号码： <",
				"请选择报关方式":"请选择报关方式",
				"请输入寄件电话":"请输入寄件电话",
				"收件人电话不能为空":"收件人电话不能为空",
				"运费":"运费",
				"取消":"取消",
				"位小数":"位小数",
				"保存到草稿":"保存到草稿",
				"收件邮箱":"收件邮箱",
				"配货信息":"配货信息",
				"海关编码":"海关编码",
				"商品链接地址":"商品链接地址",
				"快速录入":"快速录入",
				"用于额外打印在标签上":"用于额外打印在标签上",
				"请输入寄件人":"请输入寄件人",
				"删除成功!":"删除成功!",
				"货物类型不能为空":"货物类型不能为空",
				"选填":"选填",
				"收件邮编":"收件邮编",
				"寄件电话":"寄件电话",
				"请选择目的地":"请选择目的地",
				"请选择币别":"请选择币别",
				"包装类型不能为空":"包装类型不能为空",
				"订单号码":"订单号码",
				"品牌":"品牌",
				"请选择包装类型":"请选择包装类型",
				"信息":"信息",
				"收件地址":"收件地址",
				"下一订单":"下一订单",
				"寄件地址":"寄件地址",
				"寄件邮编":"寄件邮编",
				"请输入收件人！":"请输入收件人！",
				"货物重量":"货物重量",
				"英文品名":"英文品名",
				"寄件人不能为空":"寄件人不能为空",
				"收件公司":"收件公司",
				"请输入件数":"请输入件数",
				"上传附件":"上传附件",
				"请输入需要导入的信息!":"请输入需要导入的信息!",
				"收件人":"收件人",
				"保存为常用收件人":"保存为常用收件人",
				"收件人不能为空":"收件人不能为空",
				"备注":"备注",
				"寄件城市":"寄件城市",
				"寄件人信息":"寄件人信息",
				"单个重量":"单个重量",
				"请输入收件电话！":"请输入收件电话！",
				"区县":"区县",
				"关闭":"关闭",
				"请输入收件电话":"请输入收件电话",
				"格式为":"格式为",
				"目的地不能为空":"目的地不能为空",
				"材质":"材质",
				"收件人地址不能为空":"收件人地址不能为空",
				"寄件公司":"寄件公司",
				"第三方税金账号":"第三方税金账号",
				"收件州":"收件州",
				"请输入至少一行invoice信息！":"请输入至少一行invoice信息！",
				"请选择指定路线":"请选择指定路线",
				"请选择付款方式":"请选择付款方式",
				"代收款":"代收款",
				"导入":"导入",
				"用途":"用途",
				"确定":"确定",
				"请输入订单号码":"请输入订单号码",
				"点击保存按钮后添加信息":"点击保存按钮后添加信息",
				"税金支付":"税金支付",
				"请输入收件人":"请输入收件人",
				"规格":"规格",
				"件数不能为空":"件数不能为空",
				"订单号码为空，系统自动分配订单号码，是否继续？":"订单号码为空，系统自动分配订单号码，是否继续？",
				"请输入收件地址！":"请输入收件地址！",
				"收件电话":"收件电话",
				"更多信息":"更多信息",
				"导入格式":"导入格式",
				"保存为草稿":"保存为草稿",
				"保留上一笔":"保留上一笔",
				"导入前请将":"导入前请将",
				"货物类型":"货物类型",
				"请输入收件邮编":"请输入收件邮编",
				"中文品名":"中文品名",
				"请选择货物类型":"请选择货物类型",
				"请输入中文品名":"请输入中文品名",
				"保存并预报":"保存并预报",
				"确定删除此行吗？":"确定删除此行吗？",
				"选取":"选取",
				"第三方付税金账号":"第三方付税金账号",
				"隔开":"隔开"
        },
        "OMS003":{
				"导入处理类型":"导入处理类型",
				"订单导入模板有更新, 请下载最新模板":"订单导入模板有更新, 请下载最新模板",
				"提示":"提示",
				"确定":"确定",
                "指定路线":"指定路线",
                "历史日志":"历史日志",
				"订单导入成功":"订单导入成功",
				"数据有":"数据有",
				"成功":"成功",
				"状态":"状态",
				"自动获取运单号码":"自动获取运单号码",
				"导入中":"导入中",
				"上传失败":"上传失败",
				"导入文件不能超过10MB":"导入文件不能超过10MB",
				"文件大小不超过":"文件大小不超过",
				"运单号码":"运单号码",
				"验证中":"验证中",
				"导入时":"导入时",
				"批次号":"批次号",
				"验证失败":"验证失败",
				"解析中":"解析中",
				"请选择导入模版！":"请选择导入模版！",
				"组对应表头":"组对应表头",
				"需有":"需有",
				"失败":"失败",
				"解析失败":"解析失败",
				"条":"条",
				"导入":"导入",
				"请确认导入模板中表头的完整性":"请确认导入模板中表头的完整性",
				"导入历史日志":"导入历史日志",
				"总行数":"总行数",
				"请选择模版！":"请选择模版！",
				"如单个运单最多的":"如单个运单最多的",
				"导入时间":"导入时间",
				"模版下载":"模版下载",
				"导入文件格式支持":"导入文件格式支持",
				"错误说明":"错误说明",
				"导入文件":"导入文件",
				"请输入":"请输入",
				"文件下载":"文件下载",
				"上传中":"上传中",
				"行号":"行号",
				"错误行数":"错误行数",
				"导入模版":"导入模版",
				"新增模板":"新增模板",
                "订单号码":"订单号码",
                "序号":"序号",
                "模板管理":"模板管理",
                "编码":"编码",
                "名称":"名称",
                "备注":"备注",
                "标准模板":"标准模板"
        },
        "OMS008":{
            "只能上传jpg/png/word/excel/pdf文件":"只能上传jpg/png/word/excel/pdf文件",
            "点击上传附件":"点击上传附件",
            "全部问题件":"全部问题件",
            "问题处理":"问题处理",
            "问题状态":"问题状态",
            "登记人":"登记人",
            "登记成功！":"登记成功！",
            "运单号码":"运单号码",
            "指定路线":"指定路线",
            "查询":"查询",
            "我":"我",
            "可上传一个后缀名为":"可上传一个后缀名为",
            "保存":"保存",
            "请输入回复内容!":"请输入回复内容!",
            "收件邮编":"收件邮编",
            "笔":"笔",
            "请选择问题评价":"请选择问题评价",
            "登记":"登记",
            "问题描述":"问题描述",
            "登记日期不能为空":"登记日期不能为空",
            "问题个数":"问题个数",
            "已处理":"已处理",
            "文件未上传完，禁止保存！":"文件未上传完，禁止保存！",
            "最新轨迹":"最新轨迹",
            "附件":"附件",
            "获取文件路径异常":"获取文件路径异常",
            "评价":"评价",
            "请选择待评价的问题":"请选择待评价的问题",
            "该问题件没有图片！":"该问题件没有图片！",
            "大小不能超过":"大小不能超过",
            "问题类型":"问题类型",
            "问题件信息":"问题件信息",
            "添加附件":"添加附件",
            "件数":"件数",
            "问题件查询":"问题件查询",
            "处理描述":"处理描述",
            "处理状态":"处理状态",
            "待处理":"待处理",
            "登记异常":"登记异常",
            "问题件登记":"问题件登记",
            "在此回复处理问题件；可添加附件":"在此回复处理问题件；可添加附件",
            "评价成功":"评价成功",
            "序号":"序号",
            "未评价":"未评价",
            "文件大小不能大于5MB":"文件大小不能大于5MB",
            "沟通记录":"沟通记录",
            "回复中":"回复中",
            "关闭":"关闭",
            "处理完毕问题件":"处理完毕问题件",
            "重置":"重置",
            "评分":"评分",
            "已评价":"已评价",
            "请选择一行数据":"请选择一行数据",
            "发送":"发送",
            "登记日期":"登记日期",
            "评价 ":"评价 ",
            "未找到问题，请重新查询":"未找到问题，请重新查询",
            "寄件日期":"寄件日期",
            "请选择评分":"请选择评分",
            "参考编号":"参考编号",
            "确定":"确定",
            "回复":"回复",
            "转单号码":"转单号码",
            "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
            "提示":"提示",
            "收费重":"收费重",
            "目的地信息":"目的地信息",
            "最新回复时间":"最新回复时间",
            "回复失败，请重新回复!":"回复失败，请重新回复!",
            "导出":"导出",
            "请输入":"请输入",
            "取消":"取消",
            "的附件":"的附件",
            "通过处理状态可快速筛选问题件":"通过处理状态可快速筛选问题件",
            "评价内容":"评价内容"
        },
		"BMS122": {
        	"应收客户增值费明细":"应收客户增值费明细",
			"新增":"新增",
			"修改":"修改",
			"复制":"复制",
			"删除":"删除",
			"展开明细":"展开明细",
			"收起明细":"收起明细",
			"应收客户增值费":"应收客户增值费",
			"导出":"导出",
			"导出明细":"导出明细",
			"显示待生效报价":"显示待生效报价",
			"显示使用中报价":"显示使用中报价",
			"显示历史报价":"显示历史报价",
			"应收其他科目":"应收其他科目",
			"特殊客户":"特殊客户",
			"指定路线":"指定路线",
			"启用状态":"启用状态",
			"重置":"重置",
			"查询":"查询",
			"序号":"序号",
			"增加":"增加",
			"指定路线分类":"指定路线分类",
			"目的地":"目的地",
			"起始重量":"起始重量",
			"终止重量":"终止重量",
			"最低价格":"最低价格",
			"最高价格":"最高价格",
			"公式":"公式",
			"创建时间":"创建时间",
			"创建人":"创建人",
			"修改时间":"修改时间",
			"修改人":"修改人",
			"基础信息":"基础信息",
			"启用":"启用",
			"客户分组":"客户分组",
			"已选客户分组列表":"已选客户分组列表",
			"请输入关键字":"请输入关键字",
			"保存":"保存",
			"修改应收报价明细":"修改应收报价明细",
			"客户编码":"客户编码",
			"客户名称":"客户名称",
			"所属网点":"所属网点",
			"销售员":"销售员",
			"请输入起始重量":"请输入起始重量",
			"请输入终止重量":"请输入终止重量",
			"请输入公式":"请输入公式",
			"请选择科目":"请选择科目",
			"请选择币别":"请选择币别",
			"请选择生效日期":"请选择生效日期",
			"请输入停用日期":"请输入停用日期",
			"请输入":"请输入",
			"科目编码":"科目编码",
			"科目名称":"科目名称",
			"生效日期":"生效日期",
			"停用日期":"停用日期",
			"币别":"币别",
			"转本币结算":"转本币结算",
			"适用所有客户":"适用所有客户",
			"生效对象数":"生效对象数",
			"科目":"科目",
			"共":"共",
			"条":"条",
			"关闭":"关闭",
			"报价因素":"报价因素",
			"指定线路分类":"指定线路分类",
			"最低价":"最低价",
			"最高价":"最高价",
			"公式说明":"公式说明",
			"符号：+：加、 -：减、 *：乘、 /：除、()：括号":"符号：+：加、 -：减、 *：乘、 /：除、()：括号",
			"变量：收费重(@w)，实重(@a)，材重(@v)，申报价值(@s)，仓租天数(@d)，cod货款金额(@c)":"变量：收费重(@w)，实重(@a)，材重(@v)，申报价值(@s)，仓租天数(@d)，cod货款金额(@c)",
			"应收运费(@y),应收偏远费(@r)": "应收运费(@y),应收偏远费(@r)",
			"其他：明细中设置币别后，账单明细按设置币别生成":"其他：明细中设置币别后，账单明细按设置币别生成",
			"函数：round()，按指定的小数位数，四舍五入；ceiling()，进位取整；floor()，退位取整":"函数：round()，按指定的小数位数，四舍五入；ceiling()，进位取整；floor()，退位取整",
			"case when then else end，判断语句":"case when then else end，判断语句",
			"范围：起始重量 <  收费重 <= 终止重量":"范围：起始重量 <  收费重 <= 终止重量",
			"首重/续重设置方法：首重价 + ceiling ((@w-首重)/续重)*续重价":"首重/续重设置方法：首重价 + ceiling ((@w-首重)/续重)*续重价",
			"保存并继续":"保存并继续",
			"新增应收报价明细":"新增应收报价明细",
			"新增成功":"新增成功",
			"修改成功":"修改成功",
			"请选择数据":"请选择数据",
			"是否确认删除明细？":"是否确认删除明细？",
			"提示":"提示",
			"确定":"确定",
			"取消":"取消",
			"删除明细成功":"删除明细成功",
			"应收客户其他明细":"应收客户其他明细",
			"新增应收客户增值费":"新增应收客户增值费",
			"修改成功！":"修改成功！",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
			"将会同步删除明细数据，确定要删除吗？":"将会同步删除明细数据，确定要删除吗？",
			"删除成功！":"删除成功！",
			"请先选择数据！":"请先选择数据！",
			"内容有修改,是否确认关闭？'":"内容有修改,是否确认关闭？'",

		},

		"BMSAddedFee": {
			"指定路线":"指定路线",
			"请输入":"请输入",
			"导入模版":"导入模版",
			"导入":"导入",
			"模版下载":"模版下载",
			"1、导入文件格式支持.xls、.xlsx，文件大小不超过10M":"1、导入文件格式支持.xls、.xlsx，文件大小不超过10M",
			"批次号":"批次号",
			"导入文件":"导入文件",
			"导入时间":"导入时间",
			"状态":"状态",
			"总行数":"总行数",
			"错误行数":"错误行数",
			"文件下载":"文件下载",
			"历史日志":"历史日志",
			"错误说明下载":"错误说明下载",
			"导入历史日志":"导入历史日志",
			"行号":"行号",
			"运单号":"运单号",
			"错误信息":"错误信息",
			"请选择模版！":"请选择模版！",
			"请选择导入模版！":"请选择导入模版！",
			"导入文件不能超过10MB":"导入文件不能超过10MB",
			"上传中":"上传中",
			"上传失败":"上传失败",
			"解析中":"解析中",
			"解析失败":"解析失败",
			"验证中":"验证中",
			"验证失败":"验证失败",
			"导入中":"导入中",
			"成功":"成功",
			"失败":"失败",
		},

		"OMS018":{
        	"Ioss number":"Ioss number",
            "省":"省",
				"彻底删除订单完成，若删除失败，请在【预报异常】查看具体错误提示！":"彻底删除订单完成，若删除失败，请在【预报异常】查看具体错误提示！",
				"该订单无Invoice，无法下载":"该订单无Invoice，无法下载",
				"日志信息":"日志信息",
				"寄件邮箱":"寄件邮箱",
				"状态":"状态",
				"草稿":"草稿",
				"已收货情况下申请拦截":"已收货情况下申请拦截",
				"成功转草稿":"成功转草稿",
				"原产地":"原产地",
				"清空指定路线":"清空指定路线",
				"指定路线":"指定路线",
				"寄件州":"寄件州",
				"我是标题":"我是标题",
				"当前数据无修改，请先修改数据！":"当前数据无修改，请先修改数据！",
				"收件税号":"收件税号",
				"按百分比修改单价":"按百分比修改单价",
				"保存":"保存",
				"是否确定标记为已打印？":"是否确定标记为已打印？",
				"请选择要拦截的数据":"请选择要拦截的数据",
				"请选择要彻底删除的数据":"请选择要彻底删除的数据",
				"真的要将选择的<":"真的要将选择的<",
				"拦截原因":"拦截原因",
				"请选择订单状态是\"草稿\"的数据":"请选择订单状态是\"草稿\"的数据",
				"总价":"总价",
				"请选择要取消拦截的数据":"请选择要取消拦截的数据",
				"文件名":"文件名",
				"创建人":"创建人",
				"寄件时间":"寄件时间",
				"包装类型":"包装类型",
				"寄件区县":"寄件区县",
				"类别":"类别",
				"获取文件路径异常":"获取文件路径异常",
				"请选择订单状态是\"已预报\", \"已出货\",\"已收货\"的数据":"请选择订单状态是\"已预报\", \"已出货\",\"已收货\"的数据",
				"发票下载":"发票下载",
				"单价百分比和单价只能二选一！":"单价百分比和单价只能二选一！",
				"操作":"操作",
				"操作时间":"操作时间",
				"微软雅黑 Regular":"微软雅黑 Regular",
				"申请拦截":"申请拦截",
				"付款方式":"付款方式",
				"注意":"注意",
				"基本信息":"基本信息",
				"请选择订单状态是\"草稿\",\"已收货\", \"已出货\",\"已预报\"的数据":"请选择订单状态是\"草稿\",\"已收货\", \"已出货\",\"已预报\"的数据",
				"拦截":"拦截",
				"将不允许收货":"将不允许收货",
				"标签打印":"标签打印",
				"件数":"件数",
				"笔，有0未提交成功":"笔，有0未提交成功",
				"平台类型":"平台类型",
				"寄件税号":"寄件税号",
				"删除订单比较危险，您真的要删除吗？":"删除订单比较危险，您真的要删除吗？",
				"成功修改指定路线":"成功修改指定路线",
				"显示条件":"显示条件",
				"收件人信息":"收件人信息",
				"是否偏远":"是否偏远",
				"修改指定路线":"修改指定路线",
				"异常信息":"异常信息",
				"隐藏条件":"隐藏条件",
				"请选择要复制订单的数据":"请选择要复制订单的数据",
				"收件城市":"收件城市",
				"COD币别":"COD币别",
				"序号":"序号",
				"只有在已预报":"只有在已预报",
				"转寄原单号":"转寄原单号",
				"单价":"单价",
				"单号":"单号",
				"自定义信息":"自定义信息",
				"请选择订单状态是\"预报\"的数据":"请选择订单状态是\"预报\"的数据",
				"已收货":"已收货",
				"删除":"删除",
				"成功修改申报":"成功修改申报",
				"买家":"买家",
				"请选择订单状态是\"已收货\", \"已出货\",\"已预报\"的数据":"请选择订单状态是\"已收货\", \"已出货\",\"已预报\"的数据",
				"复制订单会产生一个新的订单（建议只有在拆单时才使用），您真的要复制吗？":"复制订单会产生一个新的订单（建议只有在拆单时才使用），您真的要复制吗？",
				"彻底删除订单将不能恢复，您真的要彻底删除吗？":"彻底删除订单将不能恢复，您真的要彻底删除吗？",
				"重置":"重置",
				"数量":"数量",
				"请选择订单状态是\"草稿\",\"已预报\"的数据":"请选择订单状态是\"草稿\",\"已预报\"的数据",
				"已预报的订单在收货时":"已预报的订单在收货时",
				"收件州省":"收件州省",
				"目的地":"目的地",
				"相关文件":"相关文件",
				"创建导出任务，请稍后在导出列表中下载！":"创建导出任务，请稍后在导出列表中下载！",
				"成功删除订单":"成功删除订单",
				"您真的要将选择的数据提交预报？":"您真的要将选择的数据提交预报？",
				"请选择要提交预报的数据":"请选择要提交预报的数据",
				"格式":"格式",
				"已预报":"已预报",
				"寄件国家":"寄件国家",
				"请选择订单状态是\"已删除\",\"已预报\"的数据":"请选择订单状态是\"已删除\",\"已预报\"的数据",
				"转单号码":"转单号码",
				"提示":"提示",
				">笔取消失败！":">笔取消失败！",
				"寄件日期不能为空":"寄件日期不能为空",
				"打印":"打印",
				"收件区县":"收件区县",
				"笔数据，其中<":"笔数据，其中<",
				">笔订单取消拦截吗？":">笔订单取消拦截吗？",
				"操作用户":"操作用户",
				"导出":"导出",
				"你真的要将选择的数据获取转单吗？(注意：此功能适合于快递订单)":"你真的要将选择的数据获取转单吗？(注意：此功能适合于快递订单)",
				"成功提交":"成功提交",
				"保留指定路线":"保留指定路线",
				"将不允许出货":"将不允许出货",
				"取消":"取消",
				"订单管理":"订单管理",
				"请选择要修改指定路线的数据":"请选择要修改指定路线的数据",
				"预报异常":"预报异常",
				"请选择订单状态是\"已预报\"的数据":"请选择订单状态是\"已预报\"的数据",
				"基础信息":"基础信息",
				"收件邮箱":"收件邮箱",
				"配货信息":"配货信息",
				"税金付款":"税金付款",
				"海关编码":"海关编码",
				"商品链接地址":"商品链接地址",
				"标记":"标记",
				"表格双击后查看订单详情":"表格双击后查看订单详情",
				"全部":"全部",
				"运单号码":"运单号码",
				"查询":"查询",
				"您真的要将选择的数据修改指定路线吗？":"您真的要将选择的数据修改指定路线吗？",
				"收件邮编":"收件邮编",
				"未填写栏位不做修改":"未填写栏位不做修改",
				"成功提交预报":"成功提交预报",
				"订单号码":"订单号码",
				"品牌":"品牌",
				"COD金额":"COD金额",
				"收件地址":"收件地址",
				"转草稿":"转草稿",
				"寄件地址":"寄件地址",
				"已收货的订单":"已收货的订单",
				"寄件邮编":"寄件邮编",
				"货物重量":"货物重量",
				"英文品名":"英文品名",
				"重量":"重量",
				"打印状态":"打印状态",
				"货物信息":"货物信息",
				"订单日期":"订单日期",
				"已出货":"已出货",
				"申报价值":"申报价值",
				"请选择要修改申报的数据":"请选择要修改申报的数据",
				"复制订单":"复制订单",
				"真的要将选择的订单申请拦截吗？":"真的要将选择的订单申请拦截吗？",
				"成功取消订单":"成功取消订单",
				"收件人":"收件人",
				"导入修改":"导入修改",
				"请输入拦截原因!":"请输入拦截原因!",
				"请选择要转草稿的数据":"请选择要转草稿的数据",
				"成功复制订单":"成功复制订单",
				"备注":"备注",
				"寄件城市":"寄件城市",
				"寄件人信息":"寄件人信息",
				"订单日期不能为空":"订单日期不能为空",
				"关闭":"关闭",
				"申请拦截后":"申请拦截后",
				"取消拦截":"取消拦截",
				"请输入拦截原因":"请输入拦截原因",
				"下载":"下载",
				"没有获取到下载地址！":"没有获取到下载地址！",
				"收件州":"收件州",
				"选择的订单拦截成功！":"选择的订单拦截成功！",
				"已删除":"已删除",
				"内容":"内容",
				"请选择指定路线":"请选择指定路线",
				"请选择要打印订单的数据":"请选择要打印订单的数据",
				"确定":"确定",
				"创建导出任务失败:":"创建导出任务失败:",
				"请选择订单状态是\"已删除\"的数据":"请选择订单状态是\"已删除\"的数据",
				"收货标签":"收货标签",
				"请选择小于50笔数据下载":"请选择小于50笔数据下载",
				"彻底删除":"彻底删除",
				"提交预报":"提交预报",
				"代表":"代表",
				"收件电话":"收件电话",
				"单价百分比":"单价百分比",
				"货物类型":"货物类型",
				"笔，有0笔未提交成功":"笔，有0笔未提交成功",
				"中文品名":"中文品名",
				"创建时间":"创建时间",
				"请选择要删除的数据":"请选择要删除的数据",
				"请选择订单状态是\"草稿\", \"已预报\"的数据":"请选择订单状态是\"草稿\", \"已预报\"的数据",
				"彻底删除成功":"彻底删除成功",
				"修改申报":"修改申报",
				"请选择要获取转单号码的订单数据":"请选择要获取转单号码的订单数据",
				"客户":"客户",
				"客户(可多选)":"客户(可多选)",
        },
        "OMS005":{
			"自动翻译寄件公司":"自动翻译寄件公司",
            "省":"省",
				"终止邮编":"终止邮编",
				"公司":"公司",
				"净重":"净重",
				"添加":"添加",
				"寄件信息":"寄件信息",
				"手动打印":"手动打印",
				"原产地":"原产地",
				"没有得到走货路线":"没有得到走货路线",
				"付款账号":"付款账号",
				"指定路线":"指定路线",
				"收件税号":"收件税号",
				"保存":"保存",
				"printScene:INVOICE打印机":"printScene:INVOICE打印机",
				"收件人账号":"收件人账号",
				"寄件机场代码":"寄件机场代码",
				"单价币别":"单价币别",
				"收件信息":"收件信息",
				"地址":"地址",
				"包装类型":"包装类型",
				"包装方式":"包装方式",
				"收件电话可能包含电话区号,是否继续":"收件电话可能包含电话区号,是否继续",
				"机场代码查询":"机场代码查询",
				"操作":"操作",
				"保险":"保险",
				"打印机":"打印机",
				"否":"否",
				"is_plt 配置为固定值了貌似修改了也无效":"is_plt 配置为固定值了貌似修改了也无效",
				"打单前请设置好备份联打印机":"打单前请设置好备份联打印机",
				"上下偏差":"上下偏差",
				"邮编类型":"邮编类型",
				"付款方式":"付款方式",
				"其他":"其他",
				"注意":"注意",
				"基本信息":"基本信息",
				"是":"是",
				"混打模式":"混打模式",
				"寄件账号":"寄件账号",
				"件数":"件数",
				"邮编":"邮编",
				"转单后打印":"转单后打印",
				"打单前请设置好LABEL打印机":"打单前请设置好LABEL打印机",
				"修改指定路线":"修改指定路线",
				"联络人":"联络人",
				"出货重":"出货重",
				"指定路线不能为空":"指定路线不能为空",
				"目的机场代码":"目的机场代码",
				"查询条件":"查询条件",
				"单价":"单价",
				"国家编号":"国家编号",
				"删除":"删除",
				"EDI_LABEL打印机":"EDI_LABEL打印机",
				"黑名单确认":"黑名单确认",
				"打印设置":"打印设置",
				"税金第三方国家":"税金第三方国家",
				"保存时获取转单":"保存时获取转单",
				"重置":"重置",
				"国家":"国家",
				"数量":"数量",
				"件数必填并且大于0":"件数必填并且大于0",
				"目的地":"目的地",
				"有电池信息时":"有电池信息时",
				"毛重":"毛重",
				"设置":"设置",
				"备份联":"备份联",
				"保存时不获取转单":"保存时不获取转单",
				"提示":"提示",
				"寄件操作中心":"寄件操作中心",
				"国家简码":"国家简码",
				"INVOICE打印机":"INVOICE打印机",
				"税金第三方邮编":"税金第三方邮编",
				"打单前请设置好INVOICE打印机":"打单前请设置好INVOICE打印机",
				"确":"确",
				"设置信息":"设置信息",
				"税金三方信息":"税金三方信息",
				"报关方式":"报关方式",
				"备份联打印机":"备份联打印机",
				"不支持的跳转方式":"不支持的跳转方式",
				"运费":"运费",
				"小计":"小计",
				"加载失败：":"加载失败：",
				"转单后打印备份联":"转单后打印备份联",
				"机场代码":"机场代码",
				"海关编码":"海关编码",
				"保存时打印":"保存时打印",
				"税金第三方公司":"税金第三方公司",
				">不一致":">不一致",
				"原始大小":"原始大小",
				"运单号码":"运单号码",
				"暂不支持电池信打印":"暂不支持电池信打印",
				"查询":"查询",
				"打单返回":"打单返回",
				"回车后":"回车后",
				"货物类型不能为空":"货物类型不能为空",
				"联系电话":"联系电话",
				"包装类型不能为空":"包装类型不能为空",
				"需强制录入发票信息":"需强制录入发票信息",
				"定":"定",
				"安全的从有效字段缓存中取值":"安全的从有效字段缓存中取值",
				"郊区":"郊区",
				"开始邮编":"开始邮编",
				"操作中心":"操作中心",
				"旋转角度":"旋转角度",
				"打印份数":"打印份数",
				"自动保存收件信息":"自动保存收件信息",
				"请选择代理EDI":"请选择代理EDI",
				"密度":"密度",
				"打单设置":"打单设置",
				"英文品名":"英文品名",
				"无纸化":"无纸化",
				"货物信息":"货物信息",
				"服务方式":"服务方式",
				"当前走货路线未配置EDI":"当前走货路线未配置EDI",
				"EDI 配置或API配置不能为空":"EDI 配置或API配置不能为空",
				"电子邮件":"电子邮件",
				"申报价值":"申报价值",
				"州省编号":"州省编号",
				"代理打单":"代理打单",
				"计量单位":"计量单位",
				"公司名称":"公司名称",
				"API没有配置接口名称":"API没有配置接口名称",
				"折扣":"折扣",
				"转单后打印电池信":"转单后打印电池信",
				"包装类型和配置包装类型<":"包装类型和配置包装类型<",
				"备注":"备注",
				"强制录入发票":"强制录入发票",
				"重量单位":"重量单位",
				"关闭":"关闭",
				"寄件信息自动保留":"寄件信息自动保留",
				"目的地不能为空":"目的地不能为空",
				"已停用":"已停用",
				"printScene:EDI_LABEL打印机":"printScene:EDI_LABEL打印机",
				"当前参考编号已存在，如果继续将会导致数据重复，是否继续":"当前参考编号已存在，如果继续将会导致数据重复，是否继续",
				"参考编号不能为空":"参考编号不能为空",
				"州":"州",
				"出货重必填并且大于0":"出货重必填并且大于0",
				"printScene:备份联打印机":"printScene:备份联打印机",
				"代收款":"代收款",
				"参考编号":"参考编号",
				"开始打单":"开始打单",
				"目的操作中心":"目的操作中心",
				"收件电话校验":"收件电话校验",
				"危险品":"危险品",
				"税金账号":"税金账号",
				"税金支付":"税金支付",
				"州省":"州省",
				"双击表格后选取表格当前行":"双击表格后选取表格当前行",
				"确认信息":"确认信息",
				"货物类型":"货物类型",
				"中文品名":"中文品名",
				"进口商":"进口商",
				"左右偏差":"左右偏差",
				"预约编号":"预约编号",
				"选取":"选取",
				"城市":"城市"
        },
        "OMS006":{
            "修改":"修改",
				"选中行还未生成运单数据，无法跳转至运单详情！":"选中行还未生成运单数据，无法跳转至运单详情！",
				"打印时间":"打印时间",
				"寄件邮箱":"寄件邮箱",
				"取消审核成功！":"取消审核成功！",
				"打单状态不为已审核，无法进行取消审核！":"打单状态不为已审核，无法进行取消审核！",
				">笔，成功<":">笔，成功<",
				"指定路线":"指定路线",
				"此操作将进行撤销账单, 是否继续?":"此操作将进行撤销账单, 是否继续?",
				"确定要取消审核吗？":"确定要取消审核吗？",
				"撤销审核成功！":"撤销审核成功！",
				"请勾选一行数据":"请勾选一行数据",
				"没有配置LABEL自定义模板":"没有配置LABEL自定义模板",
				"此操作将进行撤销审核, 是否继续?":"此操作将进行撤销审核, 是否继续?",
				"审核成功！":"审核成功！",
				"寄件人":"寄件人",
				"付款方式":"付款方式",
				"没有获取到备用联label地址":"没有获取到备用联label地址",
				"未审核数据，无法撤销审核！":"未审核数据，无法撤销审核！",
				"件数":"件数",
				"您真的要对选择的<":"您真的要对选择的<",
				"审核总数<":"审核总数<",
				"收件城市":"收件城市",
				"没有配置LABEL 输出方式":"没有配置LABEL 输出方式",
				"批量预览":"批量预览",
				"请选择数据进行修改":"请选择数据进行修改",
				"的数据":"的数据",
				"转单状态":"转单状态",
				"已审核数据，无法再次审核！":"已审核数据，无法再次审核！",
				"没有配置INVOICE自定义模板":"没有配置INVOICE自定义模板",
				"重置":"重置",
				"浏览":"浏览",
				"打单时间":"打单时间",
				"审核异常":"审核异常",
				"收件国家简码":"收件国家简码",
				"申报币别":"申报币别",
				">笔做批量审核吗？":">笔做批量审核吗？",
				"批量审核":"批量审核",
				"含发票":"含发票",
				"备份联":"备份联",
				"转单号码":"转单号码",
				"提示":"提示",
				"取消打单数据成功！":"取消打单数据成功！",
				"已确认或部分确认数据，无法撤销账单！":"已确认或部分确认数据，无法撤销账单！",
				"INVOICE打印机":"INVOICE打印机",
				"已审核数据，无法撤销账单！":"已审核数据，无法撤销账单！",
				"请勾选至少一行\"待审核\"数据":"请勾选至少一行\"待审核\"数据",
				"寄件地址3":"寄件地址3",
				"取消审核":"取消审核",
				"寄件地址2":"寄件地址2",
				"没有找到打印配置":"没有找到打印配置",
				"英文品名1":"英文品名1",
				"打印":"打印",
				"英文品名2":"英文品名2",
				"英文品名3":"英文品名3",
				"寄件地址1":"寄件地址1",
				"导出":"导出",
				"打单子单信息":"打单子单信息",
				"备份联打印机":"备份联打印机",
				"取消":"取消",
				"请先配置INVOICE输出方式":"请先配置INVOICE输出方式",
				"收件邮箱":"收件邮箱",
				"取消打单数据异常":"取消打单数据异常",
				"请勾选至少一行非\"待转单\"数据":"请勾选至少一行非\"待转单\"数据",
				"打单状态不为“待审核”，不允许取消重打":"打单状态不为“待审核”，不允许取消重打",
				"取消重打异常！":"取消重打异常！",
				"打单查询":"打单查询",
				"运单号码":"运单号码",
				"查询":"查询",
				"税金方式":"税金方式",
				"收件邮编":"收件邮编",
				"单件补打":"单件补打",
				"取消打单":"取消打单",
				"获取子单信息失败！":"获取子单信息失败！",
				"打单状态不为待转单或待审核，无法进行取消！":"打单状态不为待转单或待审核，无法进行取消！",
				"请选择需要":"请选择需要",
				"重量":"重量",
				"打印状态":"打印状态",
				"申报价值":"申报价值",
				"子单信息":"子单信息",
				"收件公司":"收件公司",
				"单票":"单票",
				"撤销账单成功！":"撤销账单成功！",
				"转重打":"转重打",
				"收件人":"收件人",
				"寄件城市":"寄件城市",
				"确定要取消该打单数据吗？":"确定要取消该打单数据吗？",
				"关闭":"关闭",
				"此操作将进行数据审核, 是否继续?":"此操作将进行数据审核, 是否继续?",
				"收件地址1":"收件地址1",
				"没有获取到子单数据":"没有获取到子单数据",
				"_LABEL打印机":"_LABEL打印机",
				"收件地址3":"收件地址3",
				"寄件公司":"寄件公司",
				"收件地址2":"收件地址2",
				"请选择一行数据":"请选择一行数据",
				"打单状态为待转单才可":"打单状态为待转单才可",
				"没有获取到label 地址":"没有获取到label 地址",
				"参考编号":"参考编号",
				"确定":"确定",
				"收件电话":"收件电话",
				"货物类型":"货物类型",
				"中文品名":"中文品名",
				"取消重打成功！":"取消重打成功！",
				"取消审核异常":"取消审核异常"
        },
        "OMS007":{
            "状态":"状态",
				"原产地":"原产地",
				"我是标题":"我是标题",
				"printScene:INVOICE打印机":"printScene:INVOICE打印机",
				"总价":"总价",
				"材积除以数":"材积除以数",
				"文件名":"文件名",
				"费用合计":"费用合计",
				"寄件区县":"寄件区县",
				"最新轨迹":"最新轨迹",
				"获取文件路径异常":"获取文件路径异常",
				"没有文件可以下载":"没有文件可以下载",
				"操作":"操作",
				"处理人":"处理人",
				"包装项目":"包装项目",
				"已入库":"已入库",
				"汇率":"汇率",
				"已退返":"已退返",
				"寄件税号":"寄件税号",
				"邮编":"邮编",
				"打单前请设置好LABEL打印机":"打单前请设置好LABEL打印机",
				"币别":"币别",
				"交货到末公里":"交货到末公里",
				"转寄原单号":"转寄原单号",
				"订单已支付":"订单已支付",
				"货物状态":"货物状态",
				"单价":"单价",
				"数量":"数量",
				"收件州省":"收件州省",
				"相关文件":"相关文件",
				"本币":"本币",
				"发送":"发送",
				"格式":"格式",
				"未选则数据，请重新选择":"未选则数据，请重新选择",
				"转单号码":"转单号码",
				"出货":"出货",
				"交货给干线代理":"交货给干线代理",
				"打单前请设置好INVOICE打印机":"打单前请设置好INVOICE打印机",
				"可添加附件":"可添加附件",
				"寄件日期不能为空":"寄件日期不能为空",
				"材重":"材重",
				"报关方式":"报关方式",
				"下载转单文件":"下载转单文件",
				"请输入":"请输入",
				"请至少选择一行数据！":"请至少选择一行数据！",
				"航班起飞":"航班起飞",
				"收件邮箱":"收件邮箱",
				"海关编码":"海关编码",
				"新建问题":"新建问题",
				"运单轨迹显示":"运单轨迹显示",
				"全部":"全部",
				"参考":"参考",
				"查询":"查询",
				"只支持PDF下载":"只支持PDF下载",
				"货物状态时间":"货物状态时间",
				"收费材重":"收费材重",
				"该问题件没有图片！":"该问题件没有图片！",
				"到付款":"到付款",
				"轨迹信息":"轨迹信息",
				"个问题件":"个问题件",
				"包裹损坏":"包裹损坏",
				"添加附件":"添加附件",
				"除以数":"除以数",
				"时间":"时间",
				"已出货":"已出货",
				"最新轨迹位置":"最新轨迹位置",
				"一次导出单号数量不能超过3000":"一次导出单号数量不能超过3000",
				"运费合计":"运费合计",
				"模糊":"模糊",
				"末端转运中":"末端转运中",
				"其它":"其它",
				"退件号码":"退件号码",
				"备注":"备注",
				"退回海外仓":"退回海外仓",
				"printScene:EDI_LABEL打印机":"printScene:EDI_LABEL打印机",
				"待转单":"待转单",
				"包裹到达自提点":"包裹到达自提点",
				"下载":"下载",
				"高":"高",
				"没有获取到下载地址！":"没有获取到下载地址！",
				"预报重量":"预报重量",
				"双击行查看详情":"双击行查看详情",
				"printScene:备份联打印机":"printScene:备份联打印机",
				"目的地编码":"目的地编码",
				"欠费锁机":"欠费锁机",
				"最新状态":"最新状态",
				"收费重":"收费重",
				"派送异常":"派送异常",
				"当前转单Lable格式为EPL2，限制预览":"当前转单Lable格式为EPL2，限制预览",
				"收件电话":"收件电话",
				"材重合计":"材重合计",
				"问题信息":"问题信息",
				"运单状态":"运单状态",
				"中文品名":"中文品名",
				"未找到发货记录，请重新查询":"未找到发货记录，请重新查询",
				"金额":"金额",
				"省":"省",
				"寄件邮箱":"寄件邮箱",
				"航班抵达":"航班抵达",
				"登记成功！":"登记成功！",
				"收件人拒收":"收件人拒收",
				"指定路线":"指定路线",
				"寄件州":"寄件州",
				"收件税号":"收件税号",
				"可多选":"可多选",
				"实重合计":"实重合计",
				"创建人":"创建人",
				"寄件时间":"寄件时间",
				"收费重合计":"收费重合计",
				"包装费合计":"包装费合计",
				"包装类型":"包装类型",
				"类别":"类别",
				"附件":"附件",
				"请选择数据":"请选择数据",
				"微软雅黑 Regular":"微软雅黑 Regular",
				"打单前请设置好备份联打印机":"打单前请设置好备份联打印机",
				"在此回复处理问题件":"在此回复处理问题件",
				"公式":"公式",
				"付款方式":"付款方式",
				"退返客户":"退返客户",
				"包裹丢失":"包裹丢失",
				"基本信息":"基本信息",
				"第":"第",
				"指定路线分类":"指定路线分类",
				"件数":"件数",
				"包装说明":"包装说明",
				"登记异常":"登记异常",
				"收件人信息":"收件人信息",
				"收件城市":"收件城市",
				"问题单号":"问题单号",
				"出口清关成功":"出口清关成功",
				"序号":"序号",
				"该运单无单件信息，无法下载":"该运单无单件信息，无法下载",
				"退回海外仓中": "退回海外仓中",
				"返回末端退货仓库":"返回末端退货仓库",
				"二次转寄上架":"二次转寄上架",
				"海外仓移出":"海外仓移出",
				"已二次转寄":"已二次转寄",
				"单号":"单号",
				"文件大小不能大于5MB":"文件大小不能大于5MB",
				"重置":"重置",
				"目的地":"目的地",
				"请选择货物状态":"请选择货物状态",
				"下载单件信息":"下载单件信息",
				"寄件国家":"寄件国家",
				"偏远":"偏远",
				"收件区县":"收件区县",
				"发生时间":"发生时间",
				"导出":"导出",
				"最新轨迹状态":"最新轨迹状态",
				"费用科目":"费用科目",
				"转单":"转单",
				"入口清关成功":"入口清关成功",
				"首次派送":"首次派送",
				"首次派送失败":"首次派送失败",
				"二次派送":"二次派送",
				"二次派送失败":"二次派送失败",
				"再次派送":"再次派送",
				"再次派送失败":"再次派送失败",
				"基础信息":"基础信息",
				"长":"长",
				"只能上传jpg/png/word/excel/pdf文件":"只能上传jpg/png/word/excel/pdf文件",
				"税金付款":"税金付款",
				"包裹销毁":"包裹销毁",
				"网点":"网点",
				"问题状态":"问题状态",
				"问题件":"问题件",
				"费用结算":"费用结算",
				"运单号码":"运单号码",
				"包装费":"包装费",
				"运单":"运单",
				"收件邮编":"收件邮编",
				"已签收":"已签收",
				"问题描述":"问题描述",
				"该运单无Invoice，无法下载":"该运单无Invoice，无法下载",
				"品牌":"品牌",
				"COD金额":"COD金额",
				"收件地址":"收件地址",
				"发货记录":"发货记录",
				"寄件地址":"寄件地址",
				"金额(本币)":"金额(本币)",
				"寄件邮编":"寄件邮编",
				"英文品名":"英文品名",
				"货物信息":"货物信息",
				"包裹到达分拣中心":"包裹到达分拣中心",
				"跟踪记录":"跟踪记录",
				"申报价值":"申报价值",
				"订单成功上传":"订单成功上传",
				"收件公司":"收件公司",
				"单件信息":"单件信息",
				"宽":"宽",
				"收件人":"收件人",
				"待出货":"待出货",
				"位置":"位置",
				"寄件城市":"寄件城市",
				"寄件人信息":"寄件人信息",
				"代收款":"代收款",
				"寄件日期":"寄件日期",
				"参考编号":"参考编号",
				"实重":"实重",
				"计抛方式":"计抛方式",
				"目的地信息":"目的地信息",
				"收费实重":"收费实重",
				"文件正在下载，请稍等！！！":"文件正在下载，请稍等！！！",
				"货物类型":"货物类型",
				"处理时间":"处理时间",
				"关包":"关包",
				"创建时间":"创建时间",
				"预报袋号":"预报袋号",
				"城市":"城市",
				"客户(可多选)":"客户(可多选)",
				"客户":'客户 ',
				'入口清关收货':'入口清关收货',
				'入口清关开始清关':'入口清关开始清关',
				'入口清关扣件不放行':'入口清关扣件不放行',
				'入口清关解除扣查':'入口清关解除扣查',
				'入口清关重新装箱':'入口清关重新装箱',
				'入口清关准备移交':'入口清关准备移交',
				'入口清关移交卡车':'入口清关移交卡车',
				'退件派送服务-已揽收':'退件派送服务-已揽收',
				'退件派送服务-分拣仓入库':'退件派送服务-分拣仓入库',
				'退件派送服务-分拣仓出库':'退件派送服务-分拣仓出库',
				'退件派送服务-移交':'退件派送服务-移交',
        },
        "OMS015":{
            "没有配置LABEL 输出方式":"没有配置LABEL 输出方式",
				"打印时间":"打印时间",
				"扫描打印失败！":"扫描打印失败！",
				"Invoice数量不能小于1":"Invoice数量不能小于1",
				"printScene:接口打印":"printScene:接口打印",
				"接口打印":"接口打印",
				"运单号码":"运单号码",
				"指定路线":"指定路线",
				"printScene:自定义打印":"printScene:自定义打印",
				"没有配置INVOICE自定义模板":"没有配置INVOICE自定义模板",
				"扫描单号不能为空":"扫描单号不能为空",
				"收件邮编":"收件邮编",
				"打印次数":"打印次数",
				"没有获取到子单数据":"没有获取到子单数据",
				"没有配置LABEL自定义模板":"没有配置LABEL自定义模板",
				"扫码打印为单票打印":"扫码打印为单票打印",
				"目的地":"目的地",
				"自定义打印":"自定义打印",
				"包装类型":"包装类型",
				"没有获取到label 地址":"没有获取到label 地址",
				"请仔细核对运单数据":"请仔细核对运单数据",
				"参考编号":"参考编号",
				"转单号码":"转单号码",
				"黑体 Regular":"黑体 Regular",
				"收费重":"收费重",
				"没有找到打印配置":"没有找到打印配置",
				"打印":"打印",
				"件数":"件数",
				"货物类型":"货物类型",
				"请输入":"请输入",
				"扫描单号":"扫描单号",
				"打单记录中不存在转单号，无法打印！":"打单记录中不存在转单号，无法打印！",
				"重置打印机":"重置打印机"
        },
        "OMS009":{
			"汇总票数":"汇总票数",
			"注意：":"注意：",
			"更多条件":"更多条件",
            "默认系统时间":"默认系统时间",
				"尾程":"尾程",
				"路线大类":"路线大类",
				"全部路线大类":"全部路线大类",
				"名称":"名称",
				"附加费包括":"附加费包括",
				"路线分类":"路线分类",
				"指定路线":"指定路线",
				"查询":"查询",
				"报价生效日期":"报价生效日期",
				"收件邮编":"收件邮编",
				"请选择目的地":"请选择目的地",
				"运费单价":"运费单价",
				"材积除以数":"材积除以数",
				"查询报价":"查询报价",
				"渠道发货要求和目的地国家的限制条件都会记录在备注中":"渠道发货要求和目的地国家的限制条件都会记录在备注中",
				"包装类型":"包装类型",
				"总运费":"总运费",
				"请选择包装类型":"请选择包装类型",
				"下单":"下单",
				"安检费":"安检费",
				"本币金额合计":"本币金额合计",
				"温馨提示":"温馨提示",
				"科目名称":"科目名称",
				"公式":"公式",
				"其他费用明细":"其他费用明细",
				"货物重量":"货物重量",
				"业务类型":"业务类型",
				"全部业务类型":"全部业务类型",
				"时间":"时间",
				"件数":"件数",
				"起运地":"起运地",
				"指定路线编码":"指定路线编码",
				"报价备注":"报价备注",
				"防疫物资附加费等杂费":"防疫物资附加费等杂费",
				"请输入货物重量":"请输入货物重量",
				"宽":"宽",
				"收件城市":"收件城市",
				"币别":"币别",
				"序号":"序号",
				"旺季附加费":"旺季附加费",
				"停用时间":"停用时间",
				"单价":"单价",
				"关闭":"关闭",
				"重置":"重置",
				"参考时效":"参考时效",
				"计算公式的计算结果":"计算公式的计算结果",
				"收件州省":"收件州省",
				"目的地":"目的地",
				"高":"高",
				"本币金额":"本币金额",
				"本币":"本币",
				"头程":"头程",
				"原币运费":"原币运费",
				"附加费用明细":"附加费用明细",
				"附加费":"附加费",
				"计算公式(头程+尾程)":"计算公式(头程+尾程)",
				"生效日期":"生效日期",
				"收费重":"收费重",
				"具体发货前请仔细查看备注":"具体发货前请仔细查看备注",
				"头程运费":"头程运费",
				"费用项":"费用项",
				"报价分段":"报价分段",
				"计算公式":"计算公式",
				"报价备注说明":"报价备注说明",
				"请选择起运地":"请选择起运地",
				"总费用":"总费用",
				"应收客服费等杂费":"应收客服费等杂费",
				"收件区县":"收件区县",
				"货物类型":"货物类型",
				"请输入货物类型":"请输入货物类型",
				"运费":"运费",
				"尾程运费":"尾程运费",
				"禁运货物类型":"禁运货物类型",
				"金额":"金额",
				"长":"长",
        },
        "BMS011":{
            "机场代码":"机场代码",
				"请输入收费重":"请输入收费重",
				"显示所在国家的所有偏远邮编":"显示所在国家的所有偏远邮编",
				"终止邮编":"终止邮编",
				"如输入邮编":"如输入邮编",
				"非偏远":"非偏远",
				"含燃油":"含燃油",
				"匹配规则":"匹配规则",
				"指定路线":"指定路线",
				"查询":"查询",
				"收件邮编":"收件邮编",
				"请选择目的地":"请选择目的地",
				"偏远邮编范围为":"偏远邮编范围为",
				"其次匹配城市":"其次匹配城市",
				"未查询到偏远信息!":"未查询到偏远信息!",
				"可正常匹配":"可正常匹配",
				"包装类型":"包装类型",
				"如输入城市为":"如输入城市为",
				"机场代码查询":"机场代码查询",
				"开始邮编":"开始邮编",
				"收件邮编与收件城市二者必填其一":"收件邮编与收件城市二者必填其一",
				"请选择包装类型":"请选择包装类型",
				"操作中心":"操作中心",
				"可匹配":"可匹配",
				"请输入收件邮编或者收件国家":"请输入收件邮编或者收件国家",
				"邮编类型":"邮编类型",
				"不能匹配":"不能匹配",
				"重量":"重量",
				"城市都为空时":"城市都为空时",
				"标准邮编数据":"标准邮编数据",
				"支持子邮编匹配":"支持子邮编匹配",
				"邮编":"邮编",
				"以下查询结果为":"以下查询结果为",
				"偏远费查询":"偏远费查询",
				"州省编号":"州省编号",
				"收件城市":"收件城市",
				"显示所在国家的所有邮编":"显示所在国家的所有邮编",
				"输入邮编前几位在偏远邮编范围内时":"输入邮编前几位在偏远邮编范围内时",
				"支持城市右模糊匹配":"支持城市右模糊匹配",
				"单价":"单价",
				"国家编号":"国家编号",
				"输入邮编前几位在邮编范围内时":"输入邮编前几位在邮编范围内时",
				"查询结果":"查询结果",
				"如输入邮编为":"如输入邮编为",
				"偏远城市为":"偏远城市为",
				"重置":"重置",
				"偏远费":"偏远费",
				"国家":"国家",
				"目的地":"目的地",
				"最高价格":"最高价格",
				"请选择指定路线":"请选择指定路线",
				"偏远查询":"偏远查询",
				"收费重":"收费重",
				"偏远":"偏远",
				"国家简码":"国家简码",
				"州省":"州省",
				"邮编范围为":"邮编范围为",
				"邮编查询":"邮编查询",
				"计算公式":"计算公式",
				"优先邮编匹配":"优先邮编匹配",
				"起始邮编":"起始邮编",
				"州/省":"州/省",
				"如输入邮编和城市都为空时":"如输入邮编和城市都为空时",
				"时":"时",
				"最低价格":"最低价格",
				"城市":"城市"
        },
        "OMS011":{
            "扫码确认支付后":"扫码确认支付后",
				"模式":"模式",
				"已审余额":"已审余额",
				"状态":"状态",
				"二维码产生异常！！！":"二维码产生异常！！！",
				"微信支付":"微信支付",
				"立即充值":"立即充值",
				"支付方式":"支付方式",
				"审核时间":"审核时间",
				"微信扫码支付":"微信扫码支付",
				"查询":"查询",
				"尝试重连：第几次":"尝试重连：第几次",
				"收款备注":"收款备注",
				"账单备注":"账单备注",
				"请等待页面跳转":"请等待页面跳转",
				"业务日期":"业务日期",
				"温馨提示":"温馨提示",
				"当前余额":"当前余额",
				"请选择审核时间！":"请选择审核时间！",
				"支付宝":"支付宝",
				"正常":"正常",
				"已锁机":"已锁机",
				"发生金额":"发生金额",
				"2.充值成功后，系统余额自动增加，如系统余额足够，可正常出货。":"2.充值成功后，系统余额自动增加，如系统余额足够，可正常出货。",
				"接到了":"接到了",
				"币别":"币别",
				",支付金额：￥":",支付金额：￥",
				"收款":"收款",
				"温馨提示：":"温馨提示：",
				"金额小于0":"金额小于0",
				"可用余额":"可用余额",
				"待审收款":"待审收款",
				"3.如充值异常(如已扣款，系统余额未增加情况),请联系公司财务。":"3.如充值异常(如已扣款，系统余额未增加情况),请联系公司财务。",
				"客户余额明细":"客户余额明细",
				"到账金额":"到账金额",
				"本期金额":"本期金额",
				"所有币别":"所有币别",
				"重连失败":"重连失败",
				"重连成功，重新发起心跳，并登录websocked":"重连成功，重新发起心跳，并登录websocked",
				"支付成功":"支付成功",
				"1.充值收取0.03%手续费(最低3元)，单次充值金额不得低于3元。手续费在充值成功后自动扣除。":"1.充值收取0.03%手续费(最低3元)，单次充值金额不得低于3元。手续费在充值成功后自动扣除。",
				"余额":"余额",
				"付款":"付款",
				"充值金额":"充值金额",
				"账单号码":"账单号码",
				"导出":"导出",
				"当前只支持人民币":"当前只支持人民币",
				"手续费":"手续费",
				"支付宝扫码支付":"支付宝扫码支付",
				"待审金额":"待审金额",
				"账单":"账单",
				"上期余额":"上期余额"
        },
        "OMS0111":{
            "寄件日期":"寄件日期",
				"币别":"币别",
				"转本币金额":"转本币金额",
				"请选择日期":"请选择日期",
				"全部":"全部",
				"结算状态":"结算状态",
				"运单号码":"运单号码",
				"汇率":"汇率",
				"待审帐单明细":"待审帐单明细",
				"待审核":"待审核",
				"查询":"查询",
				"科目":"科目",
				"待审收款":"待审收款",
				"已生成帐单未审核":"已生成帐单未审核",
				"日期":"日期",
				"发生日期":"发生日期",
				"可结算":"可结算",
				"待审金额":"待审金额",
				"未生成帐单":"未生成帐单",
				"金额":"金额"
        },
        "OMS016":{
            "币别":"币别",
					"寄件日期三天后为补收费用":"寄件日期三天后为补收费用",
					"账单明细":"账单明细",
					"备注":"备注",
					"运单号码":"运单号码",
					"指定路线":"指定路线",
					"查询":"查询",
					"切换纵向账单":"切换纵向账单",
					"重置":"重置",
					"目的地":"目的地",
					"帐单日期":"帐单日期",
					"只查补收费用":"只查补收费用",
					"寄件日期":"寄件日期",
					"参考编号":"参考编号",
					"补收":"补收",
					"实重":"实重",
					"账单日期":"账单日期",
					"转单号码":"转单号码",
					"收费重":"收费重",
					"目的地信息":"目的地信息",
					"科目名称":"科目名称",
					"帐单号码":"帐单号码",
					"计算公式":"计算公式",
					"未找到对应的账单格式，请联系管理员":"未找到对应的账单格式，请联系管理员",
					"客户账单":"客户账单",
					"其他费用":"其他费用",
					"材重":"材重",
					"切换横向账单":"切换横向账单",
					"件数":"件数",
					"货物类型":"货物类型",
					"导出账单":"导出账单",
					"运费":"运费",
					"应收费用":"应收费用",
					"请选择单条数据进行查看":"请选择单条数据进行查看",
					"金额":"金额",
					"单票合计":"单票合计",
					"收件人":"收件人"
        },
        "OMS012":{
            "扫码确认支付后":"扫码确认支付后",
					"二维码产生异常！！！":"二维码产生异常！！！",
					"微信支付":"微信支付",
					"支付方式":"支付方式",
					"微信扫码支付":"微信扫码支付",
					"查询":"查询",
					"尝试重连：第几次":"尝试重连：第几次",
					"总金额":"总金额",
					"账单信息查询错误！":"账单信息查询错误！",
					"请等待页面跳转":"请等待页面跳转",
					"付款金额":"付款金额",
					"温馨提示":"温馨提示",
					"账单已全部核销，无需支付":"账单已全部核销，无需支付",
					"未找到对应的账单格式，请联系管理员":"未找到对应的账单格式，请联系管理员",
					"客户账单":"客户账单",
					"总笔数":"总笔数",
					"支付宝":"支付宝",
					"2.充值成功后，系统余额自动增加，如系统余额足够，可正常出货。":"2.充值成功后，系统余额自动增加，如系统余额足够，可正常出货。",
					"接到了":"接到了",
					"币别":"币别",
					"请选择需要导出的账单数据！":"请选择需要导出的账单数据！",
					",支付金额：￥":",支付金额：￥",
					"总件数":"总件数",
					"温馨提示：":"温馨提示：",
					"待付款金额":"待付款金额",
					"金额小于0":"金额小于0",
					"重置":"重置",
					"导出总账单":"导出总账单",
					"创建导出任务，请稍后在导出列表中下载！":"创建导出任务，请稍后在导出列表中下载！",
					"3.如充值异常(如已扣款，系统余额未增加情况),请联系公司财务。":"3.如充值异常(如已扣款，系统余额未增加情况),请联系公司财务。",
					"只支持人民币(CNY)的在线付款，其他币别自动忽略，是否继续":"只支持人民币(CNY)的在线付款，其他币别自动忽略，是否继续",
					"确定":"确定",
					"创建导出任务失败:":"创建导出任务失败:",
					"导出合并格式":"导出合并格式",
					"账单日期":"账单日期",
					"总重量":"总重量",
					"提示":"提示",
					"重连失败":"重连失败",
					"重连成功，重新发起心跳，并登录websocked":"重连成功，重新发起心跳，并登录websocked",
					"支付成功":"支付成功",
					"1.充值收取0.03%手续费(最低3元)，单次充值金额不得低于3元。手续费在充值成功后自动扣除。":"1.充值收取0.03%手续费(最低3元)，单次充值金额不得低于3元。手续费在充值成功后自动扣除。",
					"付款":"付款",
					"账单号码":"账单号码",
					"未设置默认导出格式,请联系管理员":"未设置默认导出格式,请联系管理员",
					"当前只支持人民币":"当前只支持人民币",
					"手续费":"手续费",
					"导出账单":"导出账单",
					"取消":"取消",
					"账单付款":"账单付款",
					"请至少选择一行数据！":"请至少选择一行数据！",
					"请选择同一币别的帐单":"请选择同一币别的帐单",
					"总票数":"总票数",
					"支付宝扫码支付":"支付宝扫码支付",
					"请选择单条数据进行查看":"请选择单条数据进行查看"
        },
        "OMS0121":{
            "寄件日期":"寄件日期",
					"参考编号":"参考编号",
					"币别":"币别",
					"创建导出任务失败:":"创建导出任务失败:",
					"转单号码":"转单号码",
					"账单日期":"账单日期",
					"收费重":"收费重",
					"目的地信息":"目的地信息",
					"科目名称":"科目名称",
					"公式":"公式",
					"备注":"备注",
					"运单号码":"运单号码",
					"未找到对应的账单格式，请联系管理员":"未找到对应的账单格式，请联系管理员",
					"客户账单":"客户账单",
					"指定路线":"指定路线",
					"件数":"件数",
					"账单号码":"账单号码",
					"账单数据异常！":"账单数据异常！",
					"导出账单":"导出账单",
					"创建导出任务，请稍后在导出列表中下载！":"创建导出任务，请稍后在导出列表中下载！",
					"金额":"金额"
        },
        "OMS0122":{
            "寄件日期":"寄件日期",
					"币别":"币别",
					"目的地编码":"目的地编码",
					"账单日期":"账单日期",
					"收费重":"收费重",
					"科目名称":"科目名称",
					"包装":"包装",
					"备注":"备注",
					"指定路线":"指定路线",
					"账单号码":"账单号码",
					"目的地":"目的地",
					"包号":"包号",
					"金额":"金额"
        },
        "apiauth":{
            "等各大电商":"等各大电商",
				"订单预报推送":"订单预报推送",
				"各类特殊校验接口":"各类特殊校验接口",
				"大快递打单":"大快递打单",
				"对接":"对接",
				"当前未授权":"当前未授权",
				"授权成功！":"授权成功！",
				"应用场景":"应用场景",
				"启用订单授权与启用打单授权必勾其一":"启用订单授权与启用打单授权必勾其一",
				"自有系统对接":"自有系统对接",
				"订单授权":"订单授权",
				"密钥":"密钥",
				"含特殊业务":"含特殊业务",
				"即时获取转单及":"即时获取转单及",
				"如马帮":"如马帮",
				"通途":"通途",
				"打单授权":"打单授权",
				"店小蜜":"店小蜜",
				"帐号":"帐号",
				"当前已授权":"当前已授权",
				"交易助手":"交易助手",
				"芒果店长":"芒果店长",
				"电商小包订单即时获取转单":"电商小包订单即时获取转单",
				"获取授权信息":"获取授权信息",
				"速猫":"速猫",
				"电商":"电商"
        },
        "authorization":{
            "会显示授权成功":"会显示授权成功",
				"结束时间不能为空":"结束时间不能为空",
				"获取授权时":"获取授权时",
				"填写店铺昵称和授权码":"填写店铺昵称和授权码",
				"全部":"全部",
				"您真的要停用当前店铺<":"您真的要停用当前店铺<",
				"寄件人信息用于":"寄件人信息用于",
				"保存":"保存",
				"省份":"省份",
				"前往授权":"前往授权",
				"查询授权信息异常":"查询授权信息异常",
				"新增Edi异常":"新增Edi异常",
				"地址":"地址",
				"结束时间":"结束时间",
				"自动下载":"自动下载",
				"按单号下载":"按单号下载",
				"失效时间":"失效时间",
				"授权码":"授权码",
				"修改授权成功":"修改授权成功",
				"注意":"注意",
				">吗？":">吗？",
				"个订单":"个订单",
				"同步订单异常":"同步订单异常",
				"禁止填写中文或特殊字符":"禁止填写中文或特殊字符",
				"重新授权":"重新授权",
				"上次下载时间":"上次下载时间",
				"按时间下载":"按时间下载",
				"新增敦煌网授权":"新增敦煌网授权",
				"平台类型":"平台类型",
				"在授权页面":"在授权页面",
				"同步订单成功":"同步订单成功",
				"单号不能为空":"单号不能为空",
				"授权":"授权",
				"店铺昵称禁止填写中文":"店铺昵称禁止填写中文",
				"邮编":"邮编",
				"新增授权":"新增授权",
				"授权异常":"授权异常",
				"修改启用状态异常":"修改启用状态异常",
				"开始时间":"开始时间",
				"速卖通":"速卖通",
				"查询API列表异常":"查询API列表异常",
				"仅对速卖通订单生效":"仅对速卖通订单生效",
				"公司名称":"公司名称",
				"电话":"电话",
				"停用":"停用",
				"按钮":"按钮",
				"拉取方式":"拉取方式",
				"开始时间不能为空":"开始时间不能为空",
				"修改授权异常":"修改授权异常",
				"多个用回车隔开":"多个用回车隔开",
				"人工下载":"人工下载",
				"关闭":"关闭",
				"启用":"启用",
				"同步订单":"同步订单",
				"官方指定买家授权网址":"官方指定买家授权网址",
				"不支持的平台":"不支持的平台",
				"请填写店铺昵称":"请填写店铺昵称",
				"跳转打开成功！":"跳转打开成功！",
				"修改授权":"修改授权",
				"电商平台":"电商平台",
				"下载订单":"下载订单",
				"最多支持":"最多支持",
				"请输入订单号码":"请输入订单号码",
				"新增":"新增",
				"确定":"确定",
				"授权信息":"授权信息",
				"店铺昵称":"店铺昵称",
				"修改敦煌网授权":"修改敦煌网授权",
				"提示":"提示",
				"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
				"稍等片刻":"稍等片刻",
				"下载方式":"下载方式",
				"允许访问":"允许访问",
				"获取授权时间":"获取授权时间",
				"点击":"点击",
				"已向服务器发送下载请求，请点击确定并耐心等待3-5分钟！下载的订单会放入草稿订单中,请前往草稿订单查看！":"已向服务器发送下载请求，请点击确定并耐心等待3-5分钟！下载的订单会放入草稿订单中,请前往草稿订单查看！",
				"打印":"打印",
				"联络人姓名":"联络人姓名",
				"已停用，无法进行下载":"已停用，无法进行下载",
				"设置寄件人信息":"设置寄件人信息",
				"授权时间":"授权时间",
				"请输入":"请输入",
				"取消":"取消",
				"只有速卖通才可以进行单号下载":"只有速卖通才可以进行单号下载",
				"您真的要启用当前店铺<":"您真的要启用当前店铺<",
				"下载订单异常":"下载订单异常",
				"城市":"城市",
				">吗？（店铺停用后，将不会自动下载订单，但会继续回传单号）":">吗？（店铺停用后，将不会自动下载订单，但会继续回传单号）",
				"将访问":"将访问"
        },
        "downloadthelog":{
            "正在保存":"正在保存",
				"保存异常":"保存异常",
				"未知异常":"未知异常",
				"创建任务":"创建任务",
				"状态":"状态",
				"保存订单数":"保存订单数",
				"正在接收报文":"正在接收报文",
				"下载方式":"下载方式",
				"解析完成时间":"解析完成时间",
				"下载备注":"下载备注",
				"解析订单数":"解析订单数",
				"解析报文异常":"解析报文异常",
				"人工下载":"人工下载",
				"解析完成":"解析完成",
				"保存完成":"保存完成",
				"保存完成时间":"保存完成时间",
				"创建时间":"创建时间",
				"订单数据条件":"订单数据条件",
				"接收完成时间":"接收完成时间",
				"结束时间":"结束时间",
				"正在解析报文":"正在解析报文",
				"接收报文异常":"接收报文异常",
				"自动下载":"自动下载"
        },
        "OMS017":{
            "确定要删除吗？":"确定要删除吗？",
            "修改":"修改",
            "联系人":"联系人",
            "全部":"全部",
            "指定路线":"指定路线",
            "已取消":"已取消",
            "保存":"保存",
            "联系电话":"联系电话",
            "修改异常":"修改异常",
            "新增取件信息":"新增取件信息",
            "申请日期":"申请日期",
            "请先完善基础信息！":"请先完善基础信息！",
            "取件公司":"取件公司",
            "预约取件时间":"预约取件时间",
            "申请":"申请",
            "修改取件信息":"修改取件信息",
            "删除成功！":"删除成功！",
            "删除异常":"删除异常",
            "重量":"重量",
            "货物信息":"货物信息",
            "件数":"件数",
            "司机电话":"司机电话",
            "状态为‘已取件’或者‘已取消’的数据不允许修改":"状态为‘已取件’或者‘已取消’的数据不允许修改",
            "已取件":"已取件",
            "取件状态":"取件状态",
            "车牌号":"车牌号",
            "修改成功！":"修改成功！",
            "取件地址":"取件地址",
            "注意事项":"注意事项",
            "司机":"司机",
            "请选择取件状态为’待取件‘的数据":"请选择取件状态为’待取件‘的数据",
            "关闭":"关闭",
            "销售员":"销售员",
            "待取件":"待取件",
            "取件申请":"取件申请",
            "预约备注":"预约备注",
            "请选择一行数据":"请选择一行数据",
            "背景色设置":"背景色设置",
            "跟单员":"跟单员",
            "相等":"相等",
            "客户信息":"客户信息",
            "确定":"确定",
            "提示":"提示",
            "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
            "每行高亮":"每行高亮",
            "任务单号":"任务单号",
            "添加成功！":"添加成功！",
            "报关方式":"报关方式",
            "导出":"导出",
            "体积":"体积",
            "请输入":"请输入",
            "取消":"取消",
            "添加异常":"添加异常"
        },
        "outtrack":{
            "寄件日期":"寄件日期",
					"参考编号":"参考编号",
					"地点":"地点",
					"转单号码":"转单号码",
					"轨迹信息":"轨迹信息",
					"运单号码":"运单号码",
					"指定路线":"指定路线",
					"参考编码":"参考编码",
					"追踪结果":"追踪结果",
					"查询单号必填":"查询单号必填",
					"查询":"查询",
					"时间":"时间",
					"跟踪记录":"跟踪记录",
					"目的地":"目的地",
					"清空":"清空",
					"无此单号<":"无此单号<",
					"订单信息":"订单信息",
					"页面地址有误":"页面地址有误"
        },
        "OMS0081":{
            "只能上传jpg/png/word/excel/pdf文件":"只能上传jpg/png/word/excel/pdf文件",
					"点击上传附件":"点击上传附件",
					"问题状态":"问题状态",
					"登记人":"登记人",
					"返回列表":"返回列表",
					"运单号码":"运单号码",
					"文件大小不能大于5MB":"文件大小不能大于5MB",
					"指定路线":"指定路线",
					"沟通记录":"沟通记录",
					"回复成功！":"回复成功！",
					"处理结果":"处理结果",
					"目的地":"目的地",
					"问题描述":"问题描述",
					"处理记录":"处理记录",
					"订单信息":"订单信息",
					"包装类型":"包装类型",
					"寄件日期":"寄件日期",
					"附件":"附件",
					"获取文件路径异常":"获取文件路径异常",
					"参考编号":"参考编号",
					"只允许上传一个附件":"只允许上传一个附件",
					"处理意见":"处理意见",
					"回复":"回复",
					"登记时间":"登记时间",
					"转单号码":"转单号码",
					"大小不能超过":"大小不能超过",
					"问题类型":"问题类型",
					"附件格式为":"附件格式为",
					"件数":"件数",
					"回复异常":"回复异常",
					"货物类型":"货物类型",
					"问题信息":"问题信息",
					"请输入":"请输入"
        },
        "OMS0071":{
            "省":"省",
				"税金付款":"税金付款",
				"海关编码":"海关编码",
				"净重":"净重",
				"寄件信息":"寄件信息",
				"费用结算":"费用结算",
				"原产地":"原产地",
				"运单号码":"运单号码",
				"指定路线":"指定路线",
				"寄件州":"寄件州",
				"包装费":"包装费",
				"收件邮编":"收件邮编",
				"寄件电话":"寄件电话",
				"总价":"总价",
				"收件信息":"收件信息",
				"包装类型":"包装类型",
				"操作":"操作",
				"信息":"信息",
				"包装项目":"包装项目",
				"收件地址":"收件地址",
				"到付款":"到付款",
				"寄件地址":"寄件地址",
				"付款方式":"付款方式",
				"寄件人":"寄件人",
				"注意":"注意",
				"基本信息":"基本信息",
				"寄件邮编":"寄件邮编",
				"收件统编":"收件统编",
				"英文品名":"英文品名",
				"货物信息":"货物信息",
				"除以数":"除以数",
				"件数":"件数",
				"申报价值":"申报价值",
				"包装说明":"包装说明",
				"收件公司":"收件公司",
				"单票计抛规则":"单票计抛规则",
				"单件信息":"单件信息",
				"宽":"宽",
				"收件人":"收件人",
				"收件城市":"收件城市",
				"币别":"币别",
				"序号":"序号",
				"单价":"单价",
				"备注":"备注",
				"寄件城市":"寄件城市",
				"该运单无单件信息":"该运单无单件信息",
				"删除":"删除",
				"关闭":"关闭",
				"运单信息":"运单信息",
				"数量":"数量",
				"目的地":"目的地",
				"寄件公司":"寄件公司",
				"高":"高",
				"收件州":"收件州",
				"代收款":"代收款",
				"毛重":"毛重",
				"寄件日期":"寄件日期",
				"参考编号":"参考编号",
				"寄件国家":"寄件国家",
				"实重":"实重",
				"单票进位规则":"单票进位规则",
				"收费重":"收费重",
				"收件国家":"收件国家",
				"材重":"材重",
				"收件电话":"收件电话",
				"报关方式":"报关方式",
				"单件进位规则":"单件进位规则",
				"货物类型":"货物类型",
				"导出":"导出",
				"中文品名":"中文品名",
				"以下录入的都为单件信息":"以下录入的都为单件信息",
				"长":"长"
        },
        "OMS0181":{
            "历史日志":"历史日志",
				"成功":"成功",
				"运单修改成功":"运单修改成功",
				"状态":"状态",
				"导入中":"导入中",
				"上传失败":"上传失败",
				"导入文件不能超过10MB":"导入文件不能超过10MB",
				"文件大小不超过":"文件大小不超过",
				"运单号码":"运单号码",
				"验证中":"验证中",
				"导入时":"导入时",
				"批次号":"批次号",
				"验证失败":"验证失败",
				"解析中":"解析中",
				"请选择导入模版！":"请选择导入模版！",
				"失败":"失败",
				"解析失败":"解析失败",
				"导入":"导入",
				"请确认导入模板中表头的完整性":"请确认导入模板中表头的完整性",
				"导入历史日志":"导入历史日志",
				"总行数":"总行数",
				"请选择模版！":"请选择模版！",
				"导入时间":"导入时间",
				"模版下载":"模版下载",
				"导入文件格式支持":"导入文件格式支持",
				"订单导入修改标准模版":"订单导入修改标准模版",
				"错误说明":"错误说明",
				"导入文件":"导入文件",
				"请输入":"请输入",
				"文件下载":"文件下载",
				"上传中":"上传中",
				"行号":"行号",
				"错误行数":"错误行数",
				"导入模版":"导入模版",
				"新增模板":"新增模板"
        },
        "OMS0041":{
            "省":"省",
				"税金付款":"税金付款",
				"海关编码":"海关编码",
				"净重":"净重",
				"寄件信息":"寄件信息",
				"“总价”列内容格式不正确，限制导入！":"“总价”列内容格式不正确，限制导入！",
				"费用结算":"费用结算",
				"请选择代收币别!":"请选择代收币别!",
				"原产地":"原产地",
				"运单号码":"运单号码",
				"指定路线":"指定路线",
				"寄件州":"寄件州",
				"保存":"保存",
				"收件邮编":"收件邮编",
				"寄件电话":"寄件电话",
				"订单列表修改-Invoice导入模版":"订单列表修改-Invoice导入模版",
				"上传成功！":"上传成功！",
				"总价":"总价",
				"“单价”列内容格式不正确，限制导入！":"“单价”列内容格式不正确，限制导入！",
				"“净重”列内容格式不正确，限制导入！":"“净重”列内容格式不正确，限制导入！",
				"收件信息":"收件信息",
				"包装类型":"包装类型",
				"操作":"操作",
				"信息":"信息",
				"收件地址":"收件地址",
				"到付款":"到付款",
				"寄件地址":"寄件地址",
				"导入模板":"导入模板",
				"付款方式":"付款方式",
				"寄件人":"寄件人",
				"基本信息":"基本信息",
				"寄件邮编":"寄件邮编",
				"“毛重”列内容格式不正确，限制导入！":"“毛重”列内容格式不正确，限制导入！",
				"英文品名":"英文品名",
				"货物信息":"货物信息",
				"件数":"件数",
				"申报价值":"申报价值",
				"收件公司":"收件公司",
				"修改成功！":"修改成功！",
				"收件人":"收件人",
				"收件城市":"收件城市",
				"文件格式不正确，请上传正确的Excel文件":"文件格式不正确，请上传正确的Excel文件",
				"单价":"单价",
				"第一步":"第一步",
				"备注":"备注",
				"寄件城市":"寄件城市",
				"删除":"删除",
				"文件内容为空或格式不正确，请下载模版并填写导入内容！":"文件内容为空或格式不正确，请下载模版并填写导入内容！",
				"运单号码<":"运单号码<",
				"数量":"数量",
				"目的地":"目的地",
				"寄件公司":"寄件公司",
				"下载":"下载",
				"收件州":"收件州",
				"第二步":"第二步",
				"代收款":"代收款",
				"毛重":"毛重",
				"上传":"上传",
				"寄件日期":"寄件日期",
				"参考编号":"参考编号",
				"寄件国家":"寄件国家",
				"保存异常":"保存异常",
				"导入":"导入",
				"确定":"确定",
				"实重":"实重",
				"提示":"提示",
				"收费重":"收费重",
				"请选择到付币别!":"请选择到付币别!",
				"请上传附件！":"请上传附件！",
				"收件国家":"收件国家",
				">不为待审核，限制修改!":">不为待审核，限制修改!",
				"材重":"材重",
				"收件电话":"收件电话",
				"报关方式":"报关方式",
				"“数量”列内容格式不正确，限制导入！":"“数量”列内容格式不正确，限制导入！",
				"模板":"模板",
				"货物类型":"货物类型",
				"请输入":"请输入",
				"中文品名":"中文品名",
				"取消":"取消",
				"确定删除此行吗？":"确定删除此行吗？"
        },
        "OMS004":{
            "修改项目":"修改项目",
				"状态":"状态",
				"净重":"净重",
				"确定要审核选中订单吗？":"确定要审核选中订单吗？",
				"原产地":"原产地",
				"取消成功！":"取消成功！",
				"我是标题":"我是标题",
				"选择的订单中没有有效的PDF地址":"选择的订单中没有有效的PDF地址",
				"撤销审核成功！":"撤销审核成功！",
				"总价":"总价",
				"材积除以数":"材积除以数",
				"文件名":"文件名",
				"客户重量":"客户重量",
				"操作":"操作",
				"是否取消订单":"是否取消订单",
				"收件人名":"收件人名",
				"撤销审核异常":"撤销审核异常",
				"请至少选择一笔推送状态为推送成功的订单数据":"请至少选择一笔推送状态为推送成功的订单数据",
				"取消订单":"取消订单",
				"订单已经打单，不可重复打单！":"订单已经打单，不可重复打单！",
				"，确定撤销审核吗？":"，确定撤销审核吗？",
				"运单标签":"运单标签",
				"币别":"币别",
				"注意事项":"注意事项",
				"对应栏位<包装类型>为空，不能进行代理打单，请完善订单数据！":"对应栏位<包装类型>为空，不能进行代理打单，请完善订单数据！",
				"EDI_LABEL打印机":"EDI_LABEL打印机",
				"数量":"数量",
				"收件州省":"收件州省",
				"未选择数据，请选择后再打印":"未选择数据，请选择后再打印",
				"取件申请":"取件申请",
				"格式":"格式",
				"转单号码":"转单号码",
				"客户重量必须>=0.001":"客户重量必须>=0.001",
				"请选择至少一行\"待审核且不为推送中\"数据":"请选择至少一行\"待审核且不为推送中\"数据",
				"材重":"材重",
				"报关方式":"报关方式",
				"请勾选至少一行数据":"请勾选至少一行数据",
				"笔，取消失败":"笔，取消失败",
				"请输入":"请输入",
				"请选择报关方式":"请选择报关方式",
				"请选择一个客户后再进行全部收货":"请选择一个客户后再进行全部收货",
				"取消":"取消",
				"件数必须大于0且预报重量必须大于0！":"件数必须大于0且预报重量必须大于0！",
				"件数必须>=1":"件数必须>=1",
				"海关编码":"海关编码",
				"全部":"全部",
				"是否保存":"是否保存",
				"已取消":"已取消",
				"查询":"查询",
				"联系电话":"联系电话",
				"未获取到对应数据":"未获取到对应数据",
				"对应栏位<件数>为空，不能进行代理打单，请完善订单数据！":"对应栏位<件数>为空，不能进行代理打单，请完善订单数据！",
				"收费材重":"收费材重",
				"取件公司":"取件公司",
				"请选择包装类型":"请选择包装类型",
				"到付款":"到付款",
				"取消异常":"取消异常",
				"已出货":"已出货",
				"审核":"审核",
				"最多不能超过":"最多不能超过",
				"取件地址":"取件地址",
				"备注":"备注",
				"子单生成规则未设置，请重新设置":"子单生成规则未设置，请重新设置",
				"订单日期不能为空":"订单日期不能为空",
				"关闭":"关闭",
				"取消原因":"取消原因",
				"printScene:EDI_LABEL打印机":"printScene:EDI_LABEL打印机",
				"下载":"下载",
				"高":"高",
				"请选择一行数据":"请选择一行数据",
				"预报重量":"预报重量",
				"请选择至少一行数据":"请选择至少一行数据",
				"已提交收货请求！":"已提交收货请求！",
				"确定":"确定",
				"面单打印":"面单打印",
				"收费重":"收费重",
				"收货标签":"收货标签",
				"嘉里":"嘉里",
				"您选取":"您选取",
				"笔，无预报":"笔，无预报",
				"添加成功！":"添加成功！",
				"您当前选中订单":"您当前选中订单",
				"收件电话":"收件电话",
				"批量修改":"批量修改",
				"材重合计":"材重合计",
				"体积":"体积",
				"中文品名":"中文品名",
				"修改":"修改",
				"该订单无Invoice，无法下载":"该订单无Invoice，无法下载",
				"指定路线":"指定路线",
				"订单预报":"订单预报",
				"保存":"保存",
				"流水号位数不够，请重新设置":"流水号位数不够，请重新设置",
				"笔":"笔",
				"实重合计":"实重合计",
				"创建人":"创建人",
				"请勾选至少一行状态为待收货并未申请的数据":"请勾选至少一行状态为待收货并未申请的数据",
				"寄件时间":"寄件时间",
				"收费重合计":"收费重合计",
				"包装费合计":"包装费合计",
				"包装类型":"包装类型",
				"收货成功":"收货成功",
				"微软雅黑 Regular":"微软雅黑 Regular",
				", 失败笔数：":", 失败笔数：",
				"请选择至少一行\"待收货\"数据":"请选择至少一行\"待收货\"数据",
				"付款方式":"付款方式",
				"注意":"注意",
				"基本信息":"基本信息",
				"的订单共":"的订单共",
				"对应栏位<预报重>为空，不能进行代理打单，请完善订单数据！":"对应栏位<预报重>为空，不能进行代理打单，请完善订单数据！",
				"标签打印":"标签打印",
				"件数":"件数",
				"包装说明":"包装说明",
				"收件人信息":"收件人信息",
				"收件城市":"收件城市",
				"全部订单":"全部订单",
				"查询订单是否打单失败！":"查询订单是否打单失败！",
				"取消成功":"取消成功",
				"序号":"序号",
				"笔，可取消审核笔数":"笔，可取消审核笔数",
				"已收货":"已收货",
				"笔，可取消审核数":"笔，可取消审核数",
				"对应栏位<货物类型>为空，不能进行代理打单，请完善订单数据！":"对应栏位<货物类型>为空，不能进行代理打单，请完善订单数据！",
				"选择的订单中没有推送成功到POS的订单":"选择的订单中没有推送成功到POS的订单",
				"重置":"重置",
				"目的地":"目的地",
				"审核异常":"审核异常",
				"下载单件信息":"下载单件信息",
				"客户信息":"客户信息",
				"请选择需要打印的数据":"请选择需要打印的数据",
				"提示":"提示",
				"偏远":"偏远",
				"个字符":"个字符",
				"笔，已收货":"笔，已收货",
				"提交审核请求成功！":"提交审核请求成功！",
				"打印":"打印",
				"导出":"导出",
				"添加异常":"添加异常",
				"全部收货完成！":"全部收货完成！",
				"基础信息":"基础信息",
				"长":"长",
				"税金付款":"税金付款",
				"联系人":"联系人",
				"待收货":"待收货",
				"费用结算":"费用结算",
				"运单号码":"运单号码",
				"对应栏位<指定路线>为空，不能进行代理打单，请完善订单数据！":"对应栏位<指定路线>为空，不能进行代理打单，请完善订单数据！",
				"待审核":"待审核",
				"订单转单状态为“待转单”才允许代理打单！":"订单转单状态为“待转单”才允许代理打单！",
				"包装费":"包装费",
				"没有配置“嘉里-末端”面单的打印机，请先进行打印设置":"没有配置“嘉里-末端”面单的打印机，请先进行打印设置",
				"收件邮编":"收件邮编",
				"已签收":"已签收",
				"标准面单":"标准面单",
				"新增取件信息":"新增取件信息",
				"发票标签":"发票标签",
				"越南面单":"越南面单",
				"预约取件时间":"预约取件时间",
				"收件地址":"收件地址",
				"请先修改数据":"请先修改数据",
				"收件统编":"收件统编",
				"英文品名":"英文品名",
				"重量":"重量",
				"货物信息":"货物信息",
				"订单日期":"订单日期",
				"对应栏位<目的地>为空，不能进行代理打单，请完善订单数据！":"对应栏位<目的地>为空，不能进行代理打单，请完善订单数据！",
				"申报价值":"申报价值",
				"打印完成":"打印完成",
				"收件公司":"收件公司",
				"订单状态为“待收货”才允许代理打单！":"订单状态为“待收货”才允许代理打单！",
				"宽":"宽",
				"代理打单":"代理打单",
				"请先完善信息！":"请先完善信息！",
				"预览":"预览",
				"预约备注":"预约备注",
				"请选择指定路线":"请选择指定路线",
				"请选择至少一行\"待审核\"数据":"请选择至少一行\"待审核\"数据",
				"代收款":"代收款",
				"参考编号":"参考编号",
				"请勾选至少一行待审核、待收货数据":"请勾选至少一行待审核、待收货数据",
				"实重":"实重",
				"收货成功！":"收货成功！",
				"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
				"计抛方式":"计抛方式",
				"目的地信息":"目的地信息",
				"香港面单":"香港面单",
				"收件国家":"收件国家",
				"收费实重":"收费实重",
				"货物类型":"货物类型",
				"请选择至少一行待收货数据":"请选择至少一行待收货数据",
				"请选择货物类型":"请选择货物类型",
				"收货异常":"收货异常",
				"创建时间":"创建时间",
				"批量修改成功，成功笔数：":"批量修改成功，成功笔数："
        },
        "OMS0042":{
            "省":"省",
				"税金付款":"税金付款",
				"海关编码":"海关编码",
				"净重":"净重",
				"寄件信息":"寄件信息",
				"“总价”列内容格式不正确，限制导入！":"“总价”列内容格式不正确，限制导入！",
				"费用结算":"费用结算",
				"请选择代收币别!":"请选择代收币别!",
				"原产地":"原产地",
				"运单号码":"运单号码",
				"指定路线":"指定路线",
				"寄件州":"寄件州",
				"收件邮编":"收件邮编",
				"寄件电话":"寄件电话",
				"订单列表修改-Invoice导入模版":"订单列表修改-Invoice导入模版",
				"上传成功！":"上传成功！",
				"总价":"总价",
				"“单价”列内容格式不正确，限制导入！":"“单价”列内容格式不正确，限制导入！",
				"“净重”列内容格式不正确，限制导入！":"“净重”列内容格式不正确，限制导入！",
				"收件信息":"收件信息",
				"包装类型":"包装类型",
				"操作":"操作",
				"信息":"信息",
				"收件地址":"收件地址",
				"到付款":"到付款",
				"寄件地址":"寄件地址",
				"导入模板":"导入模板",
				"付款方式":"付款方式",
				"寄件人":"寄件人",
				"基本信息":"基本信息",
				"寄件邮编":"寄件邮编",
				"“毛重”列内容格式不正确，限制导入！":"“毛重”列内容格式不正确，限制导入！",
				"英文品名":"英文品名",
				"货物信息":"货物信息",
				"件数":"件数",
				"申报价值":"申报价值",
				"收件公司":"收件公司",
				"修改成功！":"修改成功！",
				"收件人":"收件人",
				"收件城市":"收件城市",
				"文件格式不正确，请上传正确的Excel文件":"文件格式不正确，请上传正确的Excel文件",
				"单价":"单价",
				"第一步":"第一步",
				"备注":"备注",
				"寄件城市":"寄件城市",
				"删除":"删除",
				"文件内容为空或格式不正确，请下载模版并填写导入内容！":"文件内容为空或格式不正确，请下载模版并填写导入内容！",
				"运单号码<":"运单号码<",
				"数量":"数量",
				"目的地":"目的地",
				"寄件公司":"寄件公司",
				"下载":"下载",
				"收件州":"收件州",
				"第二步":"第二步",
				"代收款":"代收款",
				"毛重":"毛重",
				"上传":"上传",
				"寄件日期":"寄件日期",
				"参考编号":"参考编号",
				"寄件国家":"寄件国家",
				"保存异常":"保存异常",
				"导入":"导入",
				"确定":"确定",
				"实重":"实重",
				"提示":"提示",
				"收费重":"收费重",
				"请选择到付币别!":"请选择到付币别!",
				"请上传附件！":"请上传附件！",
				"收件国家":"收件国家",
				">不为待审核，限制修改!":">不为待审核，限制修改!",
				"材重":"材重",
				"收件电话":"收件电话",
				"报关方式":"报关方式",
				"“数量”列内容格式不正确，限制导入！":"“数量”列内容格式不正确，限制导入！",
				"模板":"模板",
				"货物类型":"货物类型",
				"请输入":"请输入",
				"中文品名":"中文品名",
				"取消":"取消",
				"确定删除此行吗？":"确定删除此行吗？"
        },
		"CMN002":{
			"只能上传jpg/png/word/excel/pdf文件":"只能上传jpg/png/word/excel/pdf文件",
			"下一条":"下一条",
			"问题处理":"问题处理",
			"上一条":"上一条",
			"不提示":"不提示",
			"问题状态":"问题状态",
			"选中消息":"选中消息",
			"请选择消息":"请选择消息",
			"文件大小不能大于5MB":"文件大小不能大于5MB",
			"发送时间":"发送时间",
			"删除":"删除",
			"沟通记录":"沟通记录",
			"港前问题件":"港前问题件",
			"查询":"查询",
			"系统消息":"系统消息",
			"发件人":"发件人",
			"我":"我",
			"条，确认删除？":"条，确认删除？",
			"重置":"重置",
			"请输入回复内容!":"请输入回复内容!",
			"消息类型":"消息类型",
			"消息删除成功！":"消息删除成功！",
			"消息提醒设置":"消息提醒设置",
			"关联号码":"关联号码",
			"仅消息个数提示":"仅消息个数提示",
			"发送":"发送",
			"问题描述":"问题描述",
			"所选数据没有未读消息！":"所选数据没有未读消息！",
			"已经是最后一条消息了！":"已经是最后一条消息了！",
			"附件":"附件",
			"确定":"确定",
			"问题件回复":"问题件回复",
			"作者":"作者",
			"回复":"回复",
			"登记时间":"登记时间",
			"提示":"提示",
			"在此回复处理问题件":"在此回复处理问题件",
			"最新回复时间":"最新回复时间",
			"可添加附件":"可添加附件",
			"标记已读":"标记已读",
			"添加附件":"添加附件",
			"回复失败，请重新回复!":"回复失败，请重新回复!",
			"标记消息已读成功！":"标记消息已读成功！",
			"主题":"主题",
			"已经是第一条消息了！":"已经是第一条消息了！",
			"取消":"取消",
			"消息提醒方式设置成功！":"消息提醒方式设置成功！",
			"屏幕弹窗提醒":"屏幕弹窗提醒"
		},
		"trackquery":{
			"寄件日期":"寄件日期",
			"参考编号":"参考编号",
			"查询后选中单号":"查询后选中单号",
			"转单号码":"转单号码",
			"收费重":"收费重",
			"轨迹信息":"轨迹信息",
			"基本信息":"基本信息",
			"位置":"位置",
			"退返客户,退返方式为<":"退返客户,退返方式为<",
			"运单号码":"运单号码",
			"指定路线":"指定路线",
			"追踪结果":"追踪结果",
			"查询单号必填":"查询单号必填",
			"查询":"查询",
			"时间":"时间",
			"跟踪记录":"跟踪记录",
			"目的地":"目的地",
			"清空":"清空",
			"无此单号<":"无此单号<",
			"回车后直接查询":"回车后直接查询",
			"订单信息":"订单信息"
		},
		"ImportLog":{
			"导入时间":"导入时间",
			"网点":"网点",
			"状态":"状态",
			"查询":"查询",
			"重置":"重置",
			"批次号":"批次号",
			"结束时间":"结束时间",
			"导入耗时":"导入耗时",
			"导入网点":"导入网点",
			"导入文件":"导入文件",
			"错误描述":"错误描述",
			"错误行数":"错误行数",
			"总行数":"总行数",
			"导入人":"导入人"
		},
		"statManage":{
			"修改":"修改",
			"省":"省",
			"保存并继续":"保存并继续",
			"网点":"网点",
			"修改成功":"修改成功",
			"建立时间":"建立时间",
			"客服电话":"客服电话",
			"上级网点无法和下级网点相同，请重新选择！":"上级网点无法和下级网点相同，请重新选择！",
			"本位币":"本位币",
			"查询":"查询",
			"保存":"保存",
			"网点中文":"网点中文",
			"无法新增四级网点":"无法新增四级网点",
			"网点导出":"网点导出",
			"经理":"经理",
			"非子节点的网点不能修改上级网点！":"非子节点的网点不能修改上级网点！",
			"新增同级":"新增同级",
			"网点名称":"网点名称",
			"请选择\"网点类型\"!":"请选择\"网点类型\"!",
			"负责人电话":"负责人电话",
			"所属城市":"所属城市",
			"网点简码":"网点简码",
			"客服":"客服",
			"联系信息":"联系信息",
			"委托录单网点":"委托录单网点",
			"网点编码":"网点编码",
			"网点信息":"网点信息",
			"请选择网点":"请选择网点",
			"请选择":"请选择",
			"网点英文":"网点英文",
			"请输入\"网点编码\"!":"请输入\"网点编码\"!",
			"异步导出":"异步导出",
			"修改网点":"修改网点",
			"内部电话":"内部电话",
			"修改人":"修改人",
			"此操作将删除该网点, 是否继续?":"此操作将删除该网点, 是否继续?",
			"建立人":"建立人",
			"上级网点":"上级网点",
			"对账员":"对账员",
			"传真电话":"传真电话",
			"无法删除非子节点的网点！":"无法删除非子节点的网点！",
			"请先保存\"网点信息\"!":"请先保存\"网点信息\"!",
			"备注":"备注",
			"根节点不能新建同级网点":"根节点不能新建同级网点",
			"删除":"删除",
			"关闭":"关闭",
			"所属州/省":"所属州/省",
			"请先选择上级网点！":"请先选择上级网点！",
			"重置":"重置",
			"启用":"启用",
			"浏览":"浏览",
			"请选择\"本位币\"!":"请选择\"本位币\"!",
			"修改时间":"修改时间",
			"创建导出任务，请稍后在导出列表中下载！":"创建导出任务，请稍后在导出列表中下载！",
			"保存成功":"保存成功",
			"客服传真":"客服传真",
			"新增网点":"新增网点",
			"新增":"新增",
			"确定":"确定",
			"一级网点类型只能是“总部”！":"一级网点类型只能是“总部”！",
			"浏览网点":"浏览网点",
			"提示":"提示",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
			"网点删除成功":"网点删除成功",
			"网点类型":"网点类型",
			"根节点不能修改上级网点！":"根节点不能修改上级网点！",
			"选择网点":"选择网点",
			"导出":"导出",
			"负责人":"负责人",
			"请输入":"请输入",
			"投诉电话":"投诉电话",
			"所属国家":"所属国家",
			"经理电话":"经理电话",
			"取消":"取消",
			"新增下级":"新增下级",
			"请输入\"网点名称\"!":"请输入\"网点名称\"!",
			"所属州":"所属州",
			"基础信息":"基础信息",
		},
		"BAS005":{
			"确定要删除吗？":"确定要删除吗？",
			"修改":"修改",
			"保存并继续":"保存并继续",
			"工作地址":"工作地址",
			"户籍地址":"户籍地址",
			"修改员工":"修改员工",
			"所属部门":"所属部门",
			"建立时间":"建立时间",
			"籍贯":"籍贯",
			"请输入员工编码":"请输入员工编码",
			"合同截止日期":"合同截止日期",
			"现居住地址":"现居住地址",
			"删除员工异常":"删除员工异常",
			"查询":"查询",
			"紧急联系人":"紧急联系人",
			"保存":"保存",
			"婚姻状况":"婚姻状况",
			"合同签订日期":"合同签订日期",
			"员工管理":"员工管理",
			"紧急联系人电话":"紧急联系人电话",
			"工作":"工作",
			"身份证号":"身份证号",
			"修改异常":"修改异常",
			"家庭电话":"家庭电话",
			"现居地址":"现居地址",
			"在职状态":"在职状态",
			"员工姓名":"员工姓名",
			"请选择":"请选择",
			"员工编号":"员工编号",
			"社保号":"社保号",
			"基本信息":"基本信息",
			"删除成功！":"删除成功！",
			"工作QQ":"工作QQ",
			"所属网点":"所属网点",
			"党员":"党员",
			"修改人":"修改人",
			"员工信息":"员工信息",
			"建立人":"建立人",
			"薪资等级":"薪资等级",
			"出生年月":"出生年月",
			"修改成功！":"修改成功！",
			"手机":"手机",
			"手机号码":"手机号码",
			"职位状态":"职位状态",
			"电话":"电话",
			"个人信息":"个人信息",
			"职位描述":"职位描述",
			"备注":"备注",
			"删除":"删除",
			"入职日期":"入职日期",
			"离职日期":"离职日期",
			"关闭":"关闭",
			"重置":"重置",
			"启用":"启用",
			"民族":"民族",
			"浏览":"浏览",
			"修改时间":"修改时间",
			"在职信息":"在职信息",
			"个人":"个人",
			"请选择一行数据":"请选择一行数据",
			"背景色设置":"背景色设置",
			"紧急信息":"紧急信息",
			"相等":"相等",
			"新增":"新增",
			"确定":"确定",
			"提示":"提示",
			"浏览员工":"浏览员工",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
			"每行高亮":"每行高亮",
			"所在职位":"所在职位",
			"学历":"学历",
			"新增员工":"新增员工",
			"专业":"专业",
			"英文名":"英文名",
			"性别":"性别",
			"添加成功！":"添加成功！",
			"导出":"导出",
			"手机号":"手机号",
			"请输入":"请输入",
			"出生日期":"出生日期",
			"取消":"取消",
			"基本":"基本",
			"联系人关系":"联系人关系",
			"添加异常":"添加异常",
			"紧急联络信息":"紧急联络信息",
			"基本&在职信息":"基本&在职信息",
			"个人&紧急信息":"个人&紧急信息",
			"Email":"Email"
		},
		"roleManage":{
			"修改":"修改",
			"复制新增角色":"复制新增角色",
			"角色授权":"角色授权",
			"菜单名称":"菜单名称",
			"请选择角色":"请选择角色",
			"标识不勾":"标识不勾",
			"菜单权限":"菜单权限",
			"保存":"保存",
			"部门":"部门",
			"推荐值":"推荐值",
			"创建人":"创建人",
			"菜单标题":"菜单标题",
			"否":"否",
			"确定删除该职位?":"确定删除该职位?",
			"注意":"注意",
			"基本信息":"基本信息",
			"标准职位无法删除！":"标准职位无法删除！",
			"是":"是",
			"标准职位无法修改！":"标准职位无法修改！",
			"修改人":"修改人",
			"序号":"序号",
			"请设置参数信息!":"请设置参数信息!",
			"复选框":"复选框",
			"删除":"删除",
			"参数设置成功！":"参数设置成功！",
			"重置":"重置",
			"获取参数设置异常":"获取参数设置异常",
			"确定要删除该部门吗(包含下级部门)？":"确定要删除该部门吗(包含下级部门)？",
			"职位说明":"职位说明",
			"导出选中":"导出选中",
			"一级模块":"一级模块",
			"导出明细":"导出明细",
			"提示":"提示",
			"二级菜单":"二级菜单",
			"导出":"导出",
			"组件类型":"组件类型",
			"请输入":"请输入",
			"取消":"取消",
			"参数设置":"参数设置",
			"新增部门成功！":"新增部门成功！",
			"一级菜单":"一级菜单",
			"授权菜单数":"授权菜单数",
			"保存并继续":"保存并继续",
			"勾选菜单权限自动勾选下属按钮权限":"勾选菜单权限自动勾选下属按钮权限",
			"参数编码":"参数编码",
			"导出详情":"导出详情",
			"标识打勾":"标识打勾",
			"如设置值为空":"如设置值为空",
			"全部":"全部",
			"修改部门成功！":"修改部门成功！",
			"职位":"职位",
			"查询":"查询",
			"下拉框值为有效值":"下拉框值为有效值",
			"登录入口":"登录入口",
			"职位角色信息":"职位角色信息",
			"新增下属部门":"新增下属部门",
			"部门删除成功！":"部门删除成功！",
			"角色删除成功":"角色删除成功",
			"角色参数设置":"角色参数设置",
			"按钮启用数":"按钮启用数",
			"修改部门":"修改部门",
			"参数说明":"参数说明",
			"管理员":"管理员",
			"启用状态":"启用状态",
			"如设置值为":"如设置值为",
			"按钮权限":"按钮权限",
			"按钮标题":"按钮标题",
			"数字框":"数字框",
			"部门说明":"部门说明",
			"参数定义":"参数定义",
			"组件类型为":"组件类型为",
			"增加":"增加",
			"修改角色":"修改角色",
			"复制新增":"复制新增",
			"密码框":"密码框",
			"按钮数":"按钮数",
			"设置值":"设置值",
			"关闭":"关闭",
			"重量段删除失败！":"重量段删除失败！",
			"启用":"启用",
			"参数设置数":"参数设置数",
			"修改时间":"修改时间",
			"导出所有":"导出所有",
			"多个有效值用":"多个有效值用",
			"标识以系统设置值为准":"标识以系统设置值为准",
			"下拉框":"下拉框",
			"新增角色":"新增角色",
			"角色说明":"角色说明",
			"请选择导出数据":"请选择导出数据",
			"功能说明":"功能说明",
			"新增下属部门成功！":"新增下属部门成功！",
			"新增":"新增",
			"确定":"确定",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
			"菜单":"菜单",
			"请先选择角色！":"请先选择角色！",
			"文本框":"文本框",
			"标准职位":"标准职位",
			"角色":"角色",
			"时":"时",
			"新增部门":"新增部门",
			"角色名称":"角色名称",
			"创建时间":"创建时间",
			"隔开":"隔开"
		},
		"BAS006":{
			"请选择需要特殊授权的用户":"请选择需要特殊授权的用户",
			"特殊授权":"特殊授权",
			"勾选菜单权限自动勾选下属按钮权限":"勾选菜单权限自动勾选下属按钮权限",
			"角色授权":"角色授权",
			"密码重置成功！！":"密码重置成功！！",
			"你已改动，确定要关闭吗？":"你已改动，确定要关闭吗？",
			"选项表方法":"选项表方法",
			"追加授权":"追加授权",
			"授权角色":"授权角色",
			"所属部门":"所属部门",
			"结果对象变量":"结果对象变量",
			"角色列表":"角色列表",
			"请输入关键字":"请输入关键字",
			"网点授权类型":"网点授权类型",
			"职位":"职位",
			"授权按钮":"授权按钮",
			"查询":"查询",
			"菜单权限":"菜单权限",
			"特殊授权成功":"特殊授权成功",
			"保存":"保存",
			"普通方法":"普通方法",
			"部门":"部门",
			"重置密码不能与原密码相同！":"重置密码不能与原密码相同！",
			"登录入口":"登录入口",
			"菜单标题":"菜单标题",
			"事件触发调用方法":"事件触发调用方法",
			"默认职位":"默认职位",
			"密码不得少于":"密码不得少于",
			"密码不能是完全相同的字符":"密码不能是完全相同的字符",
			"按钮启用数":"按钮启用数",
			"确认密码":"确认密码",
			"网点列表":"网点列表",
			"授权网点方式":"授权网点方式",
			"注意":"注意",
			"调用表方法":"调用表方法",
			"管理员":"管理员",
			"表单对象变量":"表单对象变量",
			"启用状态":"启用状态",
			"用户编号":"用户编号",
			"所属网点":"所属网点",
			"按钮权限":"按钮权限",
			"用户授权":"用户授权",
			"密码不得少于6位！":"密码不得少于6位！",
			"按钮标题":"按钮标题",
			"修改人":"修改人",
			"用户编码":"用户编码",
			"建立人":"建立人",
			"复制密码":"复制密码",
			"用户信息":"用户信息",
			"序号":"序号",
			"登陆次数":"登陆次数",
			"重置密码":"重置密码",
			"上次登录时间":"上次登录时间",
			"位":"位",
			"按钮数":"按钮数",
			"网点授权":"网点授权",
			"关闭":"关闭",
			"授权管理":"授权管理",
			"授权网点":"授权网点",
			"密码重置异常":"密码重置异常",
			"重置":"重置",
			"启用":"启用",
			"用户姓名":"用户姓名",
			"授权角色列表":"授权角色列表",
			"普通变量":"普通变量",
			"修改时间":"修改时间",
			"选项表表变量":"选项表表变量",
			"确定修改密码吗？":"确定修改密码吗？",
			"请选择一行数据":"请选择一行数据",
			"功能说明":"功能说明",
			"不允许出现连续的数字或完全相同的字符":"不允许出现连续的数字或完全相同的字符",
			"选项表变量":"选项表变量",
			"授权保存成功！":"授权保存成功！",
			"一级模块":"一级模块",
			"密码不能是连续数字":"密码不能是连续数字",
			"确定":"确定",
			"校验变量":"校验变量",
			"提示":"提示",
			"角色授权保存异常":"角色授权保存异常",
			"网点授权保存异常":"网点授权保存异常",
			"调用表变量":"调用表变量",
			"用户名称":"用户名称",
			"密码重置":"密码重置",
			"密码":"密码",
			"导出":"导出",
			"无效数据！":"无效数据！",
			"请输入":"请输入",
			"请输入密码":"请输入密码",
			"取消":"取消",
			"创建时间":"创建时间",
			"显示密码":"显示密码",
			"授权网点列表":"授权网点列表",
			"重置密码与确认密码必须相同！":"重置密码与确认密码必须相同！"
		},
		"BAS045":{
			"操作时间":"操作时间",
			"操作说明":"操作说明",
			"操作日志":"操作日志",
			"按钮":"按钮",
			"命令":"命令",
			"主数据ID":"主数据ID",
			"查询":"查询",
			"重置":"重置",
			"功能菜单":"功能菜单",
			"操作用户":"操作用户",
			"操作日期不能为空":"操作日期不能为空",
			"导出":"导出",
			"主数据表":"主数据表",
			"操作网点":"操作网点",
			"标识字段":"标识字段"
		},
		"BAS036":{
			"修改":"修改",
			"保存并继续":"保存并继续",
			"是否删除该授权用户":"是否删除该授权用户",
			"新增客户时自动生成":"新增客户时自动生成",
			"查询":"查询",
			"保存":"保存",
			"登录账号":"登录账号",
			"创建人":"创建人",
			"菜单标题":"菜单标题",
			"修改异常":"修改异常",
			"修改OMS授权":"修改OMS授权",
			"用户账号":"用户账号",
			"注意":"注意",
			"基本信息":"基本信息",
			"删除成功！":"删除成功！",
			"启用状态":"启用状态",
			"删除异常":"删除异常",
			"所属网点":"所属网点",
			"拥有权限":"拥有权限",
			"修改人":"修改人",
			"修改OMS角色":"修改OMS角色",
			"用户编码":"用户编码",
			"客户名称":"客户名称",
			"修改成功！":"修改成功！",
			"复制密码":"复制密码",
			"默认角色须唯一":"默认角色须唯一",
			"新增OMS授权":"新增OMS授权",
			"是否删除当前角色?":"是否删除当前角色?",
			"增加":"增加",
			"备注":"备注",
			"删除":"删除",
			"关闭":"关闭",
			"重置":"重置",
			"启用":"启用",
			"用户姓名":"用户姓名",
			"修改时间":"修改时间",
			"请选择一行数据":"请选择一行数据",
			"角色说明":"角色说明",
			"OMS角色":"OMS角色",
			"功能说明":"功能说明",
			"新增":"新增",
			"确定":"确定",
			"授权信息":"授权信息",
			"提示":"提示",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
			"新增OMS角色":"新增OMS角色",
			"用户名称":"用户名称",
			"已有默认角色":"已有默认角色",
			"密码":"密码",
			"添加成功！":"添加成功！",
			"角色":"角色",
			"初始化密码为":"初始化密码为",
			"请输入":"请输入",
			"取消":"取消",
			"角色名称":"角色名称",
			"创建时间":"创建时间",
			"显示密码":"显示密码",
			"添加异常":"添加异常",
			"所属客户":"所属客户",
			"默认角色":"默认角色",
			"类型":"类型",
			"用户账号/手机号":"用户账号/手机号",
			"绑定微信":"绑定微信",
			"手机号码":"手机号码"
		},
		"BAS008":{
			"新增":"新增",
			"修改":"修改",
			"删除":"删除",
			"设置报音":"设置报音",
			"导出":"导出",
			"目的地信息":"目的地信息",
			"目的地编码":"目的地编码",
			"目的地名称":"目的地名称",
			"国家简码":"国家简码",
			"英文名称":"英文名称",
			"国家别名":"国家别名",
			"业务类型":"业务类型",
			"启用状态":"启用状态",
			"查询":"查询",
			"重置":"重置",
			"基础信息":"基础信息",
			"启用":"启用",
			"目的地国币别":"目的地国币别",
			"目的地服务电话":"目的地服务电话",
			"可多选":"可多选",
			"多个别名":"多个别名",
			"请用":"请用",
			"或":"或",
			"隔开":"隔开",
			"主要用报价分区导入":"主要用报价分区导入",
			"中文名称":"中文名称",
			"备注":"备注",
			"保存并继续":"保存并继续",
			"保存":"保存",
			"关闭":"关闭",
			"报音文件":"报音文件",
			"序号":"序号",
			"货物类型":"货物类型",
			"请输入":"请输入",
			"请选择":"请选择",
			"请选择，请重请选择！":"报音文件不能为空，请重新选择！",
			"目的地国家币别":"目的地国家币别",
			"目的地国服务电话":"目的地国服务电话",
			"目的地报音":"目的地报音",
			"创建时间":"创建时间",
			"创建人,是否创建人？":"内容有修改,是否确认关闭？",
			"修改时间":"修改时间",
			"修改人":"修改人",
			"新增目的地":"新增目的地",
			"修改目的地":"修改目的地",
			"请选择目的地":"请选择目的地",
			"新增成功, 是新增成功?":"此操作将删除该目的地, 是否继续?",
			"修改成功":"修改成功",
			"此操作将删除该目的地, 是否继续?":"此操作将删除该目的地, 是否继续?",
			"提示":"提示",
			"确定":"确定",
			"取消":"取消",
			"删除成功":"删除成功",
			"目的地":"目的地",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
			"目的地设置报音":"目的地设置报音",
			"报音文件不能为空，请重新选择！":"报音文件不能为空，请重新选择！",
			"国家三字代码":"国家三字代码",
			"创建人":"创建人"
		},
		"BAS037":{
			"新增":"新增",
			"修改":"修改",
			"批量修改":"批量修改",
			"浏览":"浏览",
			"删除":"删除",
			"导出":"导出",
			"代理信息":"代理信息",
			"所属网点":"所属网点",
			"代理编码":"代理编码",
			"代理名称":"代理名称",
			"代理类型":"代理类型",
			"启用状态":"启用状态",
			"对账员":"对账员",
			"查询":"查询",
			"重置":"重置",
			"基础信息":"基础信息",
			"启用":"启用",
			"代理简码":"代理简码",
			"代理全称":"代理全称",
			"英文名称":"英文名称",
			"所属国家":"所属国家",
			"所属州":"所属州",
			"省":"省",
			"所属城市":"所属城市",
			"所属邮编":"所属邮编",
			"地址":"地址",
			"地址2":"地址2",
			"备注":"备注",
			"付款信息":"付款信息",
			"付款账号信息":"付款账号信息",
			"银行账号":"银行账号",
			"开户银行":"开户银行",
			"开户人":"开户人",
			"付款账号协议":"付款账号协议",
			"只能上传":"只能上传",
			"张":"张",
			"格式":"格式",
			"图片文件":"图片文件",
			"不超过":"不超过",
			"联络信息":"联络信息",
			"序号":"序号",
			"操作":"操作",
			"联系人":"联系人",
			"岗位":"岗位",
			"电话":"电话",
			"手机":"手机",
			"传真":"传真",
			"保存并继续":"保存并继续",
			"保存":"保存",
			"关闭":"关闭",
			"修改信息":"修改信息",
			"当前选择批量修改代理":"当前选择批量修改代理",
			"家":"家",
			"请谨慎修改":"请谨慎修改",
			"新增代理":"新增代理",
			"所属州/省":"所属州/省",
			"最后一次交货时间":"最后一次交货时间",
			"创建时间":"创建时间",
			"创建人":"创建人",
			"修改时间":"修改时间",
			"修改人":"修改人",
			"请输入":"请输入",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
			"是否删除当前代理":"是否删除当前代理",
			"提示":"提示",
			"确定":"确定",
			"取消":"取消",
			"请选择一行数据":"请选择一行数据",
			"删除异常":"删除异常",
			"删除成功！":"删除成功！",
			"请输入代理编码":"请输入代理编码",
			"不能存在相同联系人":"不能存在相同联系人",
			"添加异常":"添加异常",
			"添加成功！":"添加成功！",
			"修改异常":"修改异常",
			"修改成功！":"修改成功！",
			"请选择要修改的数据":"请选择要修改的数据",
			"请选择代理类型":"请选择代理类型",
			"请选择对账员":"请选择对账员",
			"请先选择要修改列":"请先选择要修改列",
			"代理浏览":"代理浏览",
			"获取文件路径异常":"获取文件路径异常",
			"修改代理":"修改代理",
			"代理管理":"代理管理",
			"文件大小不能大于2MB":"文件大小不能大于2MB",
			"只能上传jpeg/jpg/png文件":"只能上传jpeg/jpg/png文件",
			"确定删除此行吗？":"确定删除此行吗？",
			"联系人不能为空":"联系人不能为空",
			"岗位不能为空":"岗位不能为空",
			"手机不能为空":"手机不能为空",
		},
		"BAS028":{
			"新增":"新增",
			"修改":"修改",
			"删除":"删除",
			"共享":"共享",
			"不共享":"不共享",
			"共享给所有":"共享给所有",
			"共享给指定":"共享给指定",
			"导出":"导出",
			"客户分组信息":"客户分组信息",
			"客户组编码":"客户组编码",
			"客户组名称":"客户组名称",
			"所属网点":"所属网点",
			"共享方式":"共享方式",
			"启用状态":"启用状态",
			"查询":"查询",
			"重置":"重置",
			"基本信息":"基本信息",
			"启用":"启用",
			"中隐藏公式":"中隐藏公式",
			"备注":"备注",
			"共享网点":"共享网点",
			"可多选":"可多选",
			"保存并继续":"保存并继续",
			"保存":"保存",
			"关闭":"关闭",
			"共享给指定网点":"共享给指定网点",
			"网点列表":"网点列表",
			"指定网点":"指定网点",
			"请输入关键字":"请输入关键字",
			"新增客户组":"新增客户组",
			"VIP中隐藏公式":"VIP中隐藏公式",
			"现结客户":"现结客户",
			"建立时间":"建立时间",
			"建立人":"建立人",
			"修改时间":"修改时间",
			"修改人":"修改人",
			"请输入":"请输入",
			"确定要删除吗？":"确定要删除吗？",
			"提示":"提示",
			"确定":"确定",
			"取消":"取消",
			"请选择一行数据":"请选择一行数据",
			"删除异常":"删除异常",
			"删除成功！":"删除成功！",
			"添加异常":"添加异常",
			"添加成功！":"添加成功！",
			"修改异常":"修改异常",
			"修改成功！":"修改成功！",
			"至少选择一个网点！":"至少选择一个网点！",
			"保存异常":"保存异常",
			"修改共享方式成功！":"修改共享方式成功！",
			"修改共享方式失败！":"修改共享方式失败！",
			"修改客户组":"修改客户组",
			"浏览客户组":"浏览客户组",
			"客户组管理":"客户组管理",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
		},
		"custManage": {
        	"账单公式不能为空":"账单公式不能为空",
			"账单格式": "账单格式",
			"账单格式信息": "账单格式信息",
			"账单公式（可多选）": "账单公式（可多选）",

			"结算相关": "结算相关",
			"结算节点": "结算节点",
			"计费节点": "计费节点",
			"账单格式&结算": "账单格式&结算",
			"注意：": "注意：",
			"系统默认按寄件（入库）计费与结算": "系统默认按寄件（入库）计费与结算",
			"设置其他结算节点后": "设置其他结算节点后",
			"对应账单数据需满足结算条件才允许结算": "对应账单数据需满足结算条件才允许结算",
			"系统支持根据设置计费节点时间进行批价计算": "系统支持根据设置计费节点时间进行批价计算",
			"设置其他计费节点后": "设置其他计费节点后",

			"若客户需根据指定路线设置计费": "若客户需根据指定路线设置计费",
			"请在": "请在",
			"特殊结算规则": "特殊结算规则",
			"页签中设置": "页签中设置",
			"指定路线": "指定路线",
			"指定路线不能为空": "指定路线不能为空",
			"指定路线不能重复": "指定路线不能重复",
			"指定路线存在时，计费节点与结算节点必填其一": "指定路线存在时，计费节点与结算节点必填其一",





			"客户委托指定": "客户委托指定",
			"删除销售员配置成功！": "删除销售员配置成功！",
			"只显示含附件": "只显示含附件",
			"交易流水": "交易流水",
			"客户编号": "客户编号",
			"部门": "部门",
			"行,缺少联系人": "行,缺少联系人",
			"请选择客户": "请选择客户",
			"自动发送账单邮件": "自动发送账单邮件",
			"获取文件路径异常": "获取文件路径异常",
			"此操作将停用该客户, 是否继续?": "此操作将停用该客户, 是否继续?",
			"操作": "操作",
			"子客户目的国家简码": "子客户目的国家简码",
			"禁用下载": "禁用下载",
			"关联主客户": "关联主客户",
			"请填写\"\"基本信息\"\"！": "请填写\"\"基本信息\"\"！",
			"主客户编码不能为空": "主客户编码不能为空",
			"请选择客户状态": "请选择客户状态",
			"回款期限": "回款期限",
			"所属网点": "所属网点",
			"自动触发账单发送到指定邮箱": "自动触发账单发送到指定邮箱",
			"修改人": "修改人",
			"客户名称": "客户名称",
			"通知人优先取值客户管理": "通知人优先取值客户管理",
			"默认帐单格式": "默认帐单格式",
			"账单发送邮箱": "账单发送邮箱",
			"停用": "停用",
			"是否需开票": "是否需开票",
			"请填写必填值！": "请填写必填值！",
			"营业执照号": "营业执照号",
			"英文地址": "英文地址",
			"请选择港前客服": "请选择港前客服",
			"删除": "删除",
			"请选择销售员": "请选择销售员",
			"允许有多个网点": "允许有多个网点",
			"浏览": "浏览",
			"结算周期": "结算周期",
			"当前客户停用失败！": "当前客户停用失败！",
			"当前结算周期在第几天开始计算回款期限": "当前结算周期在第几天开始计算回款期限",
			"关联客户组为空，确定继续保存吗？": "关联客户组为空，确定继续保存吗？",
			"客户编码": "客户编码",
			"主客户编码": "主客户编码",
			"请选择\"所属网点\"!": "请选择\"所属网点\"!",
			"此操作将删除该联系人, 是否继续?": "此操作将删除该联系人, 是否继续?",
			"中客户下单时": "中客户下单时",
			"帐单接收邮箱最多可以输入5个": "帐单接收邮箱最多可以输入5个",
			"请输入": "请输入",
			"取消": "取消",
			"客户修改成功": "客户修改成功",
			"最多可以输入": "最多可以输入",
			"保存并继续": "保存并继续",
			"绑定子客户": "绑定子客户",
			"客户状态": "客户状态",
			"最后交货时间": "最后交货时间",
			"查询": "查询",
			"业务手机": "业务手机",
			"港前指定处理岗位": "港前指定处理岗位",
			"请选择先客户！": "请选择先客户！",
			"帐单接收邮箱缺少“@”字符": "帐单接收邮箱缺少“@”字符",
			"个邮箱缺少“@”字符": "个邮箱缺少“@”字符",
			"结算日为": "结算日为",
			"结算账单": "结算账单",
			"所属城市": "所属城市",
			"该模式将优先调用寄件人对接人跟进": "该模式将优先调用寄件人对接人跟进",
			"如果结算周期是周结": "如果结算周期是周结",
			"客户联系人": "客户联系人",
			"税金押金币别": "税金押金币别",
			"请选择\"客户类型\"!": "请选择\"客户类型\"!",
			"登记港前": "登记港前",
			"港后指定处理岗位对应的员工": "港后指定处理岗位对应的员工",
			"根据主客户编码": "根据主客户编码",
			"账单审核后": "账单审核后",
			"同行客户": "同行客户",
			"多个邮箱之间用": "多个邮箱之间用",
			"结算日": "结算日",
			"举例说明": "举例说明",
			"请输入\"客户编码\"!": "请输入\"客户编码\"!",
			"通知岗位": "通知岗位",
			"此客户只允许所属网点录单": "此客户只允许所属网点录单",
			"请选择\"客户状态\"!": "请选择\"客户状态\"!",
			"帐单信息": "帐单信息",
			"当前选择批量修改客户": "当前选择批量修改客户",
			"当前为主客户": "当前为主客户",
			"修改成功！": "修改成功！",
			"运费押金": "运费押金",
			"对账员": "对账员",
			"财务联络人": "财务联络人",
			"请选择客户类型": "请选择客户类型",
			"请填写\"基本信息\"！": "请填写\"基本信息\"！",
			"签约日期": "签约日期",
			"合同日期": "合同日期",
			"备注": "备注",
			"复制新增": "复制新增",
			"个文件": "个文件",
			"关闭": "关闭",
			"所属邮编": "所属邮编",
			"关联客户组": "关联客户组",
			"请选择帐单发送邮箱": "请选择帐单发送邮箱",
			"请选择港后客服": "请选择港后客服",
			"修改时间": "修改时间",
			"按寄件人跟进": "按寄件人跟进",
			"请输入\"客户名称\"!": "请输入\"客户名称\"!",
			"请选择一行数据": "请选择一行数据",
			"合同编号": "合同编号",
			"内部对接人信息": "内部对接人信息",
			"附件信息": "附件信息",
			"新增": "新增",
			"确定": "确定",
			"用于订单导入时": "用于订单导入时",
			"客户委托所有": "客户委托所有",
			"通知岗位对应的员工": "通知岗位对应的员工",
			"文件大小不能大于10M": "文件大小不能大于10M",
			"批量修改": "批量修改",
			"无需关联": "无需关联",
			"以其他客户为主客户": "以其他客户为主客户",
			"当前客户删除成功": "当前客户删除成功",
			"税金押金": "税金押金",
			"委托录单": "委托录单",
			"港后客服": "港后客服",
			"其他信息": "其他信息",
			"所属国家": "所属国家",
			"所属州": "所属州",
			"修改客户": "修改客户",
			"指定处理岗位对应的员工": "指定处理岗位对应的员工",
			"隔开": "隔开",
			"请选择\"运费押金币别\"!": "请选择\"运费押金币别\"!",
			"修改": "修改",
			"省": "省",
			"网点委托指定给": "网点委托指定给",
			"如有多个委托录单网点时": "如有多个委托录单网点时",
			"所属网点下的所有客户的录单委托给指定网点": "所属网点下的所有客户的录单委托给指定网点",
			"请输入关键字": "请输入关键字",
			"押金信息": "押金信息",
			"保存": "保存",
			"客户曾用名": "客户曾用名",
			"联络": "联络",
			"可多选": "可多选",
			"帐单接收邮箱第": "帐单接收邮箱第",
			"创建人": "创建人",
			"复制新增客户": "复制新增客户",
			"请输入帐单接收邮箱": "请输入帐单接收邮箱",
			"附件": "附件",
			"客户类型": "客户类型",
			"修改信息": "修改信息",
			"公司中文名称": "公司中文名称",
			"请选择对账员": "请选择对账员",
			"行邮箱地址缺少“@”字符": "行邮箱地址缺少“@”字符",
			"勾选客户委托指定时，必须选择委托录单网点！": "勾选客户委托指定时，必须选择委托录单网点！",
			"网点列表": "网点列表",
			"在": "在",
			"天": "天",
			"注意": "注意",
			"付款方式": "付款方式",
			"基本信息": "基本信息",
			"第": "第",
			"当前客户已被停用": "当前客户已被停用",
			"浏览客户": "浏览客户",
			"客户等级": "客户等级",
			"对接信息": "对接信息",
			"请添加联系信息": "请添加联系信息",
			"请选择\"结算周期\"！": "请选择\"结算周期\"！",
			"取件员": "取件员",
			"首次交货时间": "首次交货时间",
			"指定处理人优先取值客户管理": "指定处理人优先取值客户管理",
			"客户管理": "客户管理",
			"按客户跟进": "按客户跟进",
			"发票公司抬头": "发票公司抬头",
			"跟进模式": "跟进模式",
			"帐单": "帐单",
			"发票信息": "发票信息",
			"重置": "重置",
			"此客户的录单委托给指定网点": "此客户的录单委托给指定网点",
			"表示下周二开始计算回款期限": "表示下周二开始计算回款期限",
			"第一个为默认的录单网点": "第一个为默认的录单网点",
			"当前客户删除失败！": "当前客户删除失败！",
			"个邮箱": "个邮箱",
			"请先选择要修改列": "请先选择要修改列",
			"添加或者修改销售员，系统会根据时间排序并把下一个起始时间作为上一个时间的终止时间，确定继续保存吗？": "添加或者修改销售员，系统会根据时间排序并把下一个起始时间作为上一个时间的终止时间，确定继续保存吗？",
			"子客户目的国家简码自动分拣出子客户编码": "子客户目的国家简码自动分拣出子客户编码",
			"请填写销售员": "请填写销售员",
			"港后指定处理岗位": "港后指定处理岗位",
			"收件人管理": "收件人管理",
			"提示": "提示",
			"账单接收邮箱": "账单接收邮箱",
			"委托录单网点列表": "委托录单网点列表",
			"导出": "导出",
			"财务联络电话": "财务联络电话",
			"自结算日开始多少天内回款": "自结算日开始多少天内回款",
			"港前客服": "港前客服",
			"基础信息": "基础信息",
			"联系人": "联系人",
			"自动生成账单": "自动生成账单",
			"业务电话": "业务电话",
			"邮箱地址": "邮箱地址",
			"请选择\"税金押金币别\"!": "请选择\"税金押金币别\"!",
			"中文地址": "中文地址",
			"身份证号": "身份证号",
			"请选择\"客户分类\"！": "请选择\"客户分类\"！",
			"运费押金币别": "运费押金币别",
			"请谨慎修改": "请谨慎修改",
			"起始日期": "起始日期",
			"新增客户成功": "新增客户成功",
			"税号": "税号",
			"家": "家",
			"其次取值问题状态": "其次取值问题状态",
			"可用于子客户分拣和统一以主客户收款": "可用于子客户分拣和统一以主客户收款",
			"请选择所属网点": "请选择所属网点",
			"正在上传水单，请稍等": "正在上传水单，请稍等",
			"发票": "发票",
			"此客户委托给任意网点录单": "此客户委托给任意网点录单",
			"文件格式": "文件格式",
			"逾期利率": "逾期利率",
			"当前客户即为主客户": "当前客户即为主客户",
			"请选择跟单员": "请选择跟单员",
			"是否签合同": "是否签合同",
			"客户不委托": "客户不委托",
			"增加": "增加",
			"合同信息": "合同信息",
			"网点未委托": "网点未委托",
			"当前联系人删除成功": "当前联系人删除成功",
			"请选择默认帐单格式": "请选择默认帐单格式",
			"新增客户": "新增客户",
			"销售员": "销售员",
			"请填写起始时间": "请填写起始时间",
			"网站限制查件": "网站限制查件",
			"港后问题件时": "港后问题件时",
			"最多上传": "最多上传",
			"跟单员": "跟单员",
			"单文件不超过": "单文件不超过",
			"内容有修改,是否确认关闭？": "内容有修改,是否确认关闭？",
			"客户分类": "客户分类",
			"超过回款期限开始计算逾期": "超过回款期限开始计算逾期",
			"不限": "不限",
			"发票地址": "发票地址",
			"请先关联客户组！": "请先关联客户组！",
			"公司英文名称": "公司英文名称",
			"客户附件": "客户附件",
			"港前": "港前",
			"传真": "传真",
			"此操作将删除该客户, 是否继续?": "此操作将删除该客户, 是否继续?",
			"目的国家简码": "目的国家简码",
			"创建时间": "创建时间",
			"请先选择客户": "请先选择客户"
		},
		"BAS071":{
			"修改":"修改",
			"保存并继续":"保存并继续",
			"出货批次规则第六段不能为空":"出货批次规则第六段不能为空",
			"修改成功":"修改成功",
			"请选择共享网点":"请选择共享网点",
			"自动生成出货批次规则":"自动生成出货批次规则",
			"查询":"查询",
			"保存":"保存",
			"可多选":"可多选",
			"自动生成规则第三段、第五段必填其一":"自动生成规则第三段、第五段必填其一",
			"创建人":"创建人",
			"第五段必填其一":"第五段必填其一",
			"共享给指定":"共享给指定",
			"出货批次策略":"出货批次策略",
			"请选择":"请选择",
			"请选择出货批次策略":"请选择出货批次策略",
			"启用状态":"启用状态",
			"验证方式":"验证方式",
			"所属网点":"所属网点",
			"修改人":"修改人",
			"多个用逗号分隔":"多个用逗号分隔",
			"修改出货批次策略":"修改出货批次策略",
			"为保证出货批次严谨性":"为保证出货批次严谨性",
			"策略名称":"策略名称",
			"删除成功":"删除成功",
			"大包分拣码":"大包分拣码",
			"此操作将删除该出货批次策略, 是否继续?":"此操作将删除该出货批次策略, 是否继续?",
			"备注":"备注",
			"删除":"删除",
			"自动生成规则第三段":"自动生成规则第三段",
			"关闭":"关闭",
			"重置":"重置",
			"启用":"启用",
			"修改时间":"修改时间",
			"共享网点":"共享网点",
			"新增":"新增",
			"确定":"确定",
			"策略编码":"策略编码",
			"出货批次规则第四段不能为空":"出货批次规则第四段不能为空",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
			"提示":"提示",
			"注":"注",
			"共享方式":"共享方式",
			"新增出货批次策略":"新增出货批次策略",
			"新增成功":"新增成功",
			"导出":"导出",
			"目的国家简码":"目的国家简码",
			"请输入":"请输入",
			"取消":"取消",
			"创建时间":"创建时间",
			"出货批次规则中只能存在一段流水号规则":"出货批次规则中只能存在一段流水号规则",
			"大包分拣码（多个用逗号分隔）":"大包分拣码（多个用逗号分隔）",
			"共享网点(可多选)":"共享网点(可多选)"
		},
		"BAS073":{
			"清关供应商":"清关供应商",
			"输入清关供应商检索":"输入清关供应商检索",
			"序列":"序列",
			"轨迹状态":"轨迹状态",
			"轨迹名称":"轨迹名称",
			"轨迹阶段":"轨迹阶段",
			"轨迹类型":"轨迹类型",
			"匹配编码":"匹配编码",
			"修改人":"修改人",
			"修改时间":"修改时间",
			"注：":"注：",
			"1、匹配字符可修改删除，多个匹配字符以回车分隔；单个规则字符不允许超过40个字符；":"1、匹配字符可修改删除，多个匹配字符以回车分隔；单个规则字符不允许超过40个字符；",
			"2、同时存在优先匹配轨迹编码；":"2、同时存在优先匹配轨迹编码；",
			"3、指定排除项，用于过滤指定轨迹。例如，不需要解析轨迹A，可设置A为指定排除项，后续A将不再解析到系统轨迹":"3、指定排除项，用于过滤指定轨迹。例如，不需要解析轨迹A，可设置A为指定排除项，后续A将不再解析到系统轨迹",
		},
		"TMS009":{
			"修改":"修改",
			"包数":"包数",
			"装包数量必须大于0":"装包数量必须大于0",
			"英文目的地":"英文目的地",
			"总体积":"总体积",
			"邮包互换局":"邮包互换局",
			"票数":"票数",
			"请到":"请到",
			"大包管理":"大包管理",
			"完成":"完成",
			"保存":"保存",
			"批量生成装包异常":"批量生成装包异常",
			"建包日期不能为空":"建包日期不能为空",
			"建包日期":"建包日期",
			"装包管理":"装包管理",
			"撤销完成异常":"撤销完成异常",
			"可多选":"可多选",
			"撤销完成":"撤销完成",
			"批量生成装包成功！":"批量生成装包成功！",
			"装包网点":"装包网点",
			"修改异常":"修改异常",
			"目的城市":"目的城市",
			"总实重":"总实重",
			"操作":"操作",
			"当前装包状态 不为\"已完成\", 不允许撤销完成":"当前装包状态 不为\"已完成\", 不允许撤销完成",
			"保存并打印":"保存并打印",
			"注意":"注意",
			"做完成装包操作？":"做完成装包操作？",
			"中":"中",
			"件数":"件数",
			"关包人":"关包人",
			"撤销装包":"撤销装包",
			"装包分析":"装包分析",
			"目的机场代码":"目的机场代码",
			"报关类型":"报关类型",
			"确认人":"确认人",
			"撤销装包成功！":"撤销装包成功！",
			"重置":"重置",
			"装包状态不为 “已建包”，不允许修改":"装包状态不为 “已建包”，不允许修改",
			"目的地":"目的地",
			"核重人":"核重人",
			"单票限制申报价值":"单票限制申报价值",
			"如未正常输出打印":"如未正常输出打印",
			"核重重量":"核重重量",
			"提示":"提示",
			"装包完成成功！":"装包完成成功！",
			"装包日期不能为空":"装包日期不能为空",
			"长(cm)":"长(cm)",
			"总运单确认时间":"总运单确认时间",
			"包材重(kg)":"包材重(kg)",
			"完成装包异常":"完成装包异常",
			"存在装包状态不为\"已建包\"的装包, 不允许撤销装包":"存在装包状态不为\"已建包\"的装包, 不允许撤销装包",
			"整包限制重量":"整包限制重量",
			"计划启程时间":"计划启程时间",
			"打印":"打印",
			"报关方式":"报关方式",
			":无票数, 无法打印":":无票数, 无法打印",
			"收货装包":"收货装包",
			"导出":"导出",
			"实际为增加包号数据并完成打印的过程":"实际为增加包号数据并完成打印的过程",
			"请输入":"请输入",
			"取消":"取消",
			"关包时间":"关包时间",
			"总运单":"总运单",
			"添加异常":"添加异常",
			"预打印包号":"预打印包号",
			"出货实重":"出货实重",
			"请选择数据！":"请选择数据！",
			"航班/车牌号":"航班/车牌号",
			"保存并继续":"保存并继续",
			"核重时间":"核重时间",
			"是否对包号":"是否对包号",
			"出货时间":"出货时间",
			"装包完成":"装包完成",
			"运单号码":"运单号码",
			"上板状态不满足条件<已完成，已到达>，不允许拆包":"上板状态不满足条件<已完成，已到达>，不允许拆包",
			"查询":"查询",
			"特殊单号":"特殊单号",
			"出货批次":"出货批次",
			"最小单票限制申报价值不能大于最大单票限制申报价值":"最小单票限制申报价值不能大于最大单票限制申报价值",
			"包号":"包号",
			"装包状态":"装包状态",
			"一次打印份数最多不能超过":"一次打印份数最多不能超过",
			"大包号":"大包号",
			"已合包，不允许拆包":"已合包，不允许拆包",
			"请选择装包状态为\"已建包\"的数据!":"请选择装包状态为\"已建包\"的数据!",
			"撤销装包异常":"撤销装包异常",
			"撤销完成成功！":"撤销完成成功！",
			"中进行打印":"中进行打印",
			"出货人":"出货人",
			"包号补打":"包号补打",
			"当前包状态不为\"已建包\", 不允许装包完成":"当前包状态不为\"已建包\", 不允许装包完成",
			"最小整包限制重量不能大于最大整包限制重量":"最小整包限制重量不能大于最大整包限制重量",
			"高(cm)":"高(cm)",
			"承运商":"承运商",
			"打印完成":"打印完成",
			"包中运单":"包中运单",
			"计划到达时间":"计划到达时间",
			"批量预打":"批量预打",
			"修改成功！":"修改成功！",
			"宽(cm)":"宽(cm)",
			"包号信息":"包号信息",
			"总件数":"总件数",
			"大包分拣码":"大包分拣码",
			"走货路线":"走货路线",
			"修改装包":"修改装包",
			"备注":"备注",
			"装包扫描":"装包扫描",
			"包材类型":"包材类型",
			"请至少勾选一行数据":"请至少勾选一行数据",
			"确定要撤销完成吗？":"确定要撤销完成吗？",
			"自动生成包号成功！":"自动生成包号成功！",
			"关闭":"关闭",
			"预打印过程":"预打印过程",
			"简体目的地":"简体目的地",
			"装包管理查询":"装包管理查询",
			"数据来源":"数据来源",
			"新增装包":"新增装包",
			"请选择一行数据":"请选择一行数据",
			"装包策略":"装包策略",
			"确定要撤销装包吗？":"确定要撤销装包吗？",
			"派件网点":"派件网点",
			"新增":"新增",
			"确定":"确定",
			"目的地编码":"目的地编码",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
			"添加成功！":"添加成功！",
			"拆包":"拆包",
			"货物类型":"货物类型",
			"目的国家简码":"目的国家简码",
			"生成包号异常！":"生成包号异常！",
			"总票数":"总票数",
			"份":"份",
			"运输方式":"运输方式",
			"走货路线(可多选)":"走货路线(可多选)",
			"整包限制重量（KG）":"整包限制重量（KG）",
			"货物类型(可多选)":"货物类型(可多选)",
			"预打印过程，实际为增加包号数据并完成打印的过程":"预打印过程，实际为增加包号数据并完成打印的过程",
			"一次打印份数最多不能超过100份":"一次打印份数最多不能超过100份",
			"如未正常输出打印，请到“装包管理”中，“打印.包号补打”中进行打印":"如未正常输出打印，请到“装包管理”中，“打印.包号补打”中进行打印",
			"尾程大包号":"尾程大包号",
			"打印尾程大包面单":"打印尾程大包面单",
		},
		"TMS114":{
			"轨迹匹配规则":"轨迹匹配规则",
			"清关轨迹匹配规则":"清关轨迹匹配规则",
			"清关信息设置":"清关信息设置",
			"清关路线":"清关路线",
			"序列":"序列",
			"轨迹状态":"轨迹状态",
			"轨迹名称":"轨迹名称",
			"轨迹阶段":"轨迹阶段",
			"轨迹类型":"轨迹类型",
			"匹配编码":"匹配编码",
			"修改人":"修改人",
			"修改时间":"修改时间",
			"清关供应商":"清关供应商",
			"正常":"正常",
			"启用":"启用",
			"路线编码":"路线编码",
			"路线名称":"路线名称",
			"清关行":"清关行",
			"路线英文":"路线英文",
			"路线简体":"路线简体",
			"路线分类":"路线分类",
			"目的地国家":"目的地国家",
			"备注":"备注",
			"建立时间":"建立时间",
			"建立人":"建立人",
			"路线编码/名称":"路线编码/名称",
			"启用状态":"启用状态",
			"查询":"查询",
			"重置":"重置",
			"新增":"新增",
			"修改":"修改",
			"删除":"删除",
			"导出":"导出",
			"分类编码(分类名称）":"分类编码(分类名称）",
			"分批转机":"分批转机",
			"批次数":"批次数",
			"推送清关数据":"推送清关数据",
			"推送状态":"推送状态",
			"待推送":"待推送",
			"推送中":"推送中",
			"推送成功":"推送成功",
			"推送失败":"推送失败",
			"基础信息":"基础信息",
			"目的地国家简码":"目的地国家简码",
			"特殊规则":"特殊规则",
			"规则json":"规则json",
			"保存":"保存",
			"关闭":"关闭",
			"新增清关路线":"新增清关路线",
			"编辑清关路线":"编辑清关路线",
			"请选择一行数据":"请选择一行数据",
			"新增成功":"新增成功",
			"修改成功":"修改成功",
			"此操作将删除该行数据, 是否继续?":"此操作将删除该行数据, 是否继续?",
			"提示":"提示",
			"确定":"确定",
			"取消":"取消",
			"删除成功":"删除成功",

		},
		"BMS028":{
        	"到达日":"到达日",
        	"启程日":"启程日",
			"车牌号":"车牌号",
        	"航班":"航班",
        	"出港路由":"出港路由",
			"可多选":"可多选",
			"出口清关关区":"出口清关关区",
			"入口清关关区":"入口清关关区",
			"自动生成总运单号规则":"自动生成总运单号规则",
			"注意:为保证总运单号严谨性，规则第三段和第五段必填":"注意:为保证总运单号严谨性，规则第三段和第五段必填",
			"承运信息":"承运信息",
			"序号":"序号",
			"操作":"操作",
			"分段":"分段",
			"运输方式":"运输方式",
			"承运商":"承运商",
			"航班/车牌号":"航班/车牌号",
			"启程日期":"启程日期",
			"启程时间":"启程时间",
			"到达日期":"到达日期",
			"到达时间":"到达时间",
			"目的港":"目的港",
			"保存并继续":"保存并继续",
			"确定要修改共享方式？":"确定要修改共享方式？",
			"取消":"取消",
			"确定":"确定",
			"共享给指定网点":"共享给指定网点",
			"网点列表":"网点列表",
			"指定网点":"指定网点",
			"保存":"保存",
			"关闭":"关闭",
        	"新增":"新增",
			"修改":"修改",
			"删除":"删除",
			"共享":"共享",
			"不共享":"不共享",
			"共享给所有":"共享给所有",
			"共享给指定":"共享给指定",
			"浏览":"浏览",
			"导出":"导出",
			"所属网点":"所属网点",
			"路由编码":"路由编码",
			"名称":"名称",
			"下一网点":"下一网点",
			"干线运输方式":"干线运输方式",
			"目的国家简码":"目的国家简码",
			"启用状态":"启用状态",
			"查询":"查询",
			"重置":"重置",
			"启用":"启用",
			"路由名称":"路由名称",
			"始发港":"始发港",
			"起运国家简码":"起运国家简码",
			"目的港国家简码":"目的港国家简码",
			"提单计抛":"提单计抛",
			"计费货物类型":"计费货物类型",
			"共享方式":"共享方式",
			"共享网点":"共享网点",
			"备注":"备注",
			"创建时间":"创建时间",
			"创建人":"创建人",
			"修改时间":"修改时间",
			"修改人":"修改人",

		},
		"TMS120":{
			"出库大包移交单":"出库大包移交单",
			"运单移交单":"运单移交单",
        	"小包分拣码":"小包分拣码",
			"修改":"修改",
			"请选择一行运单数据":"请选择一行运单数据",
			"修改成功":"修改成功",
			"出货批次发送时":"出货批次发送时",
			"关联承运信息成功！":"关联承运信息成功！",
			"请选择一条数据":"请选择一条数据",
			"交货承运代理必填":"交货承运代理必填",
			"查询":"查询",
			"保存":"保存",
			"出货批次":"出货批次",
			"已关联总运单包数":"已关联总运单包数",
			"新增出货批次":"新增出货批次",
			"出货批次管理":"出货批次管理",
			"出货批次状态不为\"已建立\",不允许修改":"出货批次状态不为\"已建立\",不允许修改",
			"确认撤销此出货批次数据吗？":"确认撤销此出货批次数据吗？",
			"关联承运信息异常！":"关联承运信息异常！",
			"创建人":"创建人",
			"撤销成功！":"撤销成功！",
			"总实重":"总实重",
			"出货批次策略":"出货批次策略",
			"发送人":"发送人",
			"请选择":"请选择",
			"出货批次状态不为“已发送”，无法撤销":"出货批次状态不为“已发送”，无法撤销",
			"交货承运代理":"交货承运代理",
			"基本信息":"基本信息",
			"出货批次数据":"出货批次数据",
			"}>状态<{":"}>状态<{",
			"批次状态":"批次状态",
			"验证方式":"验证方式",
			"可在出货批次管理中批量关联承运信息":"可在出货批次管理中批量关联承运信息",
			"出货批次单号<":"出货批次单号<",
			"司机电话":"司机电话",
			"车牌":"车牌",
			"修改人":"修改人",
			"打印完成":"打印完成",
			"多个用逗号分隔":"多个用逗号分隔",
			"请求参数：":"请求参数：",
			">出货批次状态不等于\"已建立\"":">出货批次状态不等于\"已建立\"",
			"批次日期":"批次日期",
			"撤销失败！":"撤销失败！",
			"当出货批次状态 <> \"已建立\", 不允许继续出货":"当出货批次状态 <> \"已建立\", 不允许继续出货",
			"修改出货批次":"修改出货批次",
			"当前没有选择出货批次，无法撤销":"当前没有选择出货批次，无法撤销",
			"大包分拣码":"大包分拣码",
			"总体积(m³)":"总体积(m³)",
			"备注":"备注",
			"发送时间":"发送时间",
			"撤销":"撤销",
			"出货网点":"出货网点",
			"关闭":"关闭",
			"重置":"重置",
			"当出货批次状态不是 \"已建立\", 不允许撤销":"当出货批次状态不是 \"已建立\", 不允许撤销",
			"浏览":"浏览",
			"撤销发送":"撤销发送",
			"修改时间":"修改时间",
			"}>（限制发送）":"}>（限制发送）",
			"发送":"发送",
			"保存成功":"保存成功",
			"出货批次存在扫描明细数据时，限制撤销":"出货批次存在扫描明细数据时，限制撤销",
			"交货司机":"交货司机",
			"保存异常":"保存异常",
			"新增":"新增",
			"确定":"确定",
			"提示":"提示",
			"出货":"出货",
			"出货批次<{":"出货批次<{",
			"注":"注",
			"是否撤销已发送出货批次?":"是否撤销已发送出货批次?",
			"撤销发送成功！":"撤销发送成功！",
			"撤销发送失败！":"撤销发送失败！",
			"打印":"打印",
			"关联承运信息":"关联承运信息",
			"导出":"导出",
			"保存并操作":"保存并操作",
			"总包数":"总包数",
			"目的国家简码":"目的国家简码",
			"请输入":"请输入",
			"取消":"取消",
			"创建时间":"创建时间",
			"该出货批次没有明细！":"该出货批次没有明细！",
			"请至少选择一行数据！":"请至少选择一行数据！",
			"总票数":"总票数",
			"交货承运信息":"交货承运信息",
			"出货实重":"出货实重",
			"生成接驳单":"生成接驳单",
			"走货路线":"走货路线"
		},
		"shipment2":{
			"批次日期":"批次日期",
			"宽(cm)":"宽(cm)",
			"请输入大包号!":"请输入大包号!",
			"的出货批次":"的出货批次",
			"扫描时间":"扫描时间",
			"固定显示当前网点最近":"固定显示当前网点最近",
			"大包分拣码":"大包分拣码",
			"包材类型":"包材类型",
			"当前行双击后":"当前行双击后",
			"请输入转运单号":"请输入转运单号",
			"扫描成功!":"扫描成功!",
			"出货批次":"出货批次",
			"请选择出货批次":"请选择出货批次",
			"出货批次管理":"出货批次管理",
			"将出货批次带入到扫描页面":"将出货批次带入到扫描页面",
			"请选择出货批次!":"请选择出货批次!",
			"发送":"发送",
			"包材重量":"包材重量",
			"大包号":"大包号",
			"核重重量":"核重重量",
			"出货批次策略":"出货批次策略",
			"黑体 Regular":"黑体 Regular",
			"注":"注",
			"长(cm)":"长(cm)",
			"请选择到件网点":"请选择到件网点",
			"已建立":"已建立",
			"重量":"重量",
			"选择批次":"选择批次",
			"扫描包数":"扫描包数",
			"高(cm)":"高(cm)",
			"目的国家简码":"目的国家简码",
			"天内":"天内",
			"总票数":"总票数",
			"出货批次信息":"出货批次信息"
		},
		"shipment2details":{
			"宽(cm)":"宽(cm)",
			"扫描时间":"扫描时间",
			"发送异常":"发送异常",
			"问题状态":"问题状态",
			"大包分拣码":"大包分拣码",
			"登记人":"登记人",
			"问题运单列表":"问题运单列表",
			"包材类型":"包材类型",
			"运单号码":"运单号码",
			"发送时间":"发送时间",
			"港前问题件处理完毕验证":"港前问题件处理完毕验证",
			"关闭":"关闭",
			"扫描大包号回车搜索":"扫描大包号回车搜索",
			"发送成功！":"发送成功！",
			"出货批次":"出货批次",
			"当前选择大包<":"当前选择大包<",
			"发送":"发送",
			"问题描述":"问题描述",
			"总实重":"总实重",
			"包材重量":"包材重量",
			"撤销大包":"撤销大包",
			"大包号":"大包号",
			"撤销大包异常":"撤销大包异常",
			"核重重量":"核重重量",
			"确定":"确定",
			"输入":"输入",
			"转单号码":"转单号码",
			"登记时间":"登记时间",
			"提示":"提示",
			"长(cm)":"长(cm)",
			">个，确认从出货批次中撤销吗？？":">个，确认从出货批次中撤销吗？？",
			"重量":"重量",
			"高(cm)":"高(cm)",
			"总包数":"总包数",
			"目的国家简码":"目的国家简码",
			"取消":"取消",
			"撤销大包成功！":"撤销大包成功！",
			"总票数":"总票数",
			"请选择数据！":"请选择数据！",
			"输入/扫描大包号回车搜索":"输入/扫描大包号回车搜索",
			"是否复核":"是否复核",
			"复核时间":"复核时间",
			"走货路线":"走货路线"
		},
		"TMS017":{
			"笔，确定重新发货吗?":"笔，确定重新发货吗?",
			"重新发货成功！":"重新发货成功！",
			"笔，确定取消退返吗?":"笔，确定取消退返吗?",
			"退返备注":"退返备注",
			"运单号码":"运单号码",
			"退返时间":"退返时间",
			"退返单号":"退返单号",
			"查询":"查询",
			"处理结果":"处理结果",
			"取消退返失败！":"取消退返失败！",
			"撤销退返申请":"撤销退返申请",
			"笔":"笔",
			"勾选的多条运单的客户必须是同一个才可打印！":"勾选的多条运单的客户必须是同一个才可打印！",
			"您选取的":"您选取的",
			"请选择申请退返时间":"请选择申请退返时间",
			"请选择数据":"请选择数据",
			"笔记录数据":"笔记录数据",
			"处理意见":"处理意见",
			"当前选择数据存在订单类型退返客户，不允许撤销退返申请":"当前选择数据存在订单类型退返客户，不允许撤销退返申请",
			"操作":"操作",
			"包含待处理问题件":"包含待处理问题件",
			"选择已退返数据":"选择已退返数据",
			"笔已退返客户":"笔已退返客户",
			"选择待处理数据":"选择待处理数据",
			"件数":"件数",
			"退返客户":"退返客户",
			"按当前时间发货":"按当前时间发货",
			"处理状态":"处理状态",
			"录单网点":"录单网点",
			"申请退返时间":"申请退返时间",
			"打印完成":"打印完成",
			"重新发货后，库存网点为当前操作网点，确认继续吗？?":"重新发货后，库存网点为当前操作网点，确认继续吗？?",
			"客户名称":"客户名称",
			"按原寄件日期发货":"按原寄件日期发货",
			"退返客户失败！":"退返客户失败！",
			"当前选择数据存在订单类型退返客户，不允许重新发货":"当前选择数据存在订单类型退返客户，不允许重新发货",
			"取消退返成功！":"取消退返成功！",
			"是否重新发货?":"是否重新发货?",
			"退返方式等于{第三方快递}时，退返单号必填":"退返方式等于{第三方快递}时，退返单号必填",
			"可处理笔数":"可处理笔数",
			"关闭":"关闭",
			"重置":"重置",
			"退返方式":"退返方式",
			"寄件网点":"寄件网点",
			"当前有选择问题件存在已退返客户或重新发货数据，请检查后重试":"当前有选择问题件存在已退返客户或重新发货数据，请检查后重试",
			"客户":"客户",
			"参考编号":"参考编号",
			"请选择已退返数据":"请选择已退返数据",
			"确定":"确定",
			"退返类型":"退返类型",
			"转单号码":"转单号码",
			"提示":"提示",
			"收费重":"收费重",
			"操作人":"操作人",
			"打印":"打印",
			"是否取消退返选择数据?":"是否取消退返选择数据?",
			"导出":"导出",
			"重新发货":"重新发货",
			"请输入":"请输入",
			"操作成功":"操作成功",
			"退返客户成功！":"退返客户成功！",
			"重新发货失败！":"重新发货失败！",
			"取消":"取消",
			"其中":"其中",
			"您选择{length}笔数据，其中{error}笔已退返客户，可处理{correct}笔！":"您选择{length}笔数据，其中{error}笔已退返客户，可处理{correct}笔！"
		},
		"TMS018":{
			"扫描时间":"扫描时间",
			"分拣码":"分拣码",
			"出货重":"出货重",
			">票，其中有<":">票，其中有<",
			"批量扫描":"批量扫描",
			"走货路线":"走货路线",
			"出货时间":"出货时间",
			"请输入扫描单号":"请输入扫描单号",
			"运单号码":"运单号码",
			"当前包中有<":"当前包中有<",
			"批量扫描运单异常":"批量扫描运单异常",
			"扫描票数":"扫描票数",
			"指定路线":"指定路线",
			"关闭":"关闭",
			"笔运成功扫描":"笔运成功扫描",
			"保存":"保存",
			"总运单号":"总运单号",
			"出货批次":"出货批次",
			">票已单独退件，是否继续将剩余<":">票已单独退件，是否继续将剩余<",
			"目的地":"目的地",
			">票做退件入库？":">票做退件入库？",
			"退件入库成功！":"退件入库成功！",
			"批量扫描运单成功！":"批量扫描运单成功！",
			"批量扫描运单":"批量扫描运单",
			"客户":"客户",
			"当前有":"当前有",
			"运单号码不能为空":"运单号码不能为空",
			"派件网点":"派件网点",
			"整包退件":"整包退件",
			"大包号":"大包号",
			"参考编号":"参考编号",
			"当整包退件时，将自动将包中明细全部转换为退件，是否继续？":"当整包退件时，将自动将包中明细全部转换为退件，是否继续？",
			"确定":"确定",
			"取消扫描！":"取消扫描！",
			"转单号码":"转单号码",
			"提示":"提示",
			"黑体 Regular":"黑体 Regular",
			"票":"票",
			"整包退件后":"整包退件后",
			"直接将装包明细转换为运单":"直接将装包明细转换为运单",
			"件数":"件数",
			"货物类型":"货物类型",
			"退件入库管理":"退件入库管理",
			"扫描单号":"扫描单号",
			"取消":"取消",
			"退件原因":"退件原因"
		},
		"bounnemanagement":{
			"请选择需要处理的退件数据":"请选择需要处理的退件数据",
			"请选择需要撤销入库的数据":"请选择需要撤销入库的数据",
			"处理信息":"处理信息",
			"分拣码":"分拣码",
			"出货重":"出货重",
			"选择的数据中存在已处理数据":"选择的数据中存在已处理数据",
			"撤销入库成功！":"撤销入库成功！",
			"当前退件处理运单笔数":"当前退件处理运单笔数",
			"走货路线":"走货路线",
			"出货时间":"出货时间",
			"退件类型":"退件类型",
			"运单号码":"运单号码",
			"指定路线":"指定路线",
			"查询":"查询",
			"关闭":"关闭",
			"退件处理":"退件处理",
			"处理结果":"处理结果",
			"保存":"保存",
			"撤销入库":"撤销入库",
			"重置":"重置",
			"总运单号":"总运单号",
			"出货批次":"出货批次",
			"退件处理失败！":"退件处理失败！",
			"目的地":"目的地",
			"客户":"客户",
			"已处理":"已处理",
			"派件网点":"派件网点",
			"大包号":"大包号",
			"退件处理成功！":"退件处理成功！",
			"参考编号":"参考编号",
			"转单号码":"转单号码",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
			"处理说明":"处理说明",
			"请选择":"请选择",
			"未处理天数":"未处理天数",
			"退件入库":"退件入库",
			"退回网点":"退回网点",
			"操作人":"操作人",
			"件数":"件数",
			"货物类型":"货物类型",
			"导出":"导出",
			"处理状态":"处理状态",
			"退件入库管理":"退件入库管理",
			"请输入":"请输入",
			"扫描单号":"扫描单号",
			"退件入库时间":"退件入库时间",
			"退件原因":"退件原因"
		},


		"managewaybill":{
        	"航班到达时间":"Flight arrival time",
        	"子运单号":"Subwaybill number",
			"booking模板":"booking模板",
        	"是否撤销锁定下列总运单号:":"是否撤销锁定下列总运单号:",
        	"总运单撤销锁定":"总运单撤销锁定",
        	"是否确认锁定下列总运单号:":"是否确认锁定下列总运单号:",
        	"总运单锁定确认":"总运单锁定确认",
			"出口清关抬头":"出口清关抬头",
			"入口清关关区":"入口清关关区",
			"出口清关关区":"出口清关关区",
        	"推送出口清关（正报）":"推送出口清关（正报）",
        	"获取HS Code":"获取HS Code",
			"下载干线booking模板":"下载干线booking模板",
        	"子运单箱号关系导入":"子运单箱号关系导入",
			"邮件推送结果":"邮件推送结果",
			"编辑附件":"编辑附件",
			"提单附件":"提单附件",
			"出口清关推送状态":"出口清关推送状态",
			"进口清关推送状态":"进口清关推送状态",
			"HScode数":"HScode数",
			"已获取HScode":"已获取HScode",
			"下载干线booking邮件":"下载干线booking邮件",
			"推送干线booking邮件":"推送干线booking邮件",
			"推送邮件":"推送邮件",
			"下载附件":"下载附件",
			"清关相关操作":"清关相关操作",
        	"Invoice维度报表":"Invoice维度报表",
        	"导入":"导入",
			"请先确认总运单后再操作推送清关数据!":'请先确认总运单后再操作推送清关数据!',
			"修改":"修改",
			"笔总运单":"笔总运单",
			"目的地港":"目的地港",
			"总体积":"总体积",
			"请选择状态为已建立的总运单":"请选择状态为已建立的总运单",
			"修改成功":"修改成功",
			"补录导入":"补录导入",
			"请输入提单重":"请输入提单重",
			"获取总运单信息异常":"获取总运单信息异常",
			"保存":"保存",
			"按件数生成":"按件数生成",
			"总运单号":"总运单号",
			"航班":"航班",
			"条，已出货":"条，已出货",
			"行的到达城市不能为空!":"行的到达城市不能为空!",
			"请选择提单计抛":"请选择提单计抛",
			"可多选":"可多选",
			"创建人":"创建人",
			"干线运输方式等于空运时，计费货物类型必填!":"干线运输方式等于空运时，计费货物类型必填!",
			"总运单信息":"总运单信息",
			"总实重":"总实重",
			"补录成功！":"补录成功！",
			"保存成功，成功":"保存成功，成功",
			"此操作将删除该承运信息, 是否继续?":"此操作将删除该承运信息, 是否继续?",
			"补录失败！":"补录失败！",
			"附件":"附件",
			"张":"张",
			"总运单状态不为“已建立”，无法撤销！":"总运单状态不为“已建立”，无法撤销！",
			"获取文件路径异常":"获取文件路径异常",
			"请选择":"请选择",
			"清单导出":"清单导出",
			"干线运输方式":"干线运输方式",
			"请选择总运单":"请选择总运单",
			"变更总运单日期成功！":"变更总运单日期成功！",
			"有退件":"有退件",
			"只能上传jpg/jpeg/png/pdf文件":"只能上传jpg/jpeg/png/pdf文件",
			"撤销确认":"撤销确认",
			"请勾选总运单":"请勾选总运单",
			"维度报表":"维度报表",
			"总运单管理":"总运单管理",
			"提单重需大于0，请重新输入":"提单重需大于0，请重新输入",
			"下一网点":"下一网点",
			"修改人":"修改人",
			"车牌号":"车牌号",
			"其他运输单号":"其他运输单号",
			"变更总运单日期异常！":"变更总运单日期异常！",
			"确认异常":"确认异常",
			"干线运输方式为空运，请录入提单图片后再确认":"干线运输方式为空运，请录入提单图片后再确认",
			"保存成功！":"保存成功！",
			"撤销失败！":"撤销失败！",
			"总运单确认":"总运单确认",
			"序号":"序号",
			"删除成功":"删除成功",
			"到达时间":"到达时间",
			"关联大包":"关联大包",
			"删除":"删除",
			"二程提单":"二程提单",
			"确认人":"确认人",
			"重置":"重置",
			"目的港":"目的港",
			"目的地":"目的地",
			"此操作将撤销总运单, 是否继续?":"此操作将撤销总运单, 是否继续?",
			"保存成功":"保存成功",
			"总运单不是已建立，无法修改!":"总运单不是已建立，无法修改!",
			"共选取":"共选取",
			"启程时间":"启程时间",
			"总运单状态不为“已确认”，无法补录！":"总运单状态不为“已确认”，无法补录！",
			"分段":"分段",
			"补":"补",
			"提示":"提示",
			"提单材重":"提单材重",
			"提单体积":"提单体积",
			"请输入提单材重":"请输入提单材重",
			"请选择需要打印的总运单":"请选择需要打印的总运单",
			"提单重":"提单重",
			"是否撤销已发送总运单?":"是否撤销已发送总运单?",
			"大包出货报表":"大包出货报表",
			"总运单日期":"总运单日期",
			"新增成功":"新增成功",
			"浏览总运单":"浏览总运单",
			"打印":"打印",
			"报关方式":"报关方式",
			"承运信息":"承运信息",
			"导出":"导出",
			"请输入":"请输入",
			"运单维度报表":"运单维度报表",
			"取消":"取消",
			"总运单":"总运单",
			"出货实重":"出货实重",
			"异常":"异常",
			"头程提单":"头程提单",
			"补录":"补录",
			"请选择寄件日期":"请选择寄件日期",
			"请核实":"请核实",
			"运单号码":"运单号码",
			"请确认承运信息与提单重量的完整性, 您真的要做总运单确认吗?":"请确认承运信息与提单重量的完整性, 您真的要做总运单确认吗?",
			"查询":"查询",
			"保存并确认":"保存并确认",
			"总运单不是已建立，无法添加预出货运单!":"总运单不是已建立，无法添加预出货运单!",
			"干线运输方式不等于<自交>时承运信息必填，请录入承运信息":"干线运输方式不等于<自交>时承运信息必填，请录入承运信息",
			"提单实重":"提单实重",
			"不超过":"不超过",
			"多笔运单回车换行输入":"多笔运单回车换行输入",
			"总运单状态等于已建立时，才允许变更总运单日期！":"总运单状态等于已建立时，才允许变更总运单日期！",
			"提单实重需大于0，请重新输入":"提单实重需大于0，请重新输入",
			"确认成功！":"确认成功！",
			"计费货物类型":"计费货物类型",
			"撤销成功！":"撤销成功！",
			"请勾选总运单!":"请勾选总运单!",
			"出港路由未设置承运信息，是否继续保存":"出港路由未设置承运信息，是否继续保存",
			"重量信息":"重量信息",
			"出港路由":"出港路由",
			"当前没有选择总运单，无法撤销":"当前没有选择总运单，无法撤销",
			"干线运输方式不等于自交时，头程提单必填":"干线运输方式不等于自交时，头程提单必填",
			"提单分组导出":"提单分组导出",
			"承运商":"承运商",
			"预出货":"预出货",
			"条，已预出货":"条，已预出货",
			"行的目的港不能为空!":"行的目的港不能为空!",
			"打印完成":"打印完成",
			"多个用逗号分隔":"多个用逗号分隔",
			"按转单子单":"按转单子单",
			"总运单状态":"总运单状态",
			"该总运单日期超过一个月，无法补录！":"该总运单日期超过一个月，无法补录！",
			"运输单号":"运输单号",
			"该总运单状态不为“已建立”，无法继续出货，请重新选择!":"该总运单状态不为“已建立”，无法继续出货，请重新选择!",
			"请谨慎操作":"请谨慎操作",
			"总运单打印":"总运单打印",
			"走货路线":"走货路线",
			"增加":"增加",
			"行的承运商不能为空!":"行的承运商不能为空!",
			"备注":"备注",
			"以上单号为失败单号":"以上单号为失败单号",
			"行的运输方式不能为空!":"行的运输方式不能为空!",
			"总运单类型不为\"已建立\"，无法关联大包":"总运单类型不为\"已建立\"，无法关联大包",
			"提单件数需大于0，请重新输入":"提单件数需大于0，请重新输入",
			"退件实重":"退件实重",
			"一次转飞港":"一次转飞港",
			"二次转飞港":"二次转飞港",
			"三次转飞港":"三次转飞港",
			"四次转飞港":"四次转飞港",
			"请选择一条数据导出!":"请选择一条数据导出!",
			"修改总运单":"修改总运单",
			"请至少勾选一行数据":"请至少勾选一行数据",
			"文件大小不能大于5M":"文件大小不能大于5M",
			"撤销":"撤销",
			"关闭":"关闭",
			"始发港":"始发港",
			"退件票数":"退件票数",
			"忽略补录总运单":"忽略补录总运单",
			"该总运单为补录单，无法修改!":"该总运单为补录单，无法修改!",
			"请输入提单实重":"请输入提单实重",
			"修改时间":"修改时间",
			"条，失败":"条，失败",
			"行的分段不能为空!":"行的分段不能为空!",
			"请选择一行数据":"请选择一行数据",
			"提单件数":"提单件数",
			"格式图片文件":"格式图片文件",
			"派件网点":"派件网点",
			"条，其中不存在运单":"条，其中不存在运单",
			"附件信息":"附件信息",
			"新增":"新增",
			"确定":"确定",
			"确认时间":"确认时间",
			"请选择总运单!":"请选择总运单!",
			"变更总运单日期":"变更总运单日期",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
			"条，已绑定其他":"条，已绑定其他",
			"按运单子单":"按运单子单",
			"请选择状态为已确认的总运单":"请选择状态为已确认的总运单",
			"您真的要补录总运单吗？（补录的总运单与原总运单相同日期；总运单号在原总运单上 + ‘-B’ + 1位流水号）":"您真的要补录总运单吗？（补录的总运单与原总运单相同日期；总运单号在原总运单上 + ‘-B’ + 1位流水号）",
			"新增总运单":"新增总运单",
			"提单图片":"提单图片",
			"确认信息":"确认信息",
			"总包数":"总包数",
			"目的国家简码":"目的国家简码",
			"提单计抛":"提单计抛",
			"确认":"确认",
			"创建时间":"创建时间",
			"承运信息第":"承运信息第",
			"只能上传":"只能上传",
			"操作网点":"操作网点",
			"总票数":"总票数",
			"总运单状态不为“已发送”，无法撤销":"总运单状态不为“已发送”，无法撤销",
			"特殊报表":"特殊报表",
			"干线运输方式为“自交”时，无需填写承运信息":"干线运输方式为“自交”时，无需填写承运信息",
			"运输方式":"运输方式",
			"航班/车牌号":"航班/车牌号",
			"Spring Post 预报 只允许大包维度导出!":"Spring Post 预报 只允许大包维度导出!",
			"清关路线":"清关路线",
			"推送状态":"推送状态",
			"推送清关数据":"推送清关数据",
			"分批转机":"分批转机",
			"批次数":"批次数",
			"起运国家简码":"起运国家简码",
			"目的港国家简码":"目的港国家简码",
		},
		"sendwaybill":{
			",非出港路由目的地":",非出港路由目的地",
			"当前总运单没有装包数据！":"当前总运单没有装包数据！",
			"票数":"票数",
			"登记人":"登记人",
			"请输入提单重":"请输入提单重",
			"选择板异常":"选择板异常",
			"获取总运单信息异常":"获取总运单信息异常",
			"选择":"选择",
			"保存":"保存",
			"总运单号":"总运单号",
			"航班":"航班",
			"发送成功！":"发送成功！",
			"笔":"笔",
			"建包日期":"建包日期",
			"选取板":"选取板",
			"请选择提单计抛":"请选择提单计抛",
			"选择运单异常":"选择运单异常",
			"总运单信息":"总运单信息",
			"总实重":"总实重",
			"单号类型":"单号类型",
			"附件":"附件",
			"张":"张",
			"请选择":"请选择",
			"干线运输方式":"干线运输方式",
			"注意":"注意",
			"核重重量(kg)":"核重重量(kg)",
			"只能上传jpg/jpeg/png/pdf文件":"只能上传jpg/jpeg/png/pdf文件",
			"提单重需大于0，请重新输入":"提单重需大于0，请重新输入",
			"下一网点":"下一网点",
			"异常说明":"异常说明",
			",报关方式不符":",报关方式不符",
			"笔，失败":"笔，失败",
			"扫描单号":"扫描单号",
			"车牌号":"车牌号",
			"其他运输单号":"其他运输单号",
			"确认异常":"确认异常",
			"保存成功！":"保存成功！",
			"撤销失败！":"撤销失败！",
			"总运单确认":"总运单确认",
			"库存件数":"库存件数",
			"序号":"序号",
			"上板日期":"上板日期",
			"显示包":"显示包",
			"上板策略":"上板策略",
			"关联时间":"关联时间",
			",走货路线不符":",走货路线不符",
			"选择运单成功！":"选择运单成功！",
			"二程提单":"二程提单",
			"重置":"重置",
			"请输入大包号回车搜索":"请输入大包号回车搜索",
			"目的港":"目的港",
			"板号":"板号",
			"寄件网点":"寄件网点",
			"选择板":"选择板",
			"目的地":"目的地",
			"录入提单重后未及时确认":"录入提单重后未及时确认",
			"撤销大包":"撤销大包",
			"撤销运单":"撤销运单",
			"入库时间":"入库时间",
			"分段":"分段",
			"转单号码":"转单号码",
			"提示":"提示",
			"提单材重":"提单材重",
			"请输入提单材重":"请输入提单材重",
			"提单重":"提单重",
			"长(cm)":"长(cm)",
			"选择包成功！":"选择包成功！",
			"选择板成功":"选择板成功",
			"报关方式":"报关方式",
			"承运信息":"承运信息",
			"请输入":"请输入",
			"选择运单成功":"选择运单成功",
			"取消":"取消",
			"出货批次号":"出货批次号",
			"选择运单":"选择运单",
			"出货实重":"出货实重",
			"头程提单":"头程提单",
			"发送异常":"发送异常",
			"问题状态":"问题状态",
			"重量(kg)":"重量(kg)",
			"上板状态":"上板状态",
			"运单号码":"运单号码",
			",客户锁机":",客户锁机",
			"操作员":"操作员",
			"请确认承运信息与提单重量的完整性, 您真的要做总运单确认吗?":"请确认承运信息与提单重量的完整性, 您真的要做总运单确认吗?",
			"有部分运单包含在其他总运单中或少件未出，是否继续发送?":"有部分运单包含在其他总运单中或少件未出，是否继续发送?",
			"查询":"查询",
			"系统将在":"系统将在",
			"保存并确认":"保存并确认",
			"特殊单号":"特殊单号",
			"出货批次":"出货批次",
			"提单实重":"提单实重",
			"撤销包关联":"撤销包关联",
			"不超过":"不超过",
			"装包状态":"装包状态",
			"问题描述":"问题描述",
			",非预出货运单":",非预出货运单",
			"提单实重需大于0，请重新输入":"提单实重需大于0，请重新输入",
			"确认成功！":"确认成功！",
			"撤销成功！":"撤销成功！",
			"包材重量":"包材重量",
			"大包号":"大包号",
			"当前总运单没有上板数据！":"当前总运单没有上板数据！",
			"重量信息":"重量信息",
			"出货总运单":"出货总运单",
			"出港路由":"出港路由",
			"选择包成功":"选择包成功",
			"待出件数":"待出件数",
			"当前没有数据，无法选择":"当前没有数据，无法选择",
			"天后自动确认该总运单":"天后自动确认该总运单",
			"打印参数:":"打印参数:",
			"选取待出货运单":"选取待出货运单",
			",排货状态不符":",排货状态不符",
			"干线运输方式不等于自交时，头程提单必填":"干线运输方式不等于自交时，头程提单必填",
			"高(cm)":"高(cm)",
			"承运商":"承运商",
			"行的目的港不能为空!":"行的目的港不能为空!",
			"预出货异常":"预出货异常",
			"运输单号":"运输单号",
			"宽(cm)":"宽(cm)",
			"扫描时间":"扫描时间",
			"排货状态":"排货状态",
			"扫描件数":"扫描件数",
			"总件数":"总件数",
			"大包分拣码":"大包分拣码",
			"走货路线":"走货路线",
			"行的承运商不能为空!":"行的承运商不能为空!",
			"备注":"备注",
			"选择包异常":"选择包异常",
			"问题运单列表":"问题运单列表",
			"包材类型":"包材类型",
			"提单件数需大于0，请重新输入":"提单件数需大于0，请重新输入",
			"行的运输方式不能为空!":"行的运输方式不能为空!",
			"显示板":"显示板",
			">吗?":">吗?",
			"文件大小不能大于5M":"文件大小不能大于5M",
			"撤销":"撤销",
			"关闭":"关闭",
			"始发港":"始发港",
			"总价值":"总价值",
			"没有已排货运单，无法选择":"没有已排货运单，无法选择",
			"选取大包":"选取大包",
			"真的要撤销运单<":"真的要撤销运单<",
			"请输入提单实重":"请输入提单实重",
			"请输入出货件数":"请输入出货件数",
			"撤销板关联":"撤销板关联",
			"提单件数":"提单件数",
			"客户":"客户",
			"格式图片文件":"格式图片文件",
			"派件网点":"派件网点",
			"寄件日期":"寄件日期",
			"附件信息":"附件信息",
			"参考编号":"参考编号",
			"大包号码":"大包号码",
			"建板日期":"建板日期",
			"确定":"确定",
			"当前运单是包中运单或板中运单，无法单独撤销!":"当前运单是包中运单或板中运单，无法单独撤销!",
			"登记时间":"登记时间",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
			"走货路线分类":"走货路线分类",
			"当前没有数据，无法撤销!":"当前没有数据，无法撤销!",
			"确认信息":"确认信息",
			"货物类型":"货物类型",
			"总包数":"总包数",
			"目的国家简码":"目的国家简码",
			"提单计抛":"提单计抛",
			"确定要撤销大包吗?":"确定要撤销大包吗?",
			"承运信息第":"承运信息第",
			"只能上传":"只能上传",
			"总票数":"总票数",
			"无有效数据，无法选择":"无有效数据，无法选择",
			"当前没有数据，无法撤销":"当前没有数据，无法撤销",
			"选择板成功！":"选择板成功！",
			"运输方式":"运输方式",
			"航班/车牌号":"航班/车牌号",
		},
		"zydglimport":{
			"历史日志":"历史日志",
			"成功":"成功",
			"状态":"状态",
			"导入中":"导入中",
			"上传失败":"上传失败",
			"单号":"单号",
			"导入文件不能超过10MB":"导入文件不能超过10MB",
			"验证中":"验证中",
			"批次号":"批次号",
			"验证失败":"验证失败",
			"解析中":"解析中",
			"请选择导入模版！":"请选择导入模版！",
			"失败":"失败",
			"解析失败":"解析失败",
			"导入":"导入",
			"导入历史日志":"导入历史日志",
			"总行数":"总行数",
			"请选择模版！":"请选择模版！",
			"导入时间":"导入时间",
			"补录导入成功":"补录导入成功",
			"导入成功才可下载":"导入成功才可下载",
			"模版下载":"模版下载",
			"错误说明":"错误说明",
			"导入文件":"导入文件",
			"请输入":"请输入",
			"文件下载":"文件下载",
			"上传中":"上传中",
			"错误行数":"错误行数",
			"导入模版":"导入模版"
		},
		"TMS032":{
			"追踪状态":"追踪状态",
			"最新状态时间":"最新状态时间",
			"批量录入轨迹":"批量录入轨迹",
			"日志信息":"日志信息",
			"入口清关扣查票数":"入口清关扣查票数",
			"轨迹状态":"轨迹状态",
			"出货日期不能为空":"出货日期不能为空",
			"轨迹描述":"轨迹描述",
			"运输号码为空":"运输号码为空",
			"助手返回任务id失败":"助手返回任务id失败",
			"笔总运单中补录轨迹":"笔总运单中补录轨迹",
			"保存":"保存",
			"总运单号":"总运单号",
			"航班":"航班",
			"总运单信息":"总运单信息",
			"补录成功！":"补录成功！",
			"失败":"失败",
			"操作":"操作",
			"航班起飞时间":"航班起飞时间",
			"出口清关开始":"出口清关开始",
			"出口清关扣查":"出口清关扣查",
			"出口清关扣件不放行":"出口清关扣件不放行",
			"轨迹地点不能为空!":"轨迹地点不能为空!",
			"导入轨迹":"导入轨迹",
			"干线运输方式":"干线运输方式",
			"注意":"注意",
			"其他":"其他",
			"请选择总运单":"请选择总运单",
			"扫描编码":"扫描编码",
			"清关代理":"清关代理",
			"下一网点":"下一网点",
			"批量录入异常":"批量录入异常",
			"出货件数":"出货件数",
			"车牌号":"车牌号",
			"其他运输单号":"其他运输单号",
			"没有查询到当前总运单关联的运单":"没有查询到当前总运单关联的运单",
			"问题件登记":"问题件登记",
			"追踪进行中，请稍候查询":"追踪进行中，请稍候查询",
			"交货给干线代理":"交货给干线代理",
			"出口清关成功":"出口清关成功",
			"交货到末公里":"交货到末公里",
			"序号":"序号",
			"录入成功！":"录入成功！",
			"删除成功":"删除成功",
			"错误原因":"错误原因",
			"删除":"删除",
			"二程提单":"二程提单",
			"出货票数":"出货票数",
			"重置":"重置",
			"轨迹时间":"轨迹时间",
			"需要追踪的数据不能为空":"需要追踪的数据不能为空",
			"共选取":"共选取",
			"所有存在异常":"所有存在异常",
			"追踪网络为空":"追踪网络为空",
			"提示":"提示",
			"运输号码":"运输号码",
			"已有一笔科目相同的账单，是否继续？":"已有一笔科目相同的账单，是否继续？",
			"总运单日期":"总运单日期",
			"新增成功":"新增成功",
			"报关方式":"报关方式",
			"补录异常":"补录异常",
			"导出":"导出",
			"获取扫描状态异常":"获取扫描状态异常",
			"请输入":"请输入",
			"取消":"取消",
			"入口清关成功":"入口清关成功",
			"只查看含承运分段":"只查看含承运分段",
			"出货实重":"出货实重",
			"批量登记":"批量登记",
			"头程提单":"头程提单",
			"笔总运单数据":"笔总运单数据",
			"到达城市":"到达城市",
			"导出日志":"导出日志",
			"总运单确认后才允许操作轨迹":"总运单确认后才允许操作轨迹",
			"获取承运信息异常":"获取承运信息异常",
			"成功":"成功",
			"刷新到达信息成功！":"刷新到达信息成功！",
			"追踪日志":"追踪日志",
			"全部":"全部",
			"轨迹地点":"轨迹地点",
			"操作员":"操作员",
			"查询":"查询",
			"只能选择一行数据进行问题件登记":"只能选择一行数据进行问题件登记",
			"没有数据可以导出！":"没有数据可以导出！",
			"总数":"总数",
			"查询追踪数据中,请稍候":"查询追踪数据中,请稍候",
			"请勾选总运单!":"请勾选总运单!",
			"承运代理":"承运代理",
			"物流助手初始化失败,请稍后重试":"物流助手初始化失败,请稍后重试",
			"追踪网络":"追踪网络",
			"航班号":"航班号",
			"批量录入成功！":"批量录入成功！",
			"出港路由":"出港路由",
			"刷新完成！":"刷新完成！",
			"轨迹信息":"轨迹信息",
			"干线轨迹追踪":"干线轨迹追踪",
			"跟踪记录":"跟踪记录",
			"干线扫描状态":"干线扫描状态",
			"录入异常":"录入异常",
			"承运商":"承运商",
			"干线承运信息":"干线承运信息",
			"运输单号":"运输单号",
			"刷新扣查票数":"刷新扣查票数",
			"出发城市":"出发城市",
			"运输单号补录":"运输单号补录",
			"走货路线":"走货路线",
			"轨迹时间不能为空!":"轨迹时间不能为空!",
			"备注":"备注",
			"关闭":"关闭",
			"始发港":"始发港",
			"请输入运单号码":"请输入运单号码",
			"录入轨迹":"录入轨迹",
			"请选择一行数据":"请选择一行数据",
			"请选择至少一行数据":"请选择至少一行数据",
			"刷新到达信息异常":"刷新到达信息异常",
			"派件网点":"派件网点",
			"确定":"确定",
			"轨迹时间不能小于之前的轨迹时间!":"轨迹时间不能小于之前的轨迹时间!",
			"请选择总运单!":"请选择总运单!",
			"航班抵达时间":"航班抵达时间",
			"最新状态":"最新状态",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
			"--请求轨迹原数据失败--":"--请求轨迹原数据失败--",
			"补录费用":"补录费用",
			"错误日志":"错误日志",
			"将在":"将在",
			"操作方式":"操作方式",
			"只能选择一行数据进行补录":"只能选择一行数据进行补录",
			"获取运单信息异常":"获取运单信息异常",
			"目的国家简码":"目的国家简码",
			"超2天未更新":"超2天未更新",
			"操作网点":"操作网点",
			"编辑轨迹":"编辑轨迹",
			"运输方式":"运输方式",
			"航班/车牌号":"航班/车牌号",
		},
		"gxgjglimport":{
			"历史日志":"历史日志",
			"成功":"成功",
			"状态":"状态",
			"导入中":"导入中",
			"上传失败":"上传失败",
			"导入文件不能超过10MB":"导入文件不能超过10MB",
			"验证中":"验证中",
			"批次号":"批次号",
			"验证失败":"验证失败",
			"解析中":"解析中",
			"请选择导入模版！":"请选择导入模版！",
			"总运单/提单号":"总运单/提单号",
			"干线轨迹导入成功":"干线轨迹导入成功",
			"失败":"失败",
			"解析失败":"解析失败",
			"导入":"导入",
			"导入历史日志":"导入历史日志",
			"总行数":"总行数",
			"请选择模版！":"请选择模版！",
			"导入时间":"导入时间",
			"导入成功才可下载":"导入成功才可下载",
			"模版下载":"模版下载",
			"错误说明":"错误说明",
			"导入文件":"导入文件",
			"请输入":"请输入",
			"文件下载":"文件下载",
			"上传中":"上传中",
			"行号":"行号",
			"错误行数":"错误行数",
			"导入模版":"导入模版"
		},
		"TMS014":{
			"只能上传jpg/png/word/excel/pdf文件":"只能上传jpg/png/word/excel/pdf文件",
			"问题单号":"问题单号",
			"问题状态":"问题状态",
			"登记人":"登记人",
			"登记成功！":"登记成功！",
			"小时":"小时",
			"运单号码":"运单号码",
			"关闭":"关闭",
			"批量登记异常":"批量登记异常",
			"当前":"当前",
			"回复提交":"回复提交",
			"输入处理意见后":"输入处理意见后",
			"可多选":"可多选",
			"多笔运单回车换行输入":"多笔运单回车换行输入",
			"问题件通知人":"问题件通知人",
			"登记":"登记",
			"问题描述":"问题描述",
			"指定处理人":"指定处理人",
			"当前有":"当前有",
			"附件":"附件",
			"参考编号":"参考编号",
			"确定":"确定",
			"文件大小不能大于15MB":"文件大小不能大于15MB",
			"通知人":"通知人",
			"批量登记成功！":"批量登记成功！",
			"笔单号问题件已存在，不允许重复登记":"笔单号问题件已存在，不允许重复登记",
			"转单号码":"转单号码",
			"提示":"提示",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
			"笔运单未能成功登记问题件":"笔运单未能成功登记问题件",
			"登记网点":"登记网点",
			"处理时限":"处理时限",
			"问题件信息":"问题件信息",
			"导入登记":"导入登记",
			"可":"可",
			"处理网点":"处理网点",
			"文件还未上传成功，请等待文件上传成功后再登记！":"文件还未上传成功，请等待文件上传成功后再登记！",
			"处理状态":"处理状态",
			"请输入":"请输入",
			"获取运单信息失败！":"获取运单信息失败！",
			"取消":"取消",
			"登记异常":"登记异常",
			"获取问题状态信息失败！":"获取问题状态信息失败！",
			">存在未处理完成问题件，确定继续登记吗？":">存在未处理完成问题件，确定继续登记吗？",
			"问题件登记":"问题件登记",
			"批量登记":"批量登记",
			"截止处理时间":"截止处理时间",
			"输入处理意见后可回复提交":"输入处理意见后可回复提交",
			"通知人可多选":"通知人可多选",
			"处理时限(H)":"处理时限(H)",
			"运单号码(多笔运单回车换行输入)":"运单号码(多笔运单回车换行输入)",
		},
		"gqwtjimport":{
			"历史日志":"历史日志",
			"成功":"成功",
			"状态":"状态",
			"导入中":"导入中",
			"上传失败":"上传失败",
			"导入文件不能超过10MB":"导入文件不能超过10MB",
			"运单号码":"运单号码",
			"验证中":"验证中",
			"验证失败":"验证失败",
			"解析中":"解析中",
			"请选择导入模版！":"请选择导入模版！",
			"失败":"失败",
			"解析失败":"解析失败",
			"导入":"导入",
			"导入历史日志":"导入历史日志",
			"总行数":"总行数",
			"请选择模版！":"请选择模版！",
			"导入时间":"导入时间",
			"导入成功才可下载":"导入成功才可下载",
			"模版下载":"模版下载",
			"港后问题件导入成功":"港后问题件导入成功",
			"错误说明":"错误说明",
			"导入文件":"导入文件",
			"请输入":"请输入",
			"文件下载":"文件下载",
			"上传中":"上传中",
			"行号":"行号",
			"错误行数":"错误行数",
			"导入模版":"导入模版"
		},
		"ghwtjimport":{
			"历史日志":"历史日志",
			"成功":"成功",
			"状态":"状态",
			"导入中":"导入中",
			"上传失败":"上传失败",
			"导入文件不能超过10MB":"导入文件不能超过10MB",
			"运单号码":"运单号码",
			"验证中":"验证中",
			"验证失败":"验证失败",
			"解析中":"解析中",
			"请选择导入模版！":"请选择导入模版！",
			"失败":"失败",
			"解析失败":"解析失败",
			"导入":"导入",
			"导入历史日志":"导入历史日志",
			"总行数":"总行数",
			"请选择模版！":"请选择模版！",
			"导入时间":"导入时间",
			"导入成功才可下载":"导入成功才可下载",
			"模版下载":"模版下载",
			"港后问题件导入成功":"港后问题件导入成功",
			"错误说明":"错误说明",
			"导入文件":"导入文件",
			"请输入":"请输入",
			"文件下载":"文件下载",
			"上传中":"上传中",
			"行号":"行号",
			"错误行数":"错误行数",
			"导入模版":"导入模版"
		},
		"TMS015":{
			"港前问题件查询导出":"港前问题件查询导出",
			"最新回复人":"最新回复人",
			"寄件邮箱":"寄件邮箱",
			"登记人":"登记人",
			"指定路线":"指定路线",
			"回复成功！":"回复成功！",
			"处理结果":"处理结果",
			"部门":"部门",
			"笔":"笔",
			"问题相关":"问题相关",
			"请选择一笔数据作为查询客户联系人！":"请选择一笔数据作为查询客户联系人！",
			"附件":"附件",
			"获取文件路径异常":"获取文件路径异常",
			"通知人":"通知人",
			"费用补录":"费用补录",
			"问题类型":"问题类型",
			"寄件人":"寄件人",
			"登记网点":"登记网点",
			"确定申请退返客户吗?":"确定申请退返客户吗?",
			"问题件信息":"问题件信息",
			"处理状态":"处理状态",
			"客户名称":"客户名称",
			"笔已处理":"笔已处理",
			"截止处理时间":"截止处理时间",
			"手机":"手机",
			"港前问题件处理导出":"港前问题件处理导出",
			"可处理笔数":"可处理笔数",
			"重置":"重置",
			"创建导出任务，请稍后在导出列表中下载！":"创建导出任务，请稍后在导出列表中下载！",
			"问题件通知人":"问题件通知人",
			"指定处理人":"指定处理人",
			"费用补录管理":"费用补录管理",
			"转单号码":"转单号码",
			"提示":"提示",
			"费用批量补录":"费用批量补录",
			"请选择运单！":"请选择运单！",
			"最新回复时间":"最新回复时间",
			"通知客户":"通知客户",
			"打印":"打印",
			"批量补录":"批量补录",
			"回复异常":"回复异常",
			"导出":"导出",
			"请输入":"请输入",
			"取消":"取消",
			"只能打印一个问题件":"只能打印一个问题件",
			"其中":"其中",
			"只能上传jpg/png/word/excel/pdf文件":"只能上传jpg/png/word/excel/pdf文件",
			"联系人":"联系人",
			"选中待处理问题件":"选中待处理问题件",
			"问题状态":"问题状态",
			"全部":"全部",
			"业务电话":"业务电话",
			"运单号码":"运单号码",
			"邮箱地址":"邮箱地址",
			"选中单号状态必须为待处理":"选中单号状态必须为待处理",
			"查询":"查询",
			"寄件电话":"寄件电话",
			"您选取的":"您选取的",
			"问题描述":"问题描述",
			"登记日期不能为空":"登记日期不能为空",
			"问题件批量回复":"问题件批量回复",
			"申请退返":"申请退返",
			"收费材重":"收费材重",
			"客户联系人":"客户联系人",
			"处理意见":"处理意见",
			"文件大小不能大于15MB":"文件大小不能大于15MB",
			"处理网点":"处理网点",
			"待处理":"待处理",
			"处理中":"处理中",
			"打印完成":"打印完成",
			"费用补录申请":"费用补录申请",
			"笔问题件数据":"笔问题件数据",
			"目的地名称":"目的地名称",
			"含子客户":"含子客户",
			"最新回复":"最新回复",
			"通知成功！":"通知成功！",
			"备注":"备注",
			"港前问题件处理":"港前问题件处理",
			"批量回复成功！":"批量回复成功！",
			"关闭":"关闭",
			"销售员":"销售员",
			"笔无需回复":"笔无需回复",
			"请选择一行数据":"请选择一行数据",
			"处理状态不能为空!":"处理状态不能为空!",
			"登记日期":"登记日期",
			"请选择至少一行数据":"请选择至少一行数据",
			"笔,确认已通知客户？":"笔,确认已通知客户？",
			"跟单员":"跟单员",
			"客户":"客户",
			"参考编号":"参考编号",
			"确定":"确定",
			"目的地编码":"目的地编码",
			"回复":"回复",
			"登记时间":"登记时间",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
			"收费重":"收费重",
			"收费实重":"收费实重",
			"运单导入修改":"运单导入修改",
			"运单修改":"运单修改",
			"传真":"传真",
			"费用补录新增":"费用补录新增",
			"笔问题件数据，其中":"笔问题件数据，其中",
			"笔无需回复，可处理笔数":"笔无需回复，可处理笔数",
		},

		"TMS016":{
			"只能上传jpg/png/word/excel/pdf文件":"只能上传jpg/png/word/excel/pdf文件",
			"港前问题件查询导出":"港前问题件查询导出",
			"最新回复人":"最新回复人",
			"寄件邮箱":"寄件邮箱",
			"问题状态":"问题状态",
			"登记人":"登记人",
			"运单号码":"运单号码",
			"确定要删除该数据吗?":"确定要删除该数据吗?",
			"问题状态不为待处理的问题件！":"问题状态不为待处理的问题件！",
			"指定路线":"指定路线",
			"查询":"查询",
			"回复成功！":"回复成功！",
			"处理结果":"处理结果",
			"笔":"笔",
			"寄件电话":"寄件电话",
			"处理完毕时间":"处理完毕时间",
			"请勾选一行数据":"请勾选一行数据",
			"您选取的":"您选取的",
			"问题件交接":"问题件交接",
			"问题描述":"问题描述",
			"登记日期不能为空":"登记日期不能为空",
			"问题件批量回复":"问题件批量回复",
			"申请退返":"申请退返",
			"附件":"附件",
			"获取文件路径异常":"获取文件路径异常",
			"收费材重":"收费材重",
			"处理意见":"处理意见",
			"文件大小不能大于15MB":"文件大小不能大于15MB",
			"问题类型":"问题类型",
			"登记网点":"登记网点",
			"寄件人":"寄件人",
			"接收人":"接收人",
			"确定申请退返客户吗?":"确定申请退返客户吗?",
			"问题件信息":"问题件信息",
			"接收网点":"接收网点",
			"处理网点":"处理网点",
			"科目":"科目",
			"件数":"件数",
			"处理状态":"处理状态",
			"待处理":"待处理",
			"打印完成":"打印完成",
			"笔问题件数据":"笔问题件数据",
			"请选择至少一行可处理数据":"请选择至少一行可处理数据",
			"客户名称":"客户名称",
			"第一次回复时间":"第一次回复时间",
			"目的地名称":"目的地名称",
			"笔已处理":"笔已处理",
			"截止处理时间":"截止处理时间",
			"交接备注":"交接备注",
			"最新回复":"最新回复",
			"删除成功":"删除成功",
			"批量回复成功！":"批量回复成功！",
			"可处理笔数":"可处理笔数",
			"删除":"删除",
			"关闭":"关闭",
			"交接信息":"交接信息",
			"重置":"重置",
			"笔无需回复":"笔无需回复",
			"寄件公司":"寄件公司",
			"创建导出任务，请稍后在导出列表中下载！":"创建导出任务，请稍后在导出列表中下载！",
			"请选择一行数据":"请选择一行数据",
			"问题件通知人":"问题件通知人",
			"处理状态不能为空!":"处理状态不能为空!",
			"请选择至少一行数据":"请选择至少一行数据",
			"指定处理人":"指定处理人",
			"请勾选未处理完的问题件":"请勾选未处理完的问题件",
			"参考编号":"参考编号",
			"确定":"确定",
			"目的地编码":"目的地编码",
			"回复":"回复",
			"登记时间":"登记时间",
			"转单号码":"转单号码",
			"提示":"提示",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
			"收费重":"收费重",
			"最新回复时间":"最新回复时间",
			"收费实重":"收费实重",
			"打印":"打印",
			"问题件交接成功！":"问题件交接成功！",
			"回复异常":"回复异常",
			"导出":"导出",
			"请输入":"请输入",
			"港前问题件查询":"港前问题件查询",
			"取消":"取消",
			"只能打印一个问题件":"只能打印一个问题件",
			"其中":"其中",
			"金额":"金额",
			"笔，其中":"笔，其中",
			"笔已处理，":"笔已处理，",
			"笔无需回复，可处理笔数":"笔无需回复，可处理笔数",
		},
		"TMS057":{
			"立刻处理的可直接写入处理说明":"立刻处理的可直接写入处理说明",
			"只能上传jpg/png/word/excel/pdf文件":"只能上传jpg/png/word/excel/pdf文件",
			"修改":"修改",
			"国外退件":"国外退件",
			"问题状态":"问题状态",
			"登记人":"登记人",
			"登记成功！":"登记成功！",
			"运单号码":"运单号码",
			"截止日期不能小于当前日期！":"截止日期不能小于当前日期！",
			"回复成功！":"回复成功！",
			"处理结果":"处理结果",
			"多笔单号回车换行输入":"多笔单号回车换行输入",
			"可多选":"可多选",
			"登记":"登记",
			"导入登记":"导入登记",
			"问题描述":"问题描述",
			"当前有":"当前有",
			"附件":"附件",
			"获取文件路径异常":"获取文件路径异常",
			"处理?":"处理?",
			"处理意见":"处理意见",
			"文件大小不能大于15MB":"文件大小不能大于15MB",
			"通知人":"通知人",
			"运单做\\":"运单做\\",
			"笔单号问题件已存在，不允许重复登记":"笔单号问题件已存在，不允许重复登记",
			"登记网点":"登记网点",
			"问题件信息":"问题件信息",
			"需回复":"需回复",
			"处理网点":"处理网点",
			"处理状态":"处理状态",
			"登记异常":"登记异常",
			"问题件登记":"问题件登记",
			"截止处理时间":"截止处理时间",
			"问题单号":"问题单号",
			"确定对":"确定对",
			"处理意见有值时，处理状态不能为待处理":"处理意见有值时，处理状态不能为待处理",
			"处理内容选填":"处理内容选填",
			"关闭":"关闭",
			"批量登记异常":"批量登记异常",
			"当前":"当前",
			"销毁":"销毁",
			"回复提交":"回复提交",
			"退客户海外仓":"退客户海外仓",
			"输入处理意见后":"输入处理意见后",
			"处理状态不能为空!":"处理状态不能为空!",
			"二次销售":"二次销售",
			"登记日期":"登记日期",
			"指定处理人":"指定处理人",
			"客户信息":"客户信息",
			"参考编号":"参考编号",
			"确定":"确定",
			"问题件回复":"问题件回复",
			"批量登记成功！":"批量登记成功！",
			"回复":"回复",
			"转单号码":"转单号码",
			"提示":"提示",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
			"笔运单未能成功登记问题件":"笔运单未能成功登记问题件",
			"可":"可",
			"文件还未上传成功，请等待文件上传成功后再登记！":"文件还未上传成功，请等待文件上传成功后再登记！",
			"回复异常":"回复异常",
			"请输入":"请输入",
			"获取运单信息失败！":"获取运单信息失败！",
			"取消":"取消",
			"获取问题状态信息失败！":"获取问题状态信息失败！",
			"批量登记":"批量登记",
			"输入处理意见后，可Enter回复提交":"输入处理意见后，可Enter回复提交",
			"处理内容选填，立刻处理的可直接写入处理说明":"处理内容选填，立刻处理的可直接写入处理说明",
			"通知人(可多选)":"通知人(可多选)",
			"问题单号(多笔单号回车换行输入)":"问题单号(多笔单号回车换行输入)",
		},
		"TMS058":{
			"修改":"修改",
			"登记人":"登记人",
			"截止时间":"截止时间",
			"指定路线":"指定路线",
			"港后问题件处理导出":"港后问题件处理导出",
			"回复成功！":"回复成功！",
			"处理结果":"处理结果",
			"笔":"笔",
			"问题相关":"问题相关",
			"可多选":"可多选",
			",补收科目:":",补收科目:",
			"附件":"附件",
			"获取文件路径异常":"获取文件路径异常",
			"通知人":"通知人",
			"费用补录":"费用补录",
			"运单做\\":"运单做\\",
			"天":"天",
			"登记网点":"登记网点",
			"问题件信息":"问题件信息",
			"件数":"件数",
			"处理状态":"处理状态",
			"客户名称":"客户名称",
			"问题状态:":"问题状态:",
			"笔已处理":"笔已处理",
			"截止处理时间":"截止处理时间",
			"收件城市":"收件城市",
			"币别":"币别",
			"确定对":"确定对",
			"文件大小不能大于5MB":"文件大小不能大于5MB",
			"可处理笔数":"可处理笔数",
			"重置":"重置",
			"退客户海外仓":"退客户海外仓",
			"目的地":"目的地",
			"二次销售":"二次销售",
			"指定处理人":"指定处理人",
			"费用补录管理":"费用补录管理",
			"客户信息":"客户信息",
			"转单号码":"转单号码",
			"提示":"提示",
			"费用批量补录":"费用批量补录",
			"补收科目:":"补收科目:",
			"最新回复时间":"最新回复时间",
			",金额:":",金额:",
			"打印":"打印",
			"批量补录":"批量补录",
			"文件还未上传成功，请等待文件上传成功后再回复！":"文件还未上传成功，请等待文件上传成功后再回复！",
			"回复异常":"回复异常",
			"导出":"导出",
			"最新轨迹状态":"最新轨迹状态",
			"最新轨迹描述":"最新轨迹描述",
			"请输入":"请输入",
			"取消":"取消",
			"只能打印一个问题件":"只能打印一个问题件",
			"其中":"其中",
			"只能上传jpg/png/word/excel/pdf文件":"只能上传jpg/png/word/excel/pdf文件",
			"国外退件":"国外退件",
			"问题状态":"问题状态",
			"运单号码":"运单号码",
			"剩余期限":"剩余期限",
			"查询":"查询",
			"确定移除":"确定移除",
			"截止日期不能小于登记日期!":"截止日期不能小于登记日期!",
			"收件邮编":"收件邮编",
			"您选取的":"您选取的",
			"问题描述":"问题描述",
			"登记日期不能为空":"登记日期不能为空",
			"问题件批量回复":"问题件批量回复",
			"处理?":"处理?",
			"处理意见":"处理意见",
			"港后":"港后",
			"打印完成":"打印完成",
			"费用补录申请":"费用补录申请",
			"笔问题件数据":"笔问题件数据",
			"目的地名称":"目的地名称",
			"目的地简码":"目的地简码",
			",问题描述:":",问题描述:",
			"补录费用成功！":"补录费用成功！",
			"最新回复":"最新回复",
			"最新轨迹时间":"最新轨迹时间",
			"走货路线":"走货路线",
			"小时":"小时",
			"批量回复成功！":"批量回复成功！",
			"关闭":"关闭",
			"销售员":"销售员",
			"销毁":"销毁",
			"回复提交":"回复提交",
			"笔无需回复":"笔无需回复",
			"输入处理意见后":"输入处理意见后",
			"请选择一行数据":"请选择一行数据",
			"处理状态不能为空!":"处理状态不能为空!",
			"登记日期":"登记日期",
			"请选择至少一行数据":"请选择至少一行数据",
			"跟单员":"跟单员",
			"客户":"客户",
			"参考编号":"参考编号",
			"确定":"确定",
			"问题件回复":"问题件回复",
			"港后问题件处理":"港后问题件处理",
			"回复":"回复",
			"补收科目":"补收科目",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
			"收费重":"收费重",
			"走货路线分类":"走货路线分类",
			"可":"可",
			"代理客服":"代理客服",
			"费用补录新增":"费用补录新增",
			"补录费用:":"补录费用:",
			"超时未处理完毕":"超时未处理完毕",
			"金额":"金额",
			"最新轨迹地点":"最新轨迹地点",
			"运单号码/转单号码/参考编号":"运单号码/转单号码/参考编号",
			"港后/代理客服":"港后/代理客服",
			"指定路线/走货路线":"指定路线/走货路线",
			"件数/收费重":"件数/收费重",
			"收件城市/收件邮编":"收件城市/收件邮编",
			"输入处理意见后，可Enter/回复提交":"输入处理意见后，可Enter/回复提交",
			"通知人(可多选)":"通知人(可多选)",
			"笔问题件数据，其中":"笔问题件数据，其中",
			"笔已处理，":"笔已处理，",
			"笔无需回复，可处理笔数":"笔无需回复，可处理笔数",
		},

		"problemsquery":{
			"修改":"修改",
			"补收金额/币别必填!":"补收金额/币别必填!",
			"港后问题件查询":"港后问题件查询",
			"登记人":"登记人",
			"指定路线":"指定路线",
			"回复成功！":"回复成功！",
			"处理结果":"处理结果",
			"笔":"笔",
			"可多选":"可多选",
			",补收科目:":",补收科目:",
			"附件":"附件",
			"获取文件路径异常":"获取文件路径异常",
			"通知人":"通知人",
			"运单做\\":"运单做\\",
			"天":"天",
			"登记网点":"登记网点",
			"问题件信息":"问题件信息",
			"件数":"件数",
			"处理状态":"处理状态",
			"客户名称":"客户名称",
			"问题状态:":"问题状态:",
			"笔已处理":"笔已处理",
			"截止处理时间":"截止处理时间",
			"收件城市":"收件城市",
			"币别":"币别",
			"确定对":"确定对",
			"文件大小不能大于5MB":"文件大小不能大于5MB",
			"可处理笔数":"可处理笔数",
			"重置":"重置",
			"退客户海外仓":"退客户海外仓",
			"目的地":"目的地",
			"二次销售":"二次销售",
			"指定处理人":"指定处理人",
			"客户信息":"客户信息",
			"转单号码":"转单号码",
			"提示":"提示",
			"补收科目:":"补收科目:",
			"最新回复时间":"最新回复时间",
			",金额:":",金额:",
			"打印":"打印",
			"文件还未上传成功，请等待文件上传成功后再回复！":"文件还未上传成功，请等待文件上传成功后再回复！",
			"回复异常":"回复异常",
			"导出":"导出",
			"最新轨迹状态":"最新轨迹状态",
			"最新轨迹描述":"最新轨迹描述",
			"请输入":"请输入",
			"取消":"取消",
			"只能打印一个问题件":"只能打印一个问题件",
			"其中":"其中",
			"只能上传jpg/png/word/excel/pdf文件":"只能上传jpg/png/word/excel/pdf文件",
			"国外退件":"国外退件",
			"问题状态":"问题状态",
			"运单号码":"运单号码",
			"剩余期限":"剩余期限",
			"查询":"查询",
			"截止日期不能小于登记日期!":"截止日期不能小于登记日期!",
			"收件邮编":"收件邮编",
			"处理完毕时间":"处理完毕时间",
			"您选取的":"您选取的",
			"问题描述":"问题描述",
			"登记日期不能为空":"登记日期不能为空",
			"问题件批量回复":"问题件批量回复",
			"处理?":"处理?",
			"处理意见":"处理意见",
			"处理网点":"处理网点",
			"港后":"港后",
			"打印完成":"打印完成",
			"笔问题件数据":"笔问题件数据",
			"请选择至少一行可处理数据":"请选择至少一行可处理数据",
			",问题描述:":",问题描述:",
			"补录费用成功！":"补录费用成功！",
			"最新回复":"最新回复",
			"最新轨迹时间":"最新轨迹时间",
			"走货路线":"走货路线",
			"批量回复成功！":"批量回复成功！",
			"小时":"小时",
			"关闭":"关闭",
			"港后问题件查询导出":"港后问题件查询导出",
			"销毁":"销毁",
			"回复提交":"回复提交",
			"笔无需回复":"笔无需回复",
			"输入处理意见后":"输入处理意见后",
			"请选择一行数据":"请选择一行数据",
			"处理状态不能为空!":"处理状态不能为空!",
			"登记日期":"登记日期",
			"请选择至少一行数据":"请选择至少一行数据",
			"客户":"客户",
			"参考编号":"参考编号",
			"确定":"确定",
			"问题件回复":"问题件回复",
			"回复":"回复",
			"补收科目":"补收科目",
			"登记时间":"登记时间",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
			"收费重":"收费重",
			"走货路线分类":"走货路线分类",
			"可":"可",
			"代理客服":"代理客服",
			"补录费用:":"补录费用:",
			"金额":"金额",
			"最新轨迹地点":"最新轨迹地点",
			"运单号码/转单号码/参考编号":"运单号码/转单号码/参考编号",
			"港后/代理客服":"港后/代理客服",
			"指定路线/走货路线":"指定路线/走货路线",
			"件数/收费重":"件数/收费重",
			"收件城市/收件邮编":"收件城市/收件邮编",
			"输入处理意见后，可Enter/回复提交":"输入处理意见后，可Enter/回复提交",
			"通知人(可多选)":"通知人(可多选)",
			"笔问题件数据，其中问题件数据":"笔问题件数据，其中问题件数据",
			"笔已处理，":"笔已处理，",
			"笔无需回复，可处理笔数":"笔无需回复，可处理笔数",
		},
		"CMN005":{
			"单号类型等于总运单号或头程提单才允许导出shopee daily report（MY）报表!":"单号类型等于总运单号或头程提单才允许导出shopee daily report（MY）报表!",
			"一行":"一行",
			"运/转/参考单号,一次导出单号数量不能超过1000":"运/转/参考单号,一次导出单号数量不能超过1000",
			"提单货量分摊":"提单货量分摊",
			"单号类型等于总运单号/头程提单，才允许提单货量分摊导出!":"单号类型等于总运单号/头程提单，才允许提单货量分摊导出!",
			"可包含运单信息":"可包含运单信息",
			"维度的特殊报表":"维度的特殊报表",
			"大包/总运单/出货批次/头程提单号，一次导出单号数量不能超过300":"大包/总运单/出货批次/头程提单号，一次导出单号数量不能超过300",
			"导出说明":"导出说明",
			"单号类型等于总运单号或头程提单才允许导出shopee daily report（TH）报表!":"单号类型等于总运单号或头程提单才允许导出shopee daily report（TH）报表!",
			"单号类型等于总运单号，才允许turkey-mawb-box报表导出!":"单号类型等于总运单号，才允许turkey-mawb-box报表导出!",
			"单号类型等于总运单号或头程提单，才允许韵达 报机明细报表导出!":"单号类型等于总运单号或头程提单，才允许韵达 报机明细报表导出!",
			"单号类型等于大包号，才允许SpringPost 预报 报表导出!":"单号类型等于大包号，才允许SpringPost 预报 报表导出!",
			"单号类型等于总运单号、大包号或者等于出货批次，才允许导出大包出货报表!":"单号类型等于总运单号、大包号或者等于出货批次，才允许导出大包出货报表!",
			"导出单号不能为空!":"导出单号不能为空!",
			"一个运单一行记录":"一个运单一行记录",
			"信息一行记录":"信息一行记录",
			"非运单维度":"非运单维度",
			"则导出":"则导出",
			"请输入单个单号!":"请输入单个单号!",
			"个":"个",
			"大包出货报表":"大包出货报表",
			"运/转/参考单号,一次导出单号数量不能超过50000":"运/转/参考单号,一次导出单号数量不能超过50000",
			"维度报表":"维度报表",
			"Invoice维度报表":"Invoice维度报表",
			"例如一个运单包含":"例如一个运单包含",
			"节点时间":"节点时间",
			"数据":"数据",
			"行记录数据":"行记录数据",
			"单号类型等于总运单号或头程提单才允许导出shopee daily report报表!":"单号类型等于总运单号或头程提单才允许导出shopee daily report报表!",
			"运单维度报表":"运单维度报表",
			"单号类型等于总运单号或出货批次,头程提单，才允许导出APG报表!":"单号类型等于总运单号或出货批次,头程提单，才允许导出APG报表!",
			"特殊报表":"特殊报表",
			"1、运单维度报表，一个运单一行记录；可包含运单信息、节点时间、数据":"1、运单维度报表，一个运单一行记录；可包含运单信息、节点时间、数据",
			"2、Invoice维度报表，一行invoice信息一行记录例如一个运单包含3个invoice，则导出3行记录数据":"2、Invoice维度报表，一行invoice信息一行记录例如一个运单包含3个invoice，则导出3行记录数据",
			"3、特殊报表，非运单维度、Invoice维度的特殊报表":"3、特殊报表，非运单维度、Invoice维度的特殊报表",
		},
		"TMS020":{
        	"跟进状态":"跟进状态",
        	"预计件数":"预计件数",
			"实收件数":"实收件数",
			"尾程实重":"尾程实重",
			"尾程材重":"尾程材重",
			"尾程体积":"尾程体积",
			"尾程重":"尾程重",
        	"无效轨迹":"无效轨迹",
			"来源状态编码":"来源状态编码",
			"原因描述":"原因描述",
			"原因码":"原因码",
			"状态编码":"状态编码",
        	"时区":"时区",
			"转单Lable":"转单Lable",
			"轨迹状态":"轨迹状态",
			"原产地":"原产地",
			"描述":"描述",
			"子单":"子单",
			"INVOICE信息":"INVOICE信息",
			"退件单号":"退件单号",
			"处理结果":"处理结果",
			"printScene:INVOICE打印机":"printScene:INVOICE打印机",
			"转单子单(0)":"转单子单(0)",
			"总价":"总价",
			"文件名":"文件名",
			"寄件区县":"寄件区县",
			"获取文件路径异常":"获取文件路径异常",
			"查询后选中单号":"查询后选中单号",
			"货款信息":"货款信息",
			"操作":"操作",
			"操作时间":"操作时间",
			"处理人":"处理人",
			"处理期限":"处理期限",
			"包装项目":"包装项目",
			"收款时间":"收款时间",
			"寄件人":"寄件人",
			"到":"到",
			"运单文件":"运单文件",
			"功能":"功能",
			"寄件税号":"寄件税号",
			"转【":"转【",
			"打单前请设置好LABEL打印机":"打单前请设置好LABEL打印机",
			"币别":"币别",
			"请输入日志信息":"请输入日志信息",
			"出货重":"出货重",
			"删除成功":"删除成功",
			"单价":"单价",
			"请选择处理状态":"请选择处理状态",
			"删除":"删除",
			"EDI_LABEL打印机":"EDI_LABEL打印机",
			"没有配置INVOICE自定义模板":"没有配置INVOICE自定义模板",
			"运单信息":"运单信息",
			"打印设置":"打印设置",
			"数量":"数量",
			"寄件网点":"寄件网点",
			"跟进日志(":"跟进日志(",
			"】已取到快件":"】已取到快件",
			"格式":"格式",
			"转单号码":"转单号码",
			"打单前请设置好INVOICE打印机":"打单前请设置好INVOICE打印机",
			"查询单号必填":"查询单号必填",
			"材重":"材重",
			"报关方式":"报关方式",
			"单件进位规则":"单件进位规则",
			"收件备注":"收件备注",
			"备份联打印机":"备份联打印机",
			"跟进人":"跟进人",
			"以下录入的都为单件信息":"以下录入的都为单件信息",
			"出货实重":"出货实重",
			"收件邮箱":"收件邮箱",
			"类型":"类型",
			"海关编码":"海关编码",
			"派送代理":"派送代理",
			"出货备注":"出货备注",
			"查询":"查询",
			"寄件电话":"寄件电话",
			"分拣分区":"分拣分区",
			"登记":"登记",
			"收费材重":"收费材重",
			"附件类型":"附件类型",
			"需要追踪的数据转单不能为空":"需要追踪的数据转单不能为空",
			"该问题件没有图片！":"该问题件没有图片！",
			"客户服务信息":"客户服务信息",
			"到付款":"到付款",
			"追踪信息":"追踪信息",
			"个问题件":"个问题件",
			"除以数":"除以数",
			"时间":"时间",
			"当前文件为其他网点创建，没有删除权限":"当前文件为其他网点创建，没有删除权限",
			"对账员":"对账员",
			"出货材重":"出货材重",
			"走货路线":"走货路线",
			"跟进网点":"跟进网点",
			"关闭":"关闭",
			"printScene:EDI_LABEL打印机":"printScene:EDI_LABEL打印机",
			"没有获取到子单数据":"没有获取到子单数据",
			"下载":"下载",
			"高":"高",
			"没有获取到下载地址！":"没有获取到下载地址！",
			"收件州":"收件州",
			"没有获取到label 地址":"没有获取到label 地址",
			"客户":"客户",
			"内容":"内容",
			"printScene:备份联打印机":"printScene:备份联打印机",
			"返款信息":"返款信息",
			"单票进位规则":"单票进位规则",
			"收费重":"收费重",
			"--请求轨迹原数据失败--":"--请求轨迹原数据失败--",
			"转单子单(":"转单子单(",
			"收件电话":"收件电话",
			"体积":"体积",
			"件":"件",
			"问题信息":"问题信息",
			"港后客服":"港后客服",
			"中文品名":"中文品名",
			"省":"省",
			"修改":"修改",
			"日志信息":"日志信息",
			"修改日志":"修改日志",
			"寄件邮箱":"寄件邮箱",
			"登记人":"登记人",
			"一次最多查询":"一次最多查询",
			"助手返回任务id失败":"助手返回任务id失败",
			"指定路线":"指定路线",
			"寄件州":"寄件州",
			"收件税号":"收件税号",
			"咨询来源":"咨询来源",
			"保存":"保存",
			"----提交后台失败":"----提交后台失败",
			"没有配置LABEL自定义模板":"没有配置LABEL自定义模板",
			"清空":"清空",
			"创建人":"创建人",
			"包装类型":"包装类型",
			"类别":"类别",
			"附件":"附件",
			"跟进日志(无)":"跟进日志(无)",
			"打单前请设置好备份联打印机":"打单前请设置好备份联打印机",
			"返款时间":"返款时间",
			"注意":"注意",
			"付款方式":"付款方式",
			"第":"第",
			"没有获取到备用联label地址":"没有获取到备用联label地址",
			"详细信息":"详细信息",
			"件数":"件数",
			"处理状态":"处理状态",
			"包装说明":"包装说明",
			"收":"收",
			"上传时间":"上传时间",
			"跟进时间":"跟进时间",
			"需要追踪的数据追踪网络不能为空":"需要追踪的数据追踪网络不能为空",
			"追踪进行中，请稍候查询":"追踪进行中，请稍候查询",
			"收件城市":"收件城市",
			"没有配置LABEL 输出方式":"没有配置LABEL 输出方式",
			"序号":"序号",
			"没有获取到文件地址，无法查看":"没有获取到文件地址，无法查看",
			"分拣码":"分拣码",
			"单号":"单号",
			"一次最多查20个单号":"一次最多查20个单号",
			"运单文件(无)":"运单文件(无)",
			"重置":"重置",
			"推送":"推送",
			"目的地":"目的地",
			"转单子单":"转单子单",
			"寄件国家":"寄件国家",
			"品名":"品名",
			"备份联":"备份联",
			"个字符":"个字符",
			"INVOICE打印机":"INVOICE打印机",
			"子单号码":"子单号码",
			"最多允许录入":"最多允许录入",
			"没有找到打印配置":"没有找到打印配置",
			"收件区县":"收件区县",
			"打印":"打印",
			"仅显示":"仅显示",
			"导出":"导出",
			"请输入处理结果":"请输入处理结果",
			"转单":"转单",
			"一次最多查询20个单号":"一次最多查询20个单号",
			"签":"签",
			"港前客服":"港前客服",
			"长":"长",
			"税金付款":"税金付款",
			"使用":"使用",
			"网点":"网点",
			"费用结算":"费用结算",
			"运单号码":"运单号码",
			"操作员":"操作员",
			"包装费":"包装费",
			"收件邮编":"收件邮编",
			"】已收到快件":"】已收到快件",
			"问题描述":"问题描述",
			"物流助手初始化失败,请稍后重试":"物流助手初始化失败,请稍后重试",
			"品牌":"品牌",
			"收件地址":"收件地址",
			"----提交后台成功":"----提交后台成功",
			"寄件地址":"寄件地址",
			"寄件邮编":"寄件邮编",
			"退返客户,退返方式为<":"退返客户,退返方式为<",
			"英文品名":"英文品名",
			"货物信息":"货物信息",
			"跟踪记录":"跟踪记录",
			"样式":"样式",
			"申报价值":"申报价值",
			"收件公司":"收件公司",
			"单票计抛规则":"单票计抛规则",
			"单件信息":"单件信息",
			"宽":"宽",
			"收件人":"收件人",
			"回款时间":"回款时间",
			"个单号":"个单号",
			"跟进日志":"跟进日志",
			"请输入最后期限":"请输入最后期限",
			"位置":"位置",
			"INVOICE信息(无)":"INVOICE信息(无)",
			"寄件城市":"寄件城市",
			"请选择咨询来源":"请选择咨询来源",
			"INVOICE信息(有)":"INVOICE信息(有)",
			"付款时间":"付款时间",
			"销售员":"销售员",
			"日期":"日期",
			"录入日志":"录入日志",
			"寄件公司":"寄件公司",
			"回款信息":"回款信息",
			"预览":"预览",
			"跟单员":"跟单员",
			"打单数据附件不允许删除":"打单数据附件不允许删除",
			"代收款":"代收款",
			"寄件日期":"寄件日期",
			"参考编号":"参考编号",
			"实重":"实重",
			"登记时间":"登记时间",
			"计抛方式":"计抛方式",
			"运单文件(":"运单文件(",
			"订单创建日期":"订单创建日期",
			"收件国家":"收件国家",
			"存在多个PDF文件，请下载后查看":"存在多个PDF文件，请下载后查看",
			"收费实重":"收费实重",
			"操作方式":"操作方式",
			"参考编码":"参考编码",
			"货款信息(有)":"货款信息(有)",
			"的轨迹信息":"的轨迹信息",
			"货物类型":"货物类型",
			"代理客服":"代理客服",
			"处理时间":"处理时间",
			"创建时间":"创建时间",
			"出":"出",
			"回车后直接查询":"回车后直接查询",
			"货款信息(无)":"货款信息(无)",
			"寄件州/省":"寄件州/省",
			"收件州/省":"收件州/省",
			"最多允许录入1000个字符":"最多允许录入1000个字符",
			"最新状态":"最新状态",
			"下次跟进时间":"下次跟进时间"
		},
		"TMS133":{

		},
		"TMS122":{
		},
		"BAS010": {
		},
		"BAS009":{
			"本地揽派服务":"本地揽派服务",
			"确定要删除吗？":"确定要删除吗？",
			"修改":"修改",
			"获取指定线路类型树异常":"获取指定线路类型树异常",
			"不共享":"不共享",
			"生成应收":"生成应收",
			"请输入关键字":"请输入关键字",
			"指定路线":"指定路线",
			"应付账单明细数据":"应付账单明细数据",
			"保存":"保存",
			"默认invoice格式默认份数必须大于等于1小于100":"默认invoice格式默认份数必须大于等于1小于100",
			"路线英文":"路线英文",
			"请选择单一行数据":"请选择单一行数据",
			"可多选":"可多选",
			"收费重规则":"收费重规则",
			"EDI配置客户名称不能为空":"EDI配置客户名称不能为空",
			"请选择数据":"请选择数据",
			"共享给指定":"共享给指定",
			"分类编码（分类名称）":"分类编码（分类名称）",
			"EDI配置二次账号不能为空":"EDI配置二次账号不能为空",
			"否":"否",
			"默认货物类型":"默认货物类型",
			"网点列表":"网点列表",
			"其他":"其他",
			"请选择录单网点":"请选择录单网点",
			"路线编码":"路线编码",
			"只查所属":"只查所属",
			"指定路线分类":"指定路线分类",
			"是":"是",
			"所属网点":"所属网点",
			"起运地":"起运地",
			'目的地':'目的地',
			"请选择业务类型":"请选择业务类型",
			"修改人":"修改人",
			"国家标签中国家简码不能为空":"国家标签中国家简码不能为空",
			"国家标签中Label格式不能为空":"国家标签中Label格式不能为空",
			"保存成功！":"保存成功！",
			"请选择收费重单票计抛规则":"请选择收费重单票计抛规则",
			"修改指定路线":"修改指定路线",
			"有多条走货路线时，是否启用分拣排货？":"有多条走货路线时，是否启用分拣排货？",
			"请选择收费重单票进位规则":"请选择收费重单票进位规则",
			"序号":"序号",
			"分拣排货后":"分拣排货后",
			"订单预报成功":"订单预报成功",
			"删除":"删除",
			"收费重单件进位规则":"收费重单件进位规则",
			"共享":"共享",
			"排列顺序":"排列顺序",
			"指定网点":"指定网点",
			"重置":"重置",
			"请先设置EDI":"请先设置EDI",
			"国家简码不能重复":"国家简码不能重复",
			"当前指定路线未设置默认Lable格式，确认继续保存吗？":"当前指定路线未设置默认Lable格式，确认继续保存吗？",
			"路线名称":"路线名称",
			"接口时":"接口时",
			"确定要修改共享方式？":"确定要修改共享方式？",
			"共享网点":"共享网点",
			"分类名称":"分类名称",
			"格式":"格式",
			"不能实现一键打印":"不能实现一键打印",
			"请选择收费重单件进位":"请选择收费重单件进位",
			"设置大类默认规则":"设置大类默认规则",
			"排货类型":"排货类型",
			"默认使用指定路线的打印规则输出":"默认使用指定路线的打印规则输出",
			"共享给指定网点":"共享给指定网点",
			"提示":"提示",
			"请选择指定路线分类":"请选择指定路线分类",
			"修改指定路线分类":"修改指定路线分类",
			"共享方式":"共享方式",
			"请选择起运地":"请选择起运地",
			"新增成功":"新增成功",
			"共享设置":"共享设置",
			"导出":"导出",
			"请输入":"请输入",
			"取消":"取消",
			"指定路线<":"指定路线<",
			"二次账号不能为空":"二次账号不能为空",
			"基础信息":"基础信息",
			"设置默认打印格式和默认份数":"设置默认打印格式和默认份数",
			"用于一键打印":"用于一键打印",
			"保存并继续":"保存并继续",
			"当前指定路线为其他网点共享的指定路线，没有修改权限":"当前指定路线为其他网点共享的指定路线，没有修改权限",
			"路线大类":"路线大类",
			"名称":"名称",
			"建立时间":"建立时间",
			"请选择共享网点":"请选择共享网点",
			"说明":"说明",
			"默认为":"默认为",
			">已存在运费报价，分段修改会导致报价失效，请尽快修改对应报价？":">已存在运费报价，分段修改会导致报价失效，请尽快修改对应报价？",
			"分类编码":"分类编码",
			"Label格式不能为空":"Label格式不能为空",
			"路线分类":"路线分类",
			"查询":"查询",
			"起始收费重必须小于等于终止收费重":"起始收费重必须小于等于终止收费重",
			"默认份数":"默认份数",
			"收费重单票计抛规则":"收费重单票计抛规则",
			"走货路线未设置":"走货路线未设置",
			"请选择共享方式":"请选择共享方式",
			"尾程订单自动结算":"尾程订单自动结算",
			"全链路尾程货态转结算":"全链路尾程货态转结算",
			"开放现结客户":"开放现结客户",
			"收货允许收费实重":"收货允许收费实重",
			"请输入线路名称":"请输入线路名称",
			"共享给所有":"共享给所有",
			"如默认份数设置为空":"如默认份数设置为空",
			"默认A4格式默认份数必须大于等于1小于100":"默认A4格式默认份数必须大于等于1小于100",
			"允许":"允许",
			"起始实重必须小于等于终止实重":"起始实重必须小于等于终止实重",
			"起始材重必须小于等于终止材重":"起始材重必须小于等于终止材重",
			"请输入材积除以数":"请输入材积除以数",
			"国家标签中国家简码不能重复":"国家标签中国家简码不能重复",
			"收费材积除以数":"收费材积除以数",
			"允许规则":"允许规则",
			"收费材重":"收费材重",
			"限制规则":"限制规则",
			"默认invoice格式份数必须大于等于1小于100":"默认invoice格式份数必须大于等于1小于100",
			"包税":"包税",
			"自动转结算":"自动转结算",
			"转单获取方式=运单分配时，运单分配规则必填":"转单获取方式=运单分配时，运单分配规则必填",
			"指定线路":"指定线路",
			"起始件数必须小于等于终止件数":"起始件数必须小于等于终止件数",
			"默认Label格式默认份数必须大于等于1小于100":"默认Label格式默认份数必须大于等于1小于100",
			"默认A4格式份数必须大于等于1小于100":"默认A4格式份数必须大于等于1小于100",
			"删除成功！":"删除成功！",
			"启用状态":"启用状态",
			"新增指定路线":"新增指定路线",
			"当收费实重":"当收费实重",
			"默认Label格式份数必须大于等于1小于100":"默认Label格式份数必须大于等于1小于100",
			"业务类型":"业务类型",
			"录单网点":"录单网点",
			"请选择所属网点":"请选择所属网点",
			"新增指定路线分类":"新增指定路线分类",
			"建立人":"建立人",
			"客户名称不能为空":"客户名称不能为空",
			"当前指定路线分类含有指定路线，不允许删除！":"当前指定路线分类含有指定路线，不允许删除！",
			"修改成功！":"修改成功！",
			"收费重都不为":"收费重都不为",
			"当前指定路线为其他网点共享的指定路线，没有删除权限":"当前指定路线为其他网点共享的指定路线，没有删除权限",
			"路线大类默认设置规则与当前界面不同，是否覆盖？":"路线大类默认设置规则与当前界面不同，是否覆盖？",
			"符合其中任何一个条件":"符合其中任何一个条件",
			"增加":"增加",
			"偏远分类":"偏远分类",
			"备注":"备注",
			"关闭":"关闭",
			"则允许收货":"则允许收货",
			"启用":"启用",
			"转单获取方式=代理edi返回时，代理edi接口必填":"转单获取方式=代理edi返回时，代理edi接口必填",
			"修改时间":"修改时间",
			"请输入路线编码":"请输入路线编码",
			"默认":"默认",
			"新增":"新增",
			"确定":"确定",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
			"如未设置默认打印格式":"如未设置默认打印格式",
			"报价分段":"报价分段",
			"收货允许收费材重":"收货允许收费材重",
			"打印规则":"打印规则",
			"路线简体":"路线简体",
			"请选择单条数据进行删除":"请选择单条数据进行删除",
			"时":"时",
			"请选择报价分段":"请选择报价分段",
			"收费重单票进位规则":"收费重单票进位规则",
			"确定删除此行吗？":"确定删除此行吗？",
			"国家简码不能为空":"国家简码不能为空",
			"份":"份",
			"启用商家二次账号前，EDI需必填(推送代理)":"启用商家二次账号前，EDI需必填(推送代理)",
			"1、分拣排货后，走货路线未设置EDI接口时，默认使用指定路线的打印规则输出Lable":"1、分拣排货后，走货路线未设置EDI接口时，默认使用指定路线的打印规则输出Lable",
			"2、设置默认打印格式和默认份数，用于一键打印":"2、设置默认打印格式和默认份数，用于一键打印",
			"3、如未设置默认打印格式，不能实现一键打印；如默认份数设置为空，默认为1份":"3、如未设置默认打印格式，不能实现一键打印；如默认份数设置为空，默认为1份",
			"路线编码/名称":"路线编码/名称",
			"收货允许收费实重(KG)":"收货允许收费实重(KG)",
			"收货允许收费材重(KG)":"收货允许收费材重(KG)",
			"允许&限制规则":"允许&限制规则",
			"默认Label格式":"默认Label格式",
			"默认A4格式":"默认A4格式",
			"共享网点(可多选)":"共享网点(可多选)",
			"分类编码(分类名称)":"分类编码(分类名称)",
			"履约状态设置":"履约状态设置",
			"签收状态(支持多选)":"签收状态(支持多选)",
			"失败状态(支持多选)":"失败状态(支持多选)",
			"未完成状态(支持多选)":"未完成状态(支持多选)",
			"注意：同一扫描状态只允许存在一个履约状态下。":"注意：同一扫描状态只允许存在一个履约状态下。",
			"特殊客户收费重规则":"特殊客户收费重规则",
			"COD服务":"COD服务",
			"操作":"操作",
			"生效日期":"生效日期",
			"停用日期":"停用日期",
			"客户（可多选）":"客户（可多选）",
			"收货材积除以数":"收货材积除以数",
			"收货重单件进位规则":"收货重单件进位规则",
			"收货重单票进位规则":"收货重单票进位规则",
			"收货重单票计抛规则":"收货重单票计抛规则",
			"集运模式(加总一段)":"集运模式(加总一段)",
			"校验地址系数":"校验地址系数",
			"不填则不校验,填写后小于系数则装包操作不拦截,反之≥系数则拦截":"不填则不校验,填写后小于系数则装包操作不拦截,反之≥系数则拦截",
			"特殊偏远":"特殊偏远",
			"添加":"添加",
			"默认地址": "默认地址",
			"启用": "启用",
			"收件信息": "收件信息",
			"收件公司": "收件公司",
			"收件人": "收件人",
			"收件电话": "收件电话",
			"收件地址": "收件地址",
			"收件州/省": "收件州/省",
			"收件城市": "收件城市",
			"收件区县": "收件区县",
			"收件门牌号": "收件门牌号",
			"收件邮编": "收件邮编",
			"收件邮箱": "收件邮箱",
			"说明：当客户填写的收件地址下单失败时，如果指定路线配置并启用了默认地址，则会自动使用默认地址重新下单": "说明：当客户填写的收件地址下单失败时，如果指定路线配置并启用了默认地址，则会自动使用默认地址重新下单",
			"特殊偏远": "特殊偏远"
		},
		"cmnMsgMsgMag":{
			"下一条":"下一条",
			"去收件箱":"去收件箱",
			"条，确认发送？":"条，确认发送？",
			"草稿":"草稿",
			"不提示":"不提示",
			"输入客户":"输入客户",
			"选中消息":"选中消息",
			"请选择消息":"请选择消息",
			"内部":"内部",
			"全部":"全部",
			"选择的消息内容存在收件人、主题或内容为空不能发送！":"选择的消息内容存在收件人、主题或内容为空不能发送！",
			"查询":"查询",
			"系统消息":"系统消息",
			"部门":"部门",
			"条，确认删除？":"条，确认删除？",
			"最大上传":"最大上传",
			"关联号码":"关联号码",
			"正文内容不超过":"正文内容不超过",
			"已经是最后一条消息了！":"已经是最后一条消息了！",
			"附件":"附件",
			"作者":"作者",
			"草稿保存成功！":"草稿保存成功！",
			"请选择":"请选择",
			"注意":"注意",
			"全选":"全选",
			"转单变更":"转单变更",
			"添加附件":"添加附件",
			"消息提示设置":"消息提示设置",
			"请选择收件人！":"请选择收件人！",
			"收件箱":"收件箱",
			"编辑":"编辑",
			"主题":"主题",
			"已经是第一条消息了！":"已经是第一条消息了！",
			"消息发送成功":"消息发送成功",
			"屏幕弹窗提醒":"屏幕弹窗提醒",
			"收件人":"收件人",
			"输入员工":"输入员工",
			"存为草稿":"存为草稿",
			"上一条":"上一条",
			"发件箱":"发件箱",
			"文件夹":"文件夹",
			"发送时间":"发送时间",
			"文件大小不能大于5M":"文件大小不能大于5M",
			"删除":"删除",
			"港前问题件":"港前问题件",
			"关闭":"关闭",
			"发件人":"发件人",
			"重置":"重置",
			"消息类型":"消息类型",
			"消息删除成功！":"消息删除成功！",
			"字":"字",
			"仅消息个数提示":"仅消息个数提示",
			"发送":"发送",
			"内容":"内容",
			"客户":"客户",
			"所选数据没有未读消息！":"所选数据没有未读消息！",
			"写信":"写信",
			"确定":"确定",
			"再写一封":"再写一封",
			"按网点显示":"按网点显示",
			"回复":"回复",
			"提示":"提示",
			"个附件":"个附件",
			"标记已读":"标记已读",
			"按部门显示":"按部门显示",
			"标记消息已读成功！":"标记消息已读成功！",
			"选中草稿":"选中草稿",
			"存为草稿时收件人、主题、附件、消息内容至少一项不能为空！":"存为草稿时收件人、主题、附件、消息内容至少一项不能为空！",
			"请输入":"请输入",
			"用户账号检索":"用户账号检索",
			"取消":"取消",
			"创建时间":"创建时间",
			"可选多个附件":"可选多个附件",
			"网点检索":"网点检索",
			"类型":"类型",
			"正文内容不超过7000字":"正文内容不超过7000字",
			"输入员工/部门/网点检索":"输入员工/部门/网点检索",
			"输入客户/用户账号检索":"输入客户/用户账号检索",
			"注意：可选多个附件，最大上传5个附件":"注意：可选多个附件，最大上传5个附件",
		},
		"BMS013":{
			"默认系统时间":"默认系统时间",
			"本币单价":"本币单价",
			"路线大类":"路线大类",
			"出货时间":"出货时间",
			"指定路线":"指定路线",
			"路线分类":"路线分类",
			"查询":"查询",
			"收件邮编":"收件邮编",
			"材积除以数":"材积除以数",
			"包装类型":"包装类型",
			"时效":"时效",
			"限制货物类型":"限制货物类型",
			"请输入\"重量\"!":"请输入\"重量\"!",
			"本币金额合计":"本币金额合计",
			"本币运费":"本币运费",
			"科目名称":"科目名称",
			"公式":"公式",
			"注意":"注意",
			"指定路线为查询允许":"指定路线为查询允许",
			"其他费用明细":"其他费用明细",
			"汇率":"汇率",
			"重量":"重量",
			"业务类型":"业务类型",
			"代理帐号":"代理帐号",
			"时间":"时间",
			"付费重":"付费重",
			"币别":"币别",
			"序号":"序号",
			"停用时间":"停用时间",
			"原币":"原币",
			"禁用":"禁用",
			"走货路线":"走货路线",
			"备注":"备注",
			"关闭":"关闭",
			"重置":"重置",
			"启用":"启用",
			"目的地":"目的地",
			"本币金额":"本币金额",
			"原币金额":"原币金额",
			"派送代理":"派送代理",
			"本币其他":"本币其他",
			"生效日期":"生效日期",
			"原币单价":"原币单价",
			"计算公式":"计算公式",
			"货物类型":"货物类型",
			"显示已停用走货路线报价":"显示已停用走货路线报价",
			"请输入":"请输入",
			"走货路线的应付报价":"走货路线的应付报价",
			"金额":"金额",
			"本币合计":"本币合计",
			"收件区县": "收件区县",
			"收件城市": "收件城市",
			"收件州省": "收件州省",
		},
		"BMS094":{
			"修改":"修改",
			"提交时间":"提交时间",
			"费用信息":"费用信息",
			"请选择要删除的数据！":"请选择要删除的数据！",
			"费用补录提交":"费用补录提交",
			"指定路线":"指定路线",
			"请输入正确的公式":"请输入正确的公式",
			"可多选":"可多选",
			"包装类型":"包装类型",
			"费用补录":"费用补录",
			"注意":"注意",
			"跟进记录":"跟进记录",
			"但允许继续跟进":"但允许继续跟进",
			"请选择要跟进的数据！":"请选择要跟进的数据！",
			"科目":"科目",
			"请选择要修改的数据！":"请选择要修改的数据！",
			"单票补录":"单票补录",
			"已提交导出任务，正在下载":"已提交导出任务，正在下载",
			"客户名称":"客户名称",
			"跟进时间":"跟进时间",
			"内部备注":"内部备注",
			"币别":"币别",
			"进入异常":"进入异常",
			"序号":"序号",
			"是否继续":"是否继续",
			"字数不能超过300，请修改后提交":"字数不能超过300，请修改后提交",
			"提交状态":"提交状态",
			"日期不能为空！":"日期不能为空！",
			"删除":"删除",
			"客户结算已存在科目":"客户结算已存在科目",
			"确认人":"确认人",
			"重置":"重置",
			"寄件网点":"寄件网点",
			"目的地":"目的地",
			"笔数据吗？(已提交数据不会被确认)":"笔数据吗？(已提交数据不会被确认)",
			"笔已提交，是否继续(已提交数据不会被提交)？":"笔已提交，是否继续(已提交数据不会被提交)？",
			"笔数据删除成功！":"笔数据删除成功！",
			"最多录入":"最多录入",
			"转单号码":"转单号码",
			"账单日期":"账单日期",
			"提示":"提示",
			"客户编码":"客户编码",
			"费用批量补录":"费用批量补录",
			"个字符":"个字符",
			"费用补录导出":"费用补录导出",
			"批量补录":"批量补录",
			"报关方式":"报关方式",
			"导出":"导出",
			"请选择要提交的数据！":"请选择要提交的数据！",
			"请输入":"请输入",
			"笔待提交，":"笔待提交，",
			"跟进人":"跟进人",
			"取消":"取消",
			"录入人":"录入人",
			"其中":"其中",
			"补录相关":"补录相关",
			"笔数据吗？(已提交数据不会被删除)":"笔数据吗？(已提交数据不会被删除)",
			"税金付款":"税金付款",
			"就不允许修改":"就不允许修改",
			"科目编码":"科目编码",
			"名称":"名称",
			"运单号码":"运单号码",
			"不可多条修改！":"不可多条修改！",
			"查询":"查询",
			"不可多条跟进 ！":"不可多条跟进 ！",
			"请输入跟进内容 ！":"请输入跟进内容 ！",
			"您选取的":"您选取的",
			"增值费导入":"增值费导入",
			"本次跟进":"本次跟进",
			"确认删除所选":"确认删除所选",
			"账单备注":"账单备注",
			"已提交数据不可修改！":"已提交数据不可修改！",
			"金额不能为空":"金额不能为空",
			"科目名称":"科目名称",
			"结算状态":"结算状态",
			"科目不能为空":"科目不能为空",
			"笔数据，其中":"笔数据，其中",
			"科目编号":"科目编号",
			"费用补录申请":"费用补录申请",
			"已取消数据不可修改！":"已取消数据不可修改！",
			"笔客户结算已有相同科目":"笔客户结算已有相同科目",
			"当费用信息确认之后":"当费用信息确认之后",
			"对账员":"对账员",
			"补录原因":"补录原因",
			"进入确认":"进入确认",
			"笔数据":"笔数据",
			"走货路线":"走货路线",
			"已有金额":"已有金额",
			"跟进":"跟进",
			"关闭":"关闭",
			"销售员":"销售员",
			"笔成功！":"笔成功！",
			"数据来源":"数据来源",
			"提交异常":"提交异常",
			"跟单员":"跟单员",
			"客户":"客户",
			"内容":"内容",
			"已提交数据不会被提交":"已提交数据不会被提交",
			"费用补录修改":"费用补录修改",
			"寄件日期":"寄件日期",
			"参考编号":"参考编号",
			"导入":"导入",
			"确定":"确定",
			"确认时间":"确认时间",
			"最新状态":"最新状态",
			"提交人":"提交人",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
			"收费重":"收费重",
			"确认所选":"确认所选",
			"计算公式":"计算公式",
			"不可多条跟进！":"不可多条跟进！",
			"笔已提交":"笔已提交",
			"跟进成功！":"跟进成功！",
			"删除的数据为空，请确认提交状态，重新选择":"删除的数据为空，请确认提交状态，重新选择",
			"货物类型":"货物类型",
			"运单状态":"运单状态",
			"确认":"确认",
			"录入时间":"录入时间",
			"补录相关不能为空！":"补录相关不能为空！",
			"金额":"金额",
			"客户编码/名称":"客户编码/名称",
			"提交人(可多选)":"提交人(可多选)",
		},
		"BAS014":{
			"确定要删除吗？":"确定要删除吗？",
			"修改":"修改",
			"省":"省",
			"联系人":"联系人",
			"保存并继续":"保存并继续",
			"寄件邮箱":"寄件邮箱",
			"业务电话":"业务电话",
			"请选择至少一行数据！":"请选择至少一行数据！",
			"邮箱地址":"邮箱地址",
			"寄件人管理":"寄件人管理",
			"此联系人将被删除，确认继续吗？":"此联系人将被删除，确认继续吗？",
			"寄件州":"寄件州",
			"查询":"查询",
			"保存":"保存",
			"部门":"部门",
			"寄件电话":"寄件电话",
			"业务手机":"业务手机",
			"联络":"联络",
			"联络&对接信息":"联络&对接信息",
			"创建人":"创建人",
			"修改异常":"修改异常",
			"请谨慎修改":"请谨慎修改",
			"修改信息":"修改信息",
			"操作":"操作",
			"分割":"分割",
			"寄件地址":"寄件地址",
			"寄件人":"寄件人",
			"基本信息":"基本信息",
			"寄件邮编":"寄件邮编",
			"删除成功！":"删除成功！",
			"启用状态":"启用状态",
			"删除异常":"删除异常",
			"所属网点":"所属网点",
			"对接信息":"对接信息",
			"寄件人不能为空":"寄件人不能为空",
			"家":"家",
			"修改人":"修改人",
			"修改成功！":"修改成功！",
			"增加":"增加",
			"请选择单行数据":"请选择单行数据",
			"备注":"备注",
			"寄件城市":"寄件城市",
			"地址信息":"地址信息",
			"删除":"删除",
			"寄件人联系人":"寄件人联系人",
			"关闭":"关闭",
			"重置":"重置",
			"启用":"启用",
			"销售员":"销售员",
			"寄件公司":"寄件公司",
			"修改时间":"修改时间",
			"请选择一行数据":"请选择一行数据",
			"寄件邮编不能为空":"寄件邮编不能为空",
			"跟单员":"跟单员",
			"内部对接人信息":"内部对接人信息",
			"寄件国家":"寄件国家",
			"新增寄件人管理":"新增寄件人管理",
			"新增":"新增",
			"确定":"确定",
			"分类标签":"分类标签",
			"提示":"提示",
			"寄件公司不能为空":"寄件公司不能为空",
			"寄件电话不能为空":"寄件电话不能为空",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
			"寄件地址1":"寄件地址1",
			"寄件地址3":"寄件地址3",
			"寄件地址2":"寄件地址2",
			"修改寄件人管理":"修改寄件人管理",
			"多个别名请用":"多个别名请用",
			"添加成功！":"添加成功！",
			"批量修改":"批量修改",
			"寄件公司别名":"寄件公司别名",
			"寄件州/省":"寄件州/省",
			"导出":"导出",
			"传真":"传真",
			"请输入":"请输入",
			"港后客服":"港后客服",
			"取消":"取消",
			"当前选择批量修改寄件人":"当前选择批量修改寄件人",
			"创建时间":"创建时间",
			"添加异常":"添加异常",
			"所属客户":"所属客户",
			"基础信息":"基础信息",
			"港前客服":"港前客服"
		},
		"BAS015":{
			"确定要删除吗？":"确定要删除吗？",
			"修改":"修改",
			"省":"省",
			"保存并继续":"保存并继续",
			"请选择共享网点":"请选择共享网点",
			"收件税号":"收件税号",
			"查询":"查询",
			"保存":"保存",
			"收件邮编":"收件邮编",
			"收件州/省":"收件州/省",
			"请选择共享方式":"请选择共享方式",
			"创建人":"创建人",
			"修改异常":"修改异常",
			"共享给指定":"共享给指定",
			"收件地址":"收件地址",
			"删除成功！":"删除成功！",
			"修改收件人":"修改收件人",
			"启用状态":"启用状态",
			"删除异常":"删除异常",
			"修改人":"修改人",
			"收件公司":"收件公司",
			"修改成功！":"修改成功！",
			"收件人":"收件人",
			"收件城市":"收件城市",
			"新增收件人":"新增收件人",
			"地址信息":"地址信息",
			"删除":"删除",
			"关闭":"关闭",
			"重置":"重置",
			"启用":"启用",
			"收件地址1":"收件地址1",
			"收件地址3":"收件地址3",
			"收件地址2":"收件地址2",
			"修改时间":"修改时间",
			"请选择一行数据":"请选择一行数据",
			"收件州":"收件州",
			"新增":"新增",
			"确定":"确定",
			"提示":"提示",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
			"收件国家":"收件国家",
			"添加成功！":"添加成功！",
			"收件电话":"收件电话",
			"导出":"导出",
			"请输入":"请输入",
			"取消":"取消",
			"创建时间":"创建时间",
			"添加异常":"添加异常",
			"基础信息":"基础信息"
		},
		"scanManage":{
			"扫描分段(可多选)":"扫描分段(可多选)",
			"修改":"修改",
			"ICBU 推送编码":"ICBU 推送编码",
			"验证排序":"验证排序",
			"开启后，轨迹录入/导入时验证轨迹时间不能小于排序之前的轨迹时间":"开启后，轨迹录入/导入时验证轨迹时间不能小于排序之前的轨迹时间",
			"唯一性":"唯一性",
			"开启后，轨迹录入/导入时验证轨迹时间唯一,不允许同个货态出现两个轨迹时间":"开启后，轨迹录入/导入时验证轨迹时间唯一,不允许同个货态出现两个轨迹时间",
			"保存并继续":"保存并继续",
			"修改扫描状态成功":"修改扫描状态成功",
			"扫描分段":"扫描分段",
			"表示已结束":"表示已结束",
			"扫描状态":"扫描状态",
			"系统标准状态":"系统标准状态",
			"查询":"查询",
			"保存":"保存",
			"勾选后会识别对应运单为已取件状态":"勾选后会识别对应运单为已取件状态",
			"可多选":"可多选",
			"创建人":"创建人",
			"客户可视必须勾选":"客户可视必须勾选",
			"新增扫描状态成功":"新增扫描状态成功",
			"请选择扫描状态":"请选择扫描状态",
			"此操作将删除该扫描状态, 是否继续?":"此操作将删除该扫描状态, 是否继续?",
			"请选择":"请选择",
			"标准数据无法删除！":"标准数据无法删除！",
			"中文备注":"中文备注",
			"注意":"注意",
			"扫描状态删除失败！":"扫描状态删除失败！",
			"WISH 推送编码":"WISH 推送编码",
			"扫描编码":"扫描编码",
			"启用状态":"启用状态",
			"不允许随意修改":"不允许随意修改",
			"需重点关注":"需重点关注",
			"修改人":"修改人",
			"存在平台编码时，api_code必填，客户可视必须勾选":"存在平台编码时，api_code必填，客户可视必须勾选",
			"已取件":"已取件",
			"推送编码":"推送编码",
			"请输入\"扫描编码\"!":"请输入\"扫描编码\"!",
			"存在平台编码时":"存在平台编码时",
			"请输入\"扫描分段\"!":"请输入\"扫描分段\"!",
			"货物状态":"货物状态",
			"属于异常操作":"属于异常操作",
			"必填":"必填",
			"删除":"删除",
			"排列顺序":"排列顺序",
			"关闭":"关闭",
			"重置":"重置",
			"启用":"启用",
			"修改时间":"修改时间",
			"结案":"结案",
			"标准状态":"标准状态",
			"属于港后状态":"属于港后状态",
			"新增":"新增",
			"确定":"确定",
			"无需关注":"无需关注",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
			"提示":"提示",
			"新增扫描状态":"新增扫描状态",
			"客户可视":"客户可视",
			"请输入\"扫描名称\"!":"请输入\"扫描名称\"!",
			"导出":"导出",
			"请输入":"请输入",
			"取消":"取消",
			"扫描名称":"扫描名称",
			"英文备注":"英文备注",
			"创建时间":"创建时间",
			"允许客户通过网站或对接显示的状态":"允许客户通过网站或对接显示的状态",
			"异常":"异常",
			"扫描状态删除成功":"扫描状态删除成功",
			"基础信息":"基础信息",
			"修改扫描状态":"修改扫描状态"
		},
		"BAS017":{
			"修改":"修改",
			"保存并继续":"保存并继续",
			"问题名称":"问题名称",
			"需要回复":"需要回复",
			"处理信息":"处理信息",
			"问题状态":"问题状态",
			"修改成功":"修改成功",
			"识问题件":"识问题件",
			"收件后":"收件后",
			"不设置":"不设置",
			"查询":"查询",
			"保存":"保存",
			"自动标识问题件":"自动标识问题件",
			"新增港后问题状态":"新增港后问题状态",
			"可多选":"可多选",
			"新增港前问题状态":"新增港前问题状态",
			"登记":"登记",
			"创建人":"创建人",
			"已处理":"已处理",
			"此问题件客户可视":"此问题件客户可视",
			"新增港后问题":"新增港后问题",
			"默认补收科目":"默认补收科目",
			"新增港前问题":"新增港前问题",
			"标准状态无法修改":"标准状态无法修改",
			"请选择":"请选择",
			"问题类型":"问题类型",
			"天":"天",
			"中文备注":"中文备注",
			"处理时限":"处理时限",
			"启用状态":"启用状态",
			"需回复":"需回复",
			"打单时":"打单时",
			"通知岗位":"通知岗位",
			"可多次":"可多次",
			"申请暂扣标识问题件":"申请暂扣标识问题件",
			"重新排货标识问题件":"重新排货标识问题件",
			"修改人":"修改人",
			"收件标识问题件":"收件标识问题件",
			"勾选":"勾选",
			"客户申请暂扣":"客户申请暂扣",
			"删除成功":"删除成功",
			"指定处理岗位":"指定处理岗位",
			"港前按小时":"港前按小时",
			"删除":"删除",
			"回复中":"回复中",
			"排列顺序":"排列顺序",
			"关闭":"关闭",
			"此操作将删除该问题状态, 是否继续?":"此操作将删除该问题状态, 是否继续?",
			"重置":"重置",
			"启用":"启用",
			"未选择数据，无法修改！":"未选择数据，无法修改！",
			"修改时间":"修改时间",
			"问题编码":"问题编码",
			"标准状态":"标准状态",
			"港后按天":"港后按天",
			"新增":"新增",
			"确定":"确定",
			"请选择问题状态":"请选择问题状态",
			"提示":"提示",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
			"修改港前问题状态":"修改港前问题状态",
			"客户可视":"客户可视",
			"标准状态无法删除":"标准状态无法删除",
			"新增成功":"新增成功",
			"问题大类":"问题大类",
			"打单标识问题件":"打单标识问题件",
			"收件时":"收件时",
			"标识问题件":"标识问题件",
			"导出":"导出",
			"修改港后问题状态":"修改港后问题状态",
			"用于对外问题件显示":"用于对外问题件显示",
			"请输入":"请输入",
			"取消":"取消",
			"英文备注":"英文备注",
			"创建时间":"创建时间",
			"运单修改重新排货时标":"运单修改重新排货时标",
			"基础信息":"基础信息"
		},
		"productcontrolrules":{
			"确定要删除吗？":"确定要删除吗？",
			"备注":"备注",
			"匹配英文品名":"匹配英文品名",
			"删除":"删除",
			"匹配规则":"匹配规则",
			"查询":"查询",
			"匹配栏位":"匹配栏位",
			"时如中文品名为空":"时如中文品名为空",
			"重置":"重置",
			"得到中文品名":"得到中文品名",
			"修改时间":"修改时间",
			"请选择一行数据":"请选择一行数据",
			"创建人":"创建人",
			"需自动根据英文品名转换为中文品名":"需自动根据英文品名转换为中文品名",
			"导入":"导入",
			"确定":"确定",
			"提示":"提示",
			"删除成功！":"删除成功！",
			"品名对照规则":"品名对照规则",
			"删除异常":"删除异常",
			"导出":"导出",
			"以分号分隔的字符串需包含在":"以分号分隔的字符串需包含在",
			"中文品名":"中文品名",
			"优先于完全匹配":"优先于完全匹配",
			"修改人":"修改人",
			"接口对接":"接口对接",
			"不分先后顺序":"不分先后顺序",
			"取消":"取消",
			"创建时间":"创建时间",
			"的英文品名中":"的英文品名中",
			"被选中的记录需符合以下条件":"被选中的记录需符合以下条件",
			"接口对接INVOICE时如中文品名为空，需自动根据英文品名转换为中文品名":"接口对接INVOICE时如中文品名为空，需自动根据英文品名转换为中文品名",
			"匹配英文品名，得到中文品名;被选中的记录需符合以下条件，以分号分隔的字符串需包含在INVOICE的英文品名中（不分先后顺序），优先于完全匹配":"匹配英文品名，得到中文品名;被选中的记录需符合以下条件，以分号分隔的字符串需包含在INVOICE的英文品名中（不分先后顺序），优先于完全匹配"
		},
		"productnameimport":{
			"历史日志":"历史日志",
			"订单导入成功":"订单导入成功",
			"成功":"成功",
			"状态":"状态",
			"导入中":"导入中",
			"上传失败":"上传失败",
			"导入文件不能超过10MB":"导入文件不能超过10MB",
			"验证中":"验证中",
			"匹配规则":"匹配规则",
			"匹配栏位":"匹配栏位",
			"批次号":"批次号",
			"验证失败":"验证失败",
			"解析中":"解析中",
			"请选择导入模版！":"请选择导入模版！",
			"失败":"失败",
			"解析失败":"解析失败",
			"导入":"导入",
			"导入历史日志":"导入历史日志",
			"总行数":"总行数",
			"请选择模版！":"请选择模版！",
			"导入时间":"导入时间",
			"请选择匹配栏位！":"请选择匹配栏位！",
			"导入成功才可下载":"导入成功才可下载",
			"模版下载":"模版下载",
			"错误说明":"错误说明",
			"导入文件":"导入文件",
			"请输入":"请输入",
			"文件下载":"文件下载",
			"上传中":"上传中",
			"行号":"行号",
			"错误行数":"错误行数",
			"导入模版":"导入模版"
		},
		"BAS066":{
			"配货信息":"配货信息",
			"修改":"修改",
			"当运单有多个":"当运单有多个",
			"精准匹配":"精准匹配",
			"查询":"查询",
			"保存":"保存",
			"货物类型不能为空":"货物类型不能为空",
			"当运单有多个品名时":"当运单有多个品名时",
			"创建人":"创建人",
			"需完全匹配":"需完全匹配",
			"否":"否",
			"只要有一个匹配即满足要求":"只要有一个匹配即满足要求",
			"请选择":"请选择",
			"删除成功！":"删除成功！",
			"中":"中",
			"启用状态":"启用状态",
			"是":"是",
			"修改人":"修改人",
			"视为匹配":"视为匹配",
			"修改成功！":"修改成功！",
			"可对特定国家设置货物类型":"可对特定国家设置货物类型",
			"英文品名关键字":"英文品名关键字",
			"配货信息必填其一":"配货信息必填其一",
			"新增货物类型策略":"新增货物类型策略",
			"删除":"删除",
			"关闭":"关闭",
			"重置":"重置",
			"启用":"启用",
			"违禁品":"违禁品",
			"修改时间":"修改时间",
			"品名关键字只允许填入一个":"品名关键字只允许填入一个",
			"请选择一行数据":"请选择一行数据",
			"仅查违禁品":"仅查违禁品",
			"中文品名关键字":"中文品名关键字",
			"新增":"新增",
			"确定":"确定",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
			"提示":"提示",
			"货物类型策略":"货物类型策略",
			"国家简码":"国家简码",
			"只允许填入一个":"只允许填入一个",
			"英文品名包含关键字时":"英文品名包含关键字时",
			"添加成功！":"添加成功！",
			"修改货物类型策略":"修改货物类型策略",
			"货物类型":"货物类型",
			"是否删除该货物类型策略":"是否删除该货物类型策略",
			"导出":"导出",
			"时":"时",
			"取消":"取消",
			"创建时间":"创建时间",
			"品名关键字":"品名关键字",
			"只允许填入一个SKU；当运单有多个SKU时，只要有一个匹配即满足要求（需完全匹配）":"只允许填入一个SKU；当运单有多个SKU时，只要有一个匹配即满足要求（需完全匹配）",
			"品名关键字只允许填入一个；当运单有多个品名时，只要有一个匹配即满足要求":"品名关键字只允许填入一个；当运单有多个品名时，只要有一个匹配即满足要求",
			"中/英文品名包含关键字时，视为匹配":"中/英文品名包含关键字时，视为匹配",
			"SKU、品名关键字、配货信息必填其一":"SKU、品名关键字、配货信息必填其一"
		},
		"BAS067":{
			"修改":"修改",
			"修改分拣码":"修改分拣码",
			"拦截":"拦截",
			"名称":"名称",
			"指定路线":"指定路线",
			"查询":"查询",
			"保存":"保存",
			"仅查询拦截分拣码":"仅查询拦截分拣码",
			"分拣分区":"分拣分区",
			"可多选":"可多选",
			"是否删除该邮编目的地策略":"是否删除该邮编目的地策略",
			"创建人":"创建人",
			"启用拦截后":"启用拦截后",
			"修改异常":"修改异常",
			"收费重范围":"收费重范围",
			"拦截提示":"拦截提示",
			"COD金额":"COD金额",
			"否":"否",
			"金额范围":"金额范围",
			"分拣操作时会拦截此分拣码":"分拣操作时会拦截此分拣码",
			"新增分拣码":"新增分拣码",
			"分拣码信息":"分拣码信息",
			"删除成功！":"删除成功！",
			"启用状态":"启用状态",
			"是":"是",
			"删除异常":"删除异常",
			"重量":"重量",
			"申报价值":"申报价值",
			"申报价值范围":"申报价值范围",
			"修改人":"修改人",
			"请求成功":"请求成功",
			"修改成功！":"修改成功！",
			"分拣码":"分拣码",
			"优先级":"优先级",
			"走货路线":"走货路线",
			"删除":"删除",
			"关闭":"关闭",
			"重置":"重置",
			"启用":"启用",
			"修改时间":"修改时间",
			"请选择一行数据":"请选择一行数据",
			"客户":"客户",
			"新增":"新增",
			"确定":"确定",
			"提示":"提示",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
			"收费重":"收费重",
			"国家简码":"国家简码",
			"输入国家简码检索":"输入国家简码检索",
			"拦截时必填":"拦截时必填",
			"添加成功！":"添加成功！",
			"报关方式":"报关方式",
			"货物类型":"货物类型",
			"导出":"导出",
			"请输入":"请输入",
			"取消":"取消",
			"英文的时候需要加上这句":"英文的时候需要加上这句",
			"创建时间":"创建时间",
			"自动换行":"自动换行",
			"添加异常":"添加异常",
			"请输入,必须是数字":"请输入,必须是数字",
			"分拣规则":"分拣规则",
			"转单号生成二维码面单":"转单号生成二维码面单",
			"二维码面单":"二维码面单",
			"CBM上限":"CBM上限"
		},
		"sortpartition":{
			"修改":"修改",
			"地址关键字":"地址关键字",
			"数据修改成功！":"数据修改成功！",
			"删除":"删除",
			"区县":"区县",
			"查询":"查询",
			"关闭":"关闭",
			"保存":"保存",
			"重置":"重置",
			"启用":"启用",
			"收件邮编":"收件邮编",
			"分拣分区":"分拣分区",
			"修改时间":"修改时间",
			"请选择一行数据":"请选择一行数据",
			"创建人":"创建人",
			"例如":"例如",
			"新增":"新增",
			"确定":"确定",
			"或者":"或者",
			"是否该分拣码配置?":"是否该分拣码配置?",
			"新增分拣分区":"新增分拣分区",
			"提示":"提示",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
			"州省":"州省",
			"国家简码":"国家简码",
			"数据新增成功！":"数据新增成功！",
			"分区信息":"分区信息",
			"输入国家简码检索":"输入国家简码检索",
			"删除成功！":"删除成功！",
			"启用状态":"启用状态",
			"支持单个邮编与邮编区间设置":"支持单个邮编与邮编区间设置",
			"删除异常":"删除异常",
			"多组邮编用逗号分隔":"多组邮编用逗号分隔",
			"导出":"导出",
			"修改分拣分区":"修改分拣分区",
			"修改人":"修改人",
			"取消":"取消",
			"创建时间":"创建时间",
			"不能为空":"不能为空",
			"邮编":"邮编",
			"城市":"城市",
			"分拣规则":"分拣规则"
		},
		"BAS070":{
			"确定要删除吗？":"确定要删除吗？",
			"修改":"修改",
			"编辑轨迹推送配置":"编辑轨迹推送配置",
			"删除成功":"删除成功",
			"消":"消",
			"删除":"删除",
			"取":"取",
			"修改时间":"修改时间",
			"请选择一行数据":"请选择一行数据",
			"配置信息":"配置信息",
			"定":"定",
			"创建人":"创建人",
			"新增轨迹推送配置":"新增轨迹推送配置",
			"客户":"客户",
			"轨迹推送配置":"轨迹推送配置",
			"货态描述映射":"货态描述映射",
			"新增":"新增",
			"确定":"确定",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
			"提示":"提示",
			"编辑成功":"编辑成功",
			"客户编码":"客户编码",
			"名称检索":"名称检索",
			"确":"确",
			"新增成功":"新增成功",
			"输入客户编码":"输入客户编码",
			"导出":"导出",
			"请输入":"请输入",
			"修改人":"修改人",
			"取消":"取消",
			"轨迹推送地址":"轨迹推送地址",
			"创建时间":"创建时间",
			"客户名称":"客户名称"
		},
		"TMS091":{
			"订单导入模板有更新, 请下载最新模板":"订单导入模板有更新, 请下载最新模板",
			"提示":"提示",
			"模版下载": "模版下载",
			"导入模版": "导入模版 ",
			"确定":"确定",
			"历史日志":"历史日志",
			"订单导入成功":"订单导入成功",
			"成功":"成功",
			"状态":"状态",
			"自动获取运单号码":"自动获取运单号码",
			"导入中":"导入中",
			"上传失败":"上传失败",
			"导入文件不能超过10MB":"导入文件不能超过10MB",
			"名称":"名称",
			"备注":"备注",
			"验证中":"验证中",
			"指定路线":"指定路线",
			"模板管理":"模板管理",
			"验证失败":"验证失败",
			"解析中":"解析中",
			"标准模板":"标准模板",
			"请选择客户！":"请选择客户！",
			"客户":"客户",
			"失败":"失败",
			"解析失败":"解析失败",
			"订单号码":"订单号码",
			"导入":"导入",
			"导入历史日志":"导入历史日志",
			"编码":"编码",
			"总行数":"总行数",
			"请选择模版！":"请选择模版！",
			"无对应文件":"无对应文件",
			"错误说明":"错误说明",
			"导入文件":"导入文件",
			"请输入":"请输入",
			"上传中":"上传中",
			"导入后自动排货":"导入后自动排货",
			"行号":"行号",
			"错误行数":"错误行数"
		},
		"TMS092":{
			"电池类型":"电池类型",
			"型号":"型号",
        	"长":"长",
			"宽":"宽",
			"高":"高",
        	"申报金额":"申报金额",
			"自定义面单":"自定义面单",
        	"保险类别":"保险类别",
			"请输入收件城市":"请输入收件城市",
			"请完善收件人信息":"请完善收件人信息",
			"省":"省",
			"请选择税金支付":"请选择税金支付",
			"订单保存并预报成功，订单号码： <":"订单保存并预报成功，订单号码： <",
			"寄件邮箱":"寄件邮箱",
			"税金支付不能为空":"税金支付不能为空",
			"添加":"添加",
			"原产地":"原产地",
			"指定路线":"指定路线",
			"寄件州":"寄件州",
			"收件税号":"收件税号",
			"选择":"选择",
			"保存":"保存",
			"最多":"最多",
			"总价":"总价",
			"列":"列",
			"清空":"清空",
			"请选择客户":"请选择客户",
			"请选择客户！":"请选择客户！",
			"包装类型":"包装类型",
			"请输入寄件城市":"请输入寄件城市",
			"订单保存成功，订单号码：<":"订单保存成功，订单号码：<",
			"获取文件路径异常":"获取文件路径异常",
			"单价不能为空":"单价不能为空",
			"操作":"操作",
			"货物重量不能为空":"货物重量不能为空",
			"请输入收件地址":"请输入收件地址",
			"请输入内容":"请输入内容",
			"否":"否",
			"行邮税号":"行邮税号",
			"付款方式":"付款方式",
			"寄件人":"寄件人",
			"其他":"其他",
			"基本信息":"基本信息",
			"是":"是",
			"件数":"件数",
			"查看订单":"查看订单",
			"平台类型":"平台类型",
			"不能上传jsp,bat,sh,js,exe文件":"不能上传jsp,bat,sh,js,exe文件",
			"寄件税号":"寄件税号",
			"选择常用收件人":"选择常用收件人",
			"请输入寄件地址":"请输入寄件地址",
			"请输入货物重量":"请输入货物重量",
			"收件人信息":"收件人信息",
			"继续编辑":"继续编辑",
			"收件城市":"收件城市",
			"序号":"序号",
			"指定路线不能为空":"指定路线不能为空",
			"单价":"单价",
			"自定义信息":"自定义信息",
			"行":"行",
			"必填":"必填",
			"注意以下几点要求":"注意以下几点要求",
			"删除":"删除",
			"数量":"数量",
			"刷新":"刷新",
			"目的地":"目的地",
			"请完善寄件人信息":"请完善寄件人信息",
			"请输入寄件邮编":"请输入寄件邮编",
			"保存成功":"保存成功",
			"列与列直接用":"列与列直接用",
			"数量不能为空":"数量不能为空",
			"寄件国家":"寄件国家",
			"英文品名不能为空":"英文品名不能为空",
			"请输入0-9999之间的重量":"请输入0-9999之间的重量",
			"信息复制到剪贴板即可":"信息复制到剪贴板即可",
			"请输入寄件国家":"请输入寄件国家",
			"转单号码":"转单号码",
			"提示":"提示",
			"文件大小不能大于10MB":"文件大小不能大于10MB",
			"商品图片地址":"商品图片地址",
			"请选择目的地！":"请选择目的地！",
			"字符以内":"字符以内",
			"订单保存到草稿成功，订单号码： <":"订单保存到草稿成功，订单号码： <",
			"请选择报关方式":"请选择报关方式",
			"请输入寄件电话":"请输入寄件电话",
			"收件人电话不能为空":"收件人电话不能为空",
			"运费":"运费",
			"取消":"取消",
			"位小数":"位小数",
			"保存到草稿":"保存到草稿",
			"收件邮箱":"收件邮箱",
			"配货信息":"配货信息",
			"海关编码":"海关编码",
			"商品链接地址":"商品链接地址",
			"客户不能为空":"客户不能为空",
			"快速录入":"快速录入",
			"用于额外打印在标签上":"用于额外打印在标签上",
			"请输入寄件人":"请输入寄件人",
			"删除成功!":"删除成功!",
			"货物类型不能为空":"货物类型不能为空",
			"选填":"选填",
			"收件邮编":"收件邮编",
			"寄件电话":"寄件电话",
			"请选择目的地":"请选择目的地",
			"请选择币别":"请选择币别",
			"包装类型不能为空":"包装类型不能为空",
			"订单号码":"订单号码",
			"品牌":"品牌",
			"请选择包装类型":"请选择包装类型",
			"信息":"信息",
			"收件地址":"收件地址",
			"下一订单":"下一订单",
			"寄件地址":"寄件地址",
			"寄件邮编":"寄件邮编",
			"请输入收件人！":"请输入收件人！",
			"货物重量":"货物重量",
			"英文品名":"英文品名",
			"收件公司":"收件公司",
			"请输入件数":"请输入件数",
			"上传附件":"上传附件",
			"请输入需要导入的信息!":"请输入需要导入的信息!",
			"收件人":"收件人",
			"保存为常用收件人":"保存为常用收件人",
			"收件人不能为空":"收件人不能为空",
			"备注":"备注",
			"寄件城市":"寄件城市",
			"寄件人信息":"寄件人信息",
			"单个重量":"单个重量",
			"请输入收件电话！":"请输入收件电话！",
			"区县":"区县",
			"关闭":"关闭",
			"请输入收件电话":"请输入收件电话",
			"格式为":"格式为",
			"目的地不能为空":"目的地不能为空",
			"材质":"材质",
			"收件人地址不能为空":"收件人地址不能为空",
			"寄件公司":"寄件公司",
			"第三方税金账号":"第三方税金账号",
			"收件州":"收件州",
			"请输入至少一行invoice信息！":"请输入至少一行invoice信息！",
			"客户":"客户",
			"请选择指定路线":"请选择指定路线",
			"代收款":"代收款",
			"导入":"导入",
			"用途":"用途",
			"确定":"确定",
			"请输入订单号码":"请输入订单号码",
			"点击保存按钮后添加信息":"点击保存按钮后添加信息",
			"税金支付":"税金支付",
			"请输入收件人":"请输入收件人",
			"规格":"规格",
			"件数不能为空":"件数不能为空",
			"订单号码为空，系统自动分配订单号码，是否继续？":"订单号码为空，系统自动分配订单号码，是否继续？",
			"请输入收件地址！":"请输入收件地址！",
			"收件电话":"收件电话",
			"更多信息":"更多信息",
			"导入格式":"导入格式",
			"保存为草稿":"保存为草稿",
			"保留上一笔":"保留上一笔",
			"导入前请将":"导入前请将",
			"货物类型":"货物类型",
			"请输入收件邮编":"请输入收件邮编",
			"中文品名":"中文品名",
			"请选择货物类型":"请选择货物类型",
			"请输入中文品名":"请输入中文品名",
			"保存并预报":"保存并预报",
			"确定删除此行吗？":"确定删除此行吗？",
			"选取":"选取",
			"第三方付税金账号":"第三方付税金账号",
			"隔开":"隔开",
			"必填，最多3位小数":"必填，最多3位小数",
			"选填，200字符以内":"选填，200字符以内",
			"选填，用于额外打印在标签上， 500字符以内":"选填，用于额外打印在标签上， 500字符以内",
			"必填，300字符以内":"必填，300字符以内",
		},
		"BAS063":{
			"未知异常":"未知异常",
			"创建任务":"创建任务",
			"状态":"状态",
			"解析完成时间":"解析完成时间",
			"解析订单数":"解析订单数",
			"报文":"报文",
			"解析报文异常":"解析报文异常",
			"人工下载":"人工下载",
			"查询":"查询",
			"只显示异常":"只显示异常",
			"重置":"重置",
			"保存完成时间":"保存完成时间",
			"订单数据条件":"订单数据条件",
			"接收完成时间":"接收完成时间",
			"结束时间":"结束时间",
			"正在解析报文":"正在解析报文",
			"接收报文异常":"接收报文异常",
			"客户":"客户",
			"自动下载":"自动下载",
			"附件":"附件",
			"正在保存":"正在保存",
			"保存异常":"保存异常",
			"保存订单数":"保存订单数",
			"店铺昵称":"店铺昵称",
			"正在接收报文":"正在接收报文",
			"下载异常":"下载异常",
			"下载方式":"下载方式",
			"解析完成":"解析完成",
			"保存完成":"保存完成",
			"平台类型":"平台类型",
			"创建时间":"创建时间"
		},
		"TMS001":{
        	"二次路由修改":"二次路由修改",
			"异步订单修改":"异步订单修改",
			"首公里面单":"首公里面单",
			"首公里面单-二维码":"首公里面单-二维码",
			"末端面单":"末端面单",
			"无章":"No stamp",
			"報關文":"報關文",
        	"Invoice导出":"Invoice导出",
			"单号导出":"单号导出",
			"ICBU快递单号导出":"ICBU快递单号导出",
			"shopee日货量导出":"shopee日货量导出",
        	"二次路由":"二次路由",
			"异步状态":"异步状态",
			"条形码":"条形码",
			"揽收快递号":"揽收快递号",
			"显示明文":"显示明文",
			"揽收取件码":"揽收取件码",
			"二次路由详情":"二次路由详情",
			"二次路由状态":"二次路由状态",
			"二次路由结果":"二次路由结果",
        	"跟单员":"跟单员",
        	"排除":"排除",
        	"修改":"修改",
			"特殊导出":"特殊导出",
			"ICBU操作":"ICBU操作",
        	"面单打印":"面单打印",
        	"指定模板打印":"指定模板打印",
			"公司":"公司",
			"不刷新":"不刷新",
			"成功转草稿":"成功转草稿",
			"原产地":"原产地",
			"请选择至少一行\"草稿\"或\"已预报\"数据":"请选择至少一行\"草稿\"或\"已预报\"数据",
			"我是标题":"我是标题",
			"是否终止":"是否终止",
			"选择":"选择",
			"是否确定标记为已打印？":"是否确定标记为已打印？",
			"预报箱号":"预报箱号",
			"请选择订单状态是\"草稿\"的数据":"请选择订单状态是\"草稿\"的数据",
			"总价":"总价",
			"请选择要取消拦截的数据":"请选择要取消拦截的数据",
			"文件名":"文件名",
			"客户重量":"客户重量",
			"收货包号":"收货包号",
			"寄件区县":"寄件区县",
			"获取文件路径异常":"获取文件路径异常",
			"预报箱材积":"预报箱材积",
			"操作":"操作",
			"操作时间":"操作时间",
			"请选择":"请选择",
			"寄件人":"寄件人",
			"取消订单":"取消订单",
			"拦截":"拦截",
			"是否打印":"是否打印",
			"将不允许收货":"将不允许收货",
			"排货时间":"排货时间",
			"寄件税号":"寄件税号",
			"请选择订单！":"请选择订单！",
			"修改人":"修改人",
			"运单标签":"运单标签",
			"邮编":"邮编",
			"客户名称":"客户名称",
			"卖家昵称":"卖家昵称",
			"异常信息":"异常信息",
			"订单来源":"订单来源",
			"COD币别":"COD币别",
			"只有在已预报":"只有在已预报",
			"排货成功":"排货成功",
			"转寄原单号":"转寄原单号",
			"单价":"单价",
			"请选择要修改的数据":"请选择要修改的数据",
			"自定义信息":"自定义信息",
			"请选择订单状态是\"已收货\", \"已出货\",\"已预报\"的数据":"请选择订单状态是\"已收货\", \"已出货\",\"已预报\"的数据",
			"彻底删除订单将不能恢复，您真的要彻底删除吗？":"彻底删除订单将不能恢复，您真的要彻底删除吗？",
			"数量":"数量",
			"刷新":"刷新",
			"预报修改操作成功":"预报修改操作成功",
			"自定义备注":"自定义备注",
			"寄件网点":"寄件网点",
			"客户类型":"客户类型",
			"已预报的订单在收货时":"已预报的订单在收货时",
			"收件州省":"收件州省",
			"未选择数据，请选择后再打印":"未选择数据，请选择后再打印",
			"相关文件":"相关文件",
			"创建导出任务，请稍后在导出列表中下载！":"创建导出任务，请稍后在导出列表中下载！",
			"成功删除订单":"成功删除订单",
			"目的编码":"目的编码",
			"格式":"格式",
			"请输入单号！":"请输入单号！",
			"销售记录编码":"销售记录编码",
			"请选择订单状态是\"已删除\",\"已预报\"的数据":"请选择订单状态是\"已删除\",\"已预报\"的数据",
			"笔！":"笔！",
			"转单号码":"转单号码",
			"客户编码":"客户编码",
			"客户重量必须>=0.001":"客户重量必须>=0.001",
			"终止平台订单":"终止平台订单",
			"报关方式":"报关方式",
			"按单号导出":"按单号导出",
			"寄件州/省":"寄件州/省",
			"交易ID":"交易ID",
			"该订单没有明细！":"该订单没有明细！",
			"你真的要将选择的数据获取转单吗？(注意：此功能适合于快递订单)":"你真的要将选择的数据获取转单吗？(注意：此功能适合于快递订单)",
			"将不允许出货":"将不允许出货",
			"请选择报关方式":"请选择报关方式",
			"请选择一个客户后再进行全部收货":"请选择一个客户后再进行全部收货",
			"取消":"取消",
			"订单包号":"订单包号",
			"请选择要修改指定路线的数据":"请选择要修改指定路线的数据",
			"收件邮箱":"收件邮箱",
			"件数必须>=1":"件数必须>=1",
			"揽收人":"揽收人",
			"快递单号导出":"快递单号导出",
			"海关编码":"海关编码",
			"您将终止订单共":"您将终止订单共",
			"确定取消吗":"确定取消吗",
			"出货时间":"出货时间",
			"全部":"全部",
			"请选择要排货的订单数据":"请选择要排货的订单数据",
			"是否保存":"是否保存",
			"目的名称":"目的名称",
			"查询":"查询",
			"成功获取转单信息":"成功获取转单信息",
			"您真的要将选择的数据修改指定路线吗？":"您真的要将选择的数据修改指定路线吗？",
			"寄件电话":"寄件电话",
			"分拣分区":"分拣分区",
			"未获取到对应数据":"未获取到对应数据",
			"发票打印":"发票打印",
			"成功提交预报":"成功提交预报",
			"订单号码":"订单号码",
			"请选择包装类型":"请选择包装类型",
			"转草稿":"转草稿",
			"到付款":"到付款",
			"删除订单":"删除订单",
			"货物重量":"货物重量",
			"录单网点":"录单网点",
			"是否确定":"是否确定",
			"真的要将选择的订单申请拦截吗？":"真的要将选择的订单申请拦截吗？",
			"最多不能超过":"最多不能超过",
			"导入修改":"导入修改",
			"请输入拦截原因!":"请输入拦截原因!",
			"走货路线":"走货路线",
			"备注":"备注",
			"子单生成规则未设置，请重新设置":"子单生成规则未设置，请重新设置",
			"订单日期不能为空":"订单日期不能为空",
			"关闭":"关闭",
			"申请拦截后":"申请拦截后",
			"取消原因":"取消原因",
			"终止原因不能为空":"终止原因不能为空",
			"终止成功":"终止成功",
			"查录单":"查录单",
			"收件地址3":"收件地址3",
			"收件地址2":"收件地址2",
			"修改时间":"修改时间",
			"下载":"下载",
			"请选择一行数据":"请选择一行数据",
			"没有获取到下载地址！":"没有获取到下载地址！",
			"收件门牌":"收件门牌",
			"收件州":"收件州",
			"请选择至少一行数据":"请选择至少一行数据",
			"选择的订单拦截成功！":"选择的订单拦截成功！",
			"已提交收货请求！":"已提交收货请求！",
			"客户":"客户",
			"内容":"内容",
			"确定":"确定",
			"目的地编码":"目的地编码",
			"终止备注":"终止备注",
			"请选择订单状态是\"已删除\"的数据":"请选择订单状态是\"已删除\"的数据",
			"收货标签":"收货标签",
			"您选取":"您选取",
			"请选择小于50笔数据下载":"请选择小于50笔数据下载",
			"彻底删除":"彻底删除",
			"提交预报":"提交预报",
			"护照/身份证号":"护照/身份证号",
			"笔，无预报":"笔，无预报",
			"删除订单异常":"删除订单异常",
			"您当前选中订单":"您当前选中订单",
			"批量修改":"批量修改",
			"收件电话":"收件电话",
			"请选择要申请拦截的数据":"请选择要申请拦截的数据",
			"中文品名":"中文品名",
			"成功删除订单！":"成功删除订单！",
			"省":"省",
			"该订单无Invoice，无法下载":"该订单无Invoice，无法下载",
			"日志信息":"日志信息",
			"寄件邮箱":"寄件邮箱",
			"终止原因":"终止原因",
			"专线":"专线",
			"预报重":"预报重",
			"预报异常":"预报异常",
			"已收货情况下申请拦截":"已收货情况下申请拦截",
			"指定路线":"指定路线",
			"寄件州":"寄件州",
			"收货时间":"收货时间",
			"收件税号":"收件税号",
			"订单预报":"订单预报",
			"保存":"保存",
			"该订单暂无Api Request":"该订单暂无Api Request",
			"请选择要彻底删除的数据":"请选择要彻底删除的数据",
			"流水号位数不够，请重新设置":"流水号位数不够，请重新设置",
			"笔":"笔",
			"打单状态":"打单状态",
			"拦截原因":"拦截原因",
			"请选择至少一行\"草稿\",\"已预报\"数据":"请选择至少一行\"草稿\",\"已预报\"数据",
			"创建人":"创建人",
			"寄件时间":"寄件时间",
			"包装类型":"包装类型",
			"类别":"类别",
			"取消拦截成功":"取消拦截成功",
			"请选择订单状态是\"已预报\", \"已出货\",\"已收货\"的数据":"请选择订单状态是\"已预报\", \"已出货\",\"已收货\"的数据",
			"收货成功":"收货成功",
			"预报箱重量":"预报箱重量",
			"发票下载":"发票下载",
			"微软雅黑 Regular":"微软雅黑 Regular",
			"申请拦截":"申请拦截",
			"付款方式":"付款方式",
			"注意":"注意",
			"只查拦截":"只查拦截",
			"基本信息":"基本信息",
			"的订单共":"的订单共",
			"标签打印":"标签打印",
			"件数":"件数",
			"平台类型":"平台类型",
			"是否退回":"是否退回",
			"删除订单比较危险，您真的要删除吗？":"删除订单比较危险，您真的要删除吗？",
			"成功修改指定路线":"成功修改指定路线",
			"请求参数：":"请求参数：",
			"申报价值币别":"申报价值币别",
			"收件人信息":"收件人信息",
			"代收款币别":"代收款币别",
			"修改指定路线":"修改指定路线",
			"收件城市":"收件城市",
			"序号":"序号",
			"分拣码":"分拣码",
			"电话":"电话",
			"订单数据来源":"订单数据来源",
			"请选择订单状态是\"预报\"的数据":"请选择订单状态是\"预报\"的数据",
			"彻底删除订单完成，若删除失败，请在【预报异常】查看具体错误提示！":"彻底删除订单完成，若删除失败，请在【预报异常】查看具体错误提示！",
			"尾程订单结算":"尾程订单结算",
			"重置":"重置",
			"按快递单号导出":"按快递单号导出",
			"目的地":"目的地",
			"您真的要将选择的数据提交预报？":"您真的要将选择的数据提交预报？",
			"寄件国家":"寄件国家",
			"请选择需要打印的数据":"请选择需要打印的数据",
			"提示":"提示",
			"个字符":"个字符",
			"笔，已收货":"笔，已收货",
			"寄件地址3":"寄件地址3",
			"寄件地址2":"寄件地址2",
			"打印":"打印",
			"收件区县":"收件区县",
			"更多操作":"更多操作",
			"操作用户":"操作用户",
			"导出":"导出",
			"订单管理":"订单管理",
			"异常":"异常",
			"全部收货完成！":"全部收货完成！",
			"基础信息":"基础信息",
			"税金付款":"税金付款",
			"待收货":"待收货",
			"请选择一行运单数据":"请选择一行运单数据",
			"请选择订单状态是\"已预报\"或\"已收货\"的数据":"请选择订单状态是\"已预报\"或\"已收货\"的数据",
			"尾程订单":"尾程订单",
			"运单号码":"运单号码",
			"买家备注":"买家备注",
			"收件邮编":"收件邮编",
			"请选择至少一行已预报数据":"请选择至少一行已预报数据",
			"装包状态":"装包状态",
			"取消拦截失败":"取消拦截失败",
			"发票标签":"发票标签",
			"品牌":"品牌",
			"COD金额":"COD金额",
			"收件地址":"收件地址",
			"请先修改数据":"请先修改数据",
			"寄件地址":"寄件地址",
			"已收货的订单":"已收货的订单",
			"寄件邮编":"寄件邮编",
			"揽收时间":"揽收时间",
			"英文品名":"英文品名",
			"货物信息":"货物信息",
			"订单日期":"订单日期",
			"申报价值":"申报价值",
			"打印完成":"打印完成",
			"收件公司":"收件公司",
			"预报修改":"预报修改",
			"含子客户":"含子客户",
			"收件人":"收件人",
			"到付款币别":"到付款币别",
			"排货状态":"排货状态",
			"预报箱尺寸":"预报箱尺寸",
			"请选择要转草稿的数据":"请选择要转草稿的数据",
			"寄件城市":"寄件城市",
			"预报时间":"预报时间",
			"寄件人信息":"寄件人信息",
			"取消拦截":"取消拦截",
			"请输入拦截原因":"请输入拦截原因",
			"寄件公司":"寄件公司",
			"请选择指定路线":"请选择指定路线",
			"请选择要打印订单的数据":"请选择要打印订单的数据",
			"代收款":"代收款",
			"派件网点":"派件网点",
			"参考编号":"参考编号",
			"买家ID":"买家ID",
			"只能选中一行数据！":"只能选中一行数据！",
			"创建导出任务失败:":"创建导出任务失败:",
			"收货成功！":"收货成功！",
			"请选择一行\"草稿\"或\"已预报\"数据":"请选择一行\"草稿\"或\"已预报\"数据",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
			"请选择订单状态是\"已预报\",\"待排货\"的数据":"请选择订单状态是\"已预报\",\"待排货\"的数据",
			"收件国家":"收件国家",
			"货物类型":"货物类型",
			"请选择货物类型":"请选择货物类型",
			"收货异常":"收货异常",
			"创建时间":"创建时间",
			"收件手机":"收件手机",
			"请选择要获取转单号码的订单数据":"请选择要获取转单号码的订单数据",
			"订单状态":"订单状态",
			"城市":"城市",
			"可取消订单笔数":"可取消订单笔数",
			"提货时间":"提货时间",
			"平台运费":"平台运费",
			"保险金额":"保险金额",
			"首公里面单-二维码":"首公里面单-二维码",
		},
		"downloadorder":{
			"下载日志":"下载日志",
			"立即下载":"立即下载",
			"报文":"报文",
			"数据类型":"数据类型",
			"查询":"查询",
			"重置":"重置",
			"请选择至少一行数据":"请选择至少一行数据",
			"客户":"客户",
			"日志":"日志",
			"OIS订单":"OIS订单",
			"订单号码":"订单号码",
			"订单":"订单",
			"转单号码":"转单号码",
			"获取平台类型列表异常":"获取平台类型列表异常",
			"客户编码":"客户编码",
			"立即下载异常":"立即下载异常",
			"下载异常":"下载异常",
			"请求报文":"请求报文",
			"重量":"重量",
			"订单日期":"订单日期",
			"件数":"件数",
			"平台类型":"平台类型",
			"获取下载状态列表异常":"获取下载状态列表异常",
			"立即下载成功！":"立即下载成功！",
			"创建时间":"创建时间",
			"POS订单":"POS订单",
			"下载状态":"下载状态",
			"异常信息":"异常信息"
		},
		"TMS004":{
			"确定要删除吗？":"确定要删除吗？",
			"修改":"修改",
			"预报重":"预报重",
			"您选择的收货包存在已取消、已揽收、收货中或已收货的数据，禁止退货！":"您选择的收货包存在已取消、已揽收、收货中或已收货的数据，禁止退货！",
			"取消成功！":"取消成功！",
			"预报材重":"预报材重",
			"新增收货包":"新增收货包",
			"非WISH客户禁止退货！":"非WISH客户禁止退货！",
			"指定路线":"指定路线",
			"选择":"选择",
			"保存":"保存",
			"收货中":"收货中",
			"笔":"笔",
			"退货原因":"退货原因",
			"请选择收货中/已收货 的数据":"请选择收货中/已收货 的数据",
			"未揽收才允许退货！":"未揽收才允许退货！",
			"创建人":"创建人",
			"修改异常":"修改异常",
			"收货包号":"收货包号",
			"揽收重量（kg）":"揽收重量（kg）",
			"操作":"操作",
			"删除收货包异常":"删除收货包异常",
			"请选择":"请选择",
			"取消确认":"取消确认",
			"退货":"退货",
			"修改人":"修改人",
			"客户名称":"客户名称",
			"取件员":"取件员",
			"退件原因":"退件原因",
			"刷新运单异常":"刷新运单异常",
			"收货包号信息":"收货包号信息",
			"撤销提交":"撤销提交",
			"删除":"删除",
			"已收货":"已收货",
			"待收货票数":"待收货票数",
			"重置":"重置",
			"收货包管理":"收货包管理",
			"修改收货包":"修改收货包",
			"收货日期不能为空":"收货日期不能为空",
			"收货提交":"收货提交",
			"提示":"提示",
			"客户编码":"客户编码",
			"收货日期":"收货日期",
			"刷新运单":"刷新运单",
			"收货尺寸":"收货尺寸",
			"收货体积":"收货体积",
			"取消大包":"取消大包",
			"导出":"导出",
			"请输入":"请输入",
			"取消":"取消",
			"添加异常":"添加异常",
			"全部收货完成！":"全部收货完成！",
			"收货实重":"收货实重",
			"收货提交成功！":"收货提交成功！",
			"确定要撤销吗？":"确定要撤销吗？",
			"保存并继续":"保存并继续",
			"预报实重":"预报实重",
			"揽收人":"揽收人",
			"待收货":"待收货",
			"全部":"全部",
			"预报尺寸":"预报尺寸",
			"预报体积":"预报体积",
			"揽收日期":"揽收日期",
			"查询":"查询",
			"已收货票数":"已收货票数",
			"包状态":"包状态",
			"未获取到对应数据":"未获取到对应数据",
			"撤销成功！":"撤销成功！",
			"退件备注":"退件备注",
			"退件原因不能为空":"退件原因不能为空",
			"撤销提交异常":"撤销提交异常",
			"揽收时间":"揽收时间",
			"取消异常":"取消异常",
			"删除成功！":"删除成功！",
			"收货重":"收货重",
			"退货备注":"退货备注",
			"是否确定":"是否确定",
			"修改成功！":"修改成功！",
			"大包入库":"大包入库",
			"备注":"备注",
			"运单重":"运单重",
			"收货材重":"收货材重",
			"关闭":"关闭",
			"取消原因":"取消原因",
			"数据来源":"数据来源",
			"修改时间":"修改时间",
			"请选择一行数据":"请选择一行数据",
			"刷新运单成功！":"刷新运单成功！",
			"收货网点":"收货网点",
			"请选择至少一行数据":"请选择至少一行数据",
			"客户":"客户",
			"新增":"新增",
			"确定":"确定",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
			"预报日期":"预报日期",
			"添加成功！":"添加成功！",
			"货物类型":"货物类型",
			"总包数":"总包数",
			"请选择至少一行待收货数据":"请选择至少一行待收货数据",
			"确认":"确认",
			"创建时间":"创建时间",
			"您选择退货的订单共":"您选择退货的订单共",
			"总票数":"总票数",
			"请至少选择一行数据":"请至少选择一行数据",
			"是否退货":"是否退货",
			"退返后重出":"退返后重出",
		},
		"bagreceive":{
			"采集失败！":"采集失败！",
			"预报实重":"预报实重",
			"称重设备":"称重设备",
			"客户不能为空":"客户不能为空",
			"指定路线不能为空":"指定路线不能为空",
			"电子秤":"电子秤",
			"指定路线":"指定路线",
			"收费尺寸长宽高不能为0":"收费尺寸长宽高不能为0",
			"关闭":"关闭",
			"货物类型不能为空":"货物类型不能为空",
			"设备名称":"设备名称",
			"自动保留":"自动保留",
			"扫描装包失败！":"扫描装包失败！",
			"收货包管理":"收货包管理",
			"请填写端口":"请填写端口",
			"请选择设备":"请选择设备",
			"请选择一行数据":"请选择一行数据",
			"设备类型":"设备类型",
			"端口":"端口",
			"收货包号":"收货包号",
			"客户":"客户",
			"收费尺寸":"收费尺寸",
			"收货包号不能为空":"收货包号不能为空",
			"确定":"确定",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
			"提示":"提示",
			"黑体 Regular":"黑体 Regular",
			"收费重":"收费重",
			"请填写1-20的端口号":"请填写1-20的端口号",
			"收费实重":"收费实重",
			"自动":"自动",
			"你确定删除该预报包吗？":"你确定删除该预报包吗？",
			"预报包删除成功！":"预报包删除成功！",
			"货物类型":"货物类型",
			"重量采集设置":"重量采集设置",
			"请输入":"请输入",
			"波特率":"波特率",
			"开始采集":"开始采集",
			"取消":"取消",
			"客户名称":"客户名称",
			"总票数":"总票数",
			"收费实重不能为空":"收费实重不能为空",
			"预报包删除失败！":"预报包删除失败！"
		},
		"TMS121":{
			"再次外出派送失败":"再次外出派送失败",
			"末端退货移交给海外仓":"末端退货移交给海外仓",
			"退回到达海外仓":"退回到达海外仓",
			"退件派送服务-揽收中":"退件派送服务-揽收中",
			"港后退返客户":"港后退返客户",
			"离开起运地":"离开起运地",
			"到达目的国":"到达目的国",
			"入口清关站已通知提货":"入口清关站已通知提货",
			"原因描述":"原因描述",
			"原因码":"原因码",
			"货物到达转运中心":"货物到达转运中心",
			"包裹到达派件站点":"包裹到达派件站点",
			"首次外出派送失败":"首次外出派送失败",
			"再次外出派送":"再次外出派送",
			"投递":"投递",
			"包裹离开分拣仓库":"包裹离开分拣仓库",
			"二次外出派送":"二次外出派送",

			"重复扫描":"重复扫描",
			"港前退返客户":"港前退返客户",
			"最新下次跟进时间":"最新下次跟进时间",
			"最新跟进状态":"最新跟进状态",
			"最新跟进时间":"最新跟进时间",
			"最新跟进内容":"最新跟进内容",
        	"运单数量":"运单数量",
        	"下载Invoice":"下载Invoice",
			"预计件数":"预计件数",
			"实收件数":"实收件数",
        	"子单号":"子单号",
			"显示明文":"显示明文",
			"跟进日志导出":"跟进日志导出",
			"排除":"排除",
			"跟单员":"跟单员",
			"操作说明":"操作说明",
			"轨迹状态":"轨迹状态",
			"补录成功：":"补录成功：",
			"操作日志":"操作日志",
			"退返备注":"退返备注",
			"轨迹描述":"轨迹描述",
			"原产地":"原产地",
			"本位币金额":"本位币金额",
			"笔，删除失败":"笔，删除失败",
			"扫描分段":"扫描分段",
			"应付明细":"应付明细",
			"我是标题":"我是标题",
			"删除运单异常":"删除运单异常",
			"总价":"总价",
			"国外退件，退件单号为: ":"国外退件，退件单号为: ",
			"材积除以数":"材积除以数",
			"代理退件":"代理退件",
			"文件名":"文件名",
			"费用合计":"费用合计",
			"寄件区县":"寄件区县",
			"笔记录数据":"笔记录数据",
			"没有文件可以下载":"没有文件可以下载",
			"操作":"操作",
			"处理人":"处理人",
			"操作时间":"操作时间",
			"包装项目":"包装项目",
			"收件人名":"收件人名",
			"交货段":"交货段",
			"已入库":"已入库",
			"出口清关开始":"出口清关开始",
			"出口清关扣查":"出口清关扣查",
			"出口清关扣件不放行":"出口清关扣件不放行",
			"路由变更":"路由变更",
			"退件单号":"退件单号",
			"仓库重复扫描":"仓库重复扫描",
			"定为违禁品":"定为违禁品",
			"含":"含",
			"汇率":"汇率",
			"功能菜单":"功能菜单",
			"运/转/参考/收货袋单号,一次导出单号数量不能超过1000":"运/转/参考/收货袋单号,一次导出单号数量不能超过1000",
			"寄件税号":"寄件税号",
			"退返客户":"退返客户",
			"派送段":"派送段",
			"请勾选需要删除的运单！":"请勾选需要删除的运单！",
			"客户名称":"客户名称",
			"退件派送服务-已揽收":"退件派送服务-已揽收",
			"退件派送服务-移交":"退件派送服务-移交",
			"退返客户失败！":"退返客户失败！",
			"币别":"币别",
			"交货到末公里":"交货到末公里",
			"文件":"文件",
			"删除成功":"删除成功",
			"转寄原单号":"转寄原单号",
			"订单已支付":"订单已支付",
			"货物状态":"货物状态",
			"单价":"单价",
			"单件":"单件",
			"删除":"删除",
			"核销状态":"核销状态",
			"表格参数":"表格参数",
			"数量":"数量",
			"寄件网点":"寄件网点",
			"收件州省":"收件州省",
			"已核销":"已核销",
			"补录轨迹":"补录轨迹",
			"退返结果":"退返结果",
			"笔运单数据":"笔运单数据",
			"格式":"格式",
			"出货日期":"出货日期",
			"转单号码":"转单号码",
			"笔运单中补录轨迹":"笔运单中补录轨迹",
			"客户编码":"客户编码",
			"出货":"出货",
			"交货给干线代理":"交货给干线代理",
			"入口清关重新装箱":"入口清关重新装箱",
			"费用批量补录":"费用批量补录",
			"运单管理":"运单管理",
			"寄件日期不能为空":"寄件日期不能为空",
			"材重":"材重",
			"批量补录":"批量补录",
			"报关方式":"报关方式",
			"收件备注":"收件备注",
			"补录异常":"补录异常",
			"请输入":"请输入",
			"跟进人":"跟进人",
			"取消":"取消",
			"基本":"基本",
			"总运单":"总运单",
			"航班起飞":"航班起飞",
			"轨迹未更新天数":"轨迹未更新天数",
			"海关编码":"海关编码",
			"国外退件":"国外退件",
			"运单轨迹显示":"运单轨迹显示",
			"出货时间":"出货时间",
			"出货备注":"出货备注",
			"查询":"查询",
			"运单id为空":"运单id为空",
			"入口清关解除扣查":"入口清关解除扣查",
			"账单备注":"账单备注",
			"日志":"日志",
			"收费材重":"收费材重",
			"请选择运单":"请选择运单",
			"到付款":"到付款",
			"轨迹信息":"轨迹信息",
			"科目名称":"科目名称",
			">吗？":">吗？",
			"已二次转寄":"已二次转寄",
			"删除成功！":"删除成功！",
			"个问题件":"个问题件",
			"包裹损坏":"包裹损坏",
			"除以数":"除以数",
			"时间":"时间",
			"退件派送服务-分拣仓入库":"退件派送服务-分拣仓入库",
			"大包/总运单/出货批次号，一次导出单号数量不能超过300":"大包/总运单/出货批次号，一次导出单号数量不能超过300",
			"录单网点":"录单网点",
			"退件派送服务-分拣仓出库":"退件派送服务-分拣仓出库",
			"费用补录申请":"费用补录申请",
			"只允许勾选一条运单进行编辑轨迹":"只允许勾选一条运单进行编辑轨迹",
			"上传附件":"上传附件",
			"运费合计":"运费合计",
			"对账员":"对账员",
			"到达派件站点":"到达派件站点",
			"末端转运中":"末端转运中",
			"退件号码":"退件号码",
			"走货路线":"走货路线",
			"备注":"备注",
			"入口清关扣查":"入口清关扣查",
			"退回海外仓":"退回海外仓",
			"返回末端退货仓库":"返回末端退货仓库",
			"到达退回海外仓": "到达退回海外仓",
			"跟进网点":"跟进网点",
			"关闭":"关闭",
			"已对账":"已对账",
			"查录单":"查录单",
			"退返方式":"退返方式",
			"包裹到达自提点":"包裹到达自提点",
			"下载":"下载",
			"高":"高",
			"背景色设置":"背景色设置",
			"请选择一行数据":"请选择一行数据",
			"预报重量":"预报重量",
			"请选择至少一行数据":"请选择至少一行数据",
			"导入客服日志":"导入客服日志",
			"客户":"客户",
			"确定":"确定",
			"默认目的地":"默认目的地",
			"目的地编码":"目的地编码",
			"海关已放行":"海关已放行",
			"收费重":"收费重",
			"每行高亮":"每行高亮",
			"派送异常":"派送异常",
			"已出货，不允许删除！":"已出货，不允许删除！",
			"计算公式":"计算公式",
			"收件电话":"收件电话",
			"材重合计":"材重合计",
			"更多条件":"更多条件",
			"最新轨迹网点":"最新轨迹网点",
			"费用补录新增":"费用补录新增",
			"运单状态":"运单状态",
			"客户类型":"客户类型",
			"中文品名":"中文品名",
			"操作网点":"操作网点",
			"账单":"账单",
			"金额":"金额",
			"最新轨迹地点":"最新轨迹地点",
			"省":"省",
			"寄件邮箱":"寄件邮箱",
			"航班抵达":"航班抵达",
			"入口清关扣件不放行":"入口清关扣件不放行",
			"国外退件不允许批量操作":"国外退件不允许批量操作",
			"收件人拒收":"收件人拒收",
			"指定路线":"指定路线",
			"寄件州":"寄件州",
			"保存":"保存",
			"跟进内容":"跟进内容",
			"笔":"笔",
			"可多选":"可多选",
			"实重合计":"实重合计",
			"创建人":"创建人",
			"收费重合计":"收费重合计",
			"包装费合计":"包装费合计",
			"包装类型":"包装类型",
			"入口清关收货":"入口清关收货",
			"类别":"类别",
			"附件":"附件",
			"请选择数据":"请选择数据",
			"全部轨迹":"全部轨迹",
			"微软雅黑 Regular":"微软雅黑 Regular",
			"费用补录":"费用补录",
			"入口清关准备移交":"入口清关准备移交",
			"导入轨迹":"导入轨迹",
			"付款方式":"付款方式",
			"包裹丢失":"包裹丢失",
			"第":"第",
			"扫描编码":"扫描编码",
			"收货备注":"收货备注",
			"指定路线分类":"指定路线分类",
			"件数":"件数",
			"包装说明":"包装说明",
			"跟进时间":"跟进时间",
			"收件人信息":"收件人信息",
			"收件城市":"收件城市",
			"出口清关成功":"出口清关成功",
			"序号":"序号",
			"分拣码":"分拣码",
			"该运单无单件信息，无法下载":"该运单无单件信息，无法下载",
			"二次转寄上架":"二次转寄上架",
			"海外仓移出":"海外仓移出",
			"单号":"单号",
			"提交状态":"提交状态",
			"补录信息":"补录信息",
			"列样式":"列样式",
			"重置":"重置",
			"轨迹时间":"轨迹时间",
			"目的地":"目的地",
			"退返参数":"退返参数",
			"请选择货物状态":"请选择货物状态",
			"下载单件信息":"下载单件信息",
			"费用补录管理":"费用补录管理",
			"寄件国家":"寄件国家",
			"结算备注":"结算备注",
			"新增运单":"新增运单",
			"提示":"提示",
			"偏远":"偏远",
			"请选择运单！":"请选择运单！",
			"打印":"打印",
			"收件区县":"收件区县",
			"操作用户":"操作用户",
			"导出":"导出",
			"最新轨迹状态":"最新轨迹状态",
			"最新轨迹描述":"最新轨迹描述",
			"退返客户成功！":"退返客户成功！",
			"入口清关成功":"入口清关成功",
			"未对账":"未对账",
			"首次派送":"首次派送",
			"首次派送失败":"首次派送失败",
			"二次派送":"二次派送",
			"二次派送失败":"二次派送失败",
			"再次派送":"再次派送",
			"再次派送失败":"再次派送失败",
			"基础信息":"基础信息",
			"头程提单":"头程提单",
			"长":"长",
			"轨迹":"轨迹",
			"只能上传jpg/png/word/excel/pdf文件":"只能上传jpg/png/word/excel/pdf文件",
			"税金付款":"税金付款",
			"包裹销毁":"包裹销毁",
			"您选取了":"您选取了",
			"网点":"网点",
			"批量操作时，国外退件页签不允许切换":"批量操作时，国外退件页签不允许切换",
			"问题件":"问题件",
			"代理":"代理",
			"费用结算":"费用结算",
			"运单号码":"运单号码",
			"退返单号":"退返单号",
			"轨迹地点":"轨迹地点",
			"操作员":"操作员",
			"扫描状态":"扫描状态",
			"入口清关开始清关":"入口清关开始清关",
			"包装费":"包装费",
			"状态时间":"状态时间",
			"收件邮编":"收件邮编",
			"出货批次":"出货批次",
			"展开开关":"展开开关",
			"您选取的":"您选取的",
			"已签收":"已签收",
			"退回海外仓中":"退回海外仓中",
			"问题描述":"问题描述",
			"应收明细":"应收明细",
			"确定要删除勾选中的运单吗？":"确定要删除勾选中的运单吗？",
			"该运单无Invoice，无法下载":"该运单无Invoice，无法下载",
			"确定要删除<":"确定要删除<",
			"大包号":"大包号",
			"快速退返":"快速退返",
			"品牌":"品牌",
			"COD金额":"COD金额",
			"文件大小不能大于15MB":"文件大小不能大于15MB",
			"收件地址":"收件地址",
			"寄件地址":"寄件地址",
			"寄件邮编":"寄件邮编",
			"收件统编":"收件统编",
			"英文品名":"英文品名",
			"货物信息":"货物信息",
			"包裹到达分拣中心":"包裹到达分拣中心",
			"跟踪记录":"跟踪记录",
			"申报价值":"申报价值",
			"订单成功上传":"订单成功上传",
			"收件公司":"收件公司",
			"单件信息":"单件信息",
			"宽":"宽",
			"含子客户":"含子客户",
			"收件人":"收件人",
			"报表导出":"报表导出",
			"退返":"退返",
			"离开分拣仓":"离开分拣仓",
			"条，失败：":"条，失败：",
			"跟进日志":"跟进日志",
			"最新轨迹时间":"最新轨迹时间",
			"退返方式等于{第三方快递}时，退返单号必填":"退返方式等于{第三方快递}时，退返单号必填",
			"位置":"位置",
			"寄件城市":"寄件城市",
			"寄件人信息":"寄件人信息",
			"预览":"预览",
			"未更新天数":"未更新天数",
			"数据来源":"数据来源",
			"我们将在":"我们将在",
			"配置信息":"配置信息",
			"代收款":"代收款",
			"寄件日期":"寄件日期",
			"参考编号":"参考编号",
			"实重":"实重",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
			"计抛方式":"计抛方式",
			"其中可退返":"其中可退返",
			"收件国家":"收件国家",
			"走货路线分类":"走货路线分类",
			"收费实重":"收费实重",
			"操作方式":"操作方式",
			"文件正在下载，请稍等！！！":"文件正在下载，请稍等！！！",
			"入口清关移交卡车":"入口清关移交卡车",
			"运单修改":"运单修改",
			"货物类型":"货物类型",
			"操作成功":"操作成功",
			"处理时间":"处理时间",
			"关包":"关包",
			"创建时间":"创建时间",
			"预报袋号":"预报袋号",
			"编辑轨迹":"编辑轨迹",
			"派件网点":"派件网点",
			"出货实重":"出货实重",
			"出货材重":"出货材重",
			"尾程实重":"尾程实重",
			"尾程材重":"尾程材重"
		},
		"trajectorytrackingimport":{
			"历史日志":"历史日志",
			"订单导入成功":"订单导入成功",
			"成功":"成功",
			"状态":"状态",
			"导入中":"导入中",
			"上传失败":"上传失败",
			"导入文件不能超过10MB":"导入文件不能超过10MB",
			"运单号码":"运单号码",
			"验证中":"验证中",
			"验证失败":"验证失败",
			"解析中":"解析中",
			"请选择导入模版！":"请选择导入模版！",
			"失败":"失败",
			"解析失败":"解析失败",
			"导入":"导入",
			"导入历史日志":"导入历史日志",
			"总行数":"总行数",
			"请选择模版！":"请选择模版！",
			"导入时间":"导入时间",
			"导入成功才可下载":"导入成功才可下载",
			"模版下载":"模版下载",
			"错误说明":"错误说明",
			"导入文件":"导入文件",
			"请输入":"请输入",
			"文件下载":"文件下载",
			"上传中":"上传中",
			"行号":"行号",
			"错误行数":"错误行数",
			"导入模版":"导入模版"
		},
		"InvoicePreEdit":{
			"补录原因":"补录原因",
			"币别":"币别",
			"保存并继续":"保存并继续",
			"运单数据不存在！":"运单数据不存在！",
			"费用信息":"费用信息",
			"运单号码":"运单号码",
			"补录信息":"补录信息",
			"请输入正确的公式":"请输入正确的公式",
			"关闭":"关闭",
			"客户编号":"客户编号",
			"保存":"保存",
			"寄件网点":"寄件网点",
			"寄件时间":"寄件时间",
			"账单备注":"账单备注",
			"参考编号":"参考编号",
			">已收费用：":">已收费用：",
			"确定":"确定",
			"转单号码":"转单号码",
			"提示":"提示",
			"收费重":"收费重",
			"计算公式":"计算公式",
			",确认继续补收？":",确认继续补收？",
			"科目":"科目",
			"燃油加收比例":"燃油加收比例",
			"件数":"件数",
			"请输入":"请输入",
			"取消":"取消",
			"客户名称":"客户名称",
			"保存成功！":"保存成功！",
			"内部备注":"内部备注",
			"金额":"金额"
		},
		"BMS084":{
			"修改":"修改",
			"提交时间":"提交时间",
			"费用信息":"费用信息",
			"请选择要删除的数据！":"请选择要删除的数据！",
			"费用补录提交":"费用补录提交",
			"指定路线":"指定路线",
			"请输入正确的公式":"请输入正确的公式",
			"可多选":"可多选",
			"包装类型":"包装类型",
			"注意":"注意",
			"跟进记录":"跟进记录",
			"撤销确认":"撤销确认",
			"请选择要跟进的数据！":"请选择要跟进的数据！",
			"科目":"科目",
			"请选择要修改的数据！":"请选择要修改的数据！",
			"已提交导出任务，正在下载":"已提交导出任务，正在下载",
			"客户名称":"客户名称",
			"跟进时间":"跟进时间",
			"内部备注":"内部备注",
			"币别":"币别",
			"进入异常":"进入异常",
			"序号":"序号",
			"是否继续":"是否继续",
			"字数不能超过300，请修改后提交":"字数不能超过300，请修改后提交",
			"id为空不允许取消！，请选择待提交的数据":"id为空不允许取消！，请选择待提交的数据",
			"提交状态":"提交状态",
			"日期不能为空！":"日期不能为空！",
			"删除":"删除",
			"客户结算已存在科目":"客户结算已存在科目",
			"确认人":"确认人",
			"重置":"重置",
			"寄件网点":"寄件网点",
			"目的地":"目的地",
			"笔已提交或金额为0，是否继续(已提交数据不会被提交)？":"笔已提交或金额为0，是否继续(已提交数据不会被提交)？",
			"费用补录管理":"费用补录管理",
			"笔数据删除成功！":"笔数据删除成功！",
			"最多录入":"最多录入",
			"转单号码":"转单号码",
			"账单日期":"账单日期",
			"提示":"提示",
			"客户编码":"客户编码",
			"个字符":"个字符",
			"费用补录导出":"费用补录导出",
			"报关方式":"报关方式",
			"导出":"导出",
			"请选择要提交的数据！":"请选择要提交的数据！",
			"请输入":"请输入",
			"笔待提交，":"笔待提交，",
			"取消":"取消",
			"跟进人":"跟进人",
			"录入人":"录入人",
			"其中":"其中",
			"补录相关":"补录相关",
			"笔数据吗？(已提交数据不会被删除)":"笔数据吗？(已提交数据不会被删除)",
			"补录":"补录",
			"税金付款":"税金付款",
			"科目编码":"科目编码",
			"名称":"名称",
			"运单号码":"运单号码",
			"不可多条修改！":"不可多条修改！",
			"查询":"查询",
			"请选择要取消的数据！":"请选择要取消的数据！",
			"请输入跟进内容 ！":"请输入跟进内容 ！",
			"您选取的":"您选取的",
			"增值费导入":"增值费导入",
			"本次跟进":"本次跟进",
			"确认删除所选":"确认删除所选",
			"账单备注":"账单备注",
			"确认撤销所选":"确认撤销所选",
			"已提交数据不可修改！":"已提交数据不可修改！",
			"科目名称":"科目名称",
			"结算状态":"结算状态",
			"笔数据，其中":"笔数据，其中",
			"请选择未提交的数据和金额不为0的数据！":"请选择未提交的数据和金额不为0的数据！",
			"科目编号":"科目编号",
			"笔客户结算已有相同科目":"笔客户结算已有相同科目",
			"对账员":"对账员",
			"补录原因":"补录原因",
			"进入确认":"进入确认",
			"笔数据":"笔数据",
			"走货路线":"走货路线",
			"已有金额":"已有金额",
			"请选择要撤销的数据！":"请选择要撤销的数据！",
			"跟进":"跟进",
			"关闭":"关闭",
			"取消原因":"取消原因",
			"销售员":"销售员",
			"笔成功！":"笔成功！",
			"数据来源":"数据来源",
			"提交":"提交",
			"提交异常":"提交异常",
			"请选择待提交的数据":"请选择待提交的数据",
			"客户":"客户",
			"内容":"内容",
			"已提交数据不会被提交":"已提交数据不会被提交",
			"费用补录修改":"费用补录修改",
			"寄件日期":"寄件日期",
			"参考编号":"参考编号",
			"导入":"导入",
			"确定":"确定",
			"确认时间":"确认时间",
			"最新状态":"最新状态",
			"提交人":"提交人",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
			"收费重":"收费重",
			"计算公式":"计算公式",
			"笔数撤销成功！":"笔数撤销成功！",
			"不可多条跟进！":"不可多条跟进！",
			"笔已提交":"笔已提交",
			"跟进成功！":"跟进成功！",
			"笔数取消成功！":"笔数取消成功！",
			"货物类型":"货物类型",
			"费用补录新增":"费用补录新增",
			"运单状态":"运单状态",
			"确认":"确认",
			"录入时间":"录入时间",
			"补录相关不能为空！":"补录相关不能为空！",
			"金额":"金额"
		},
		"BMSAdd":{
			"历史日志":"历史日志",
			"成功":"成功",
			"状态":"状态",
			"上传失败":"上传失败",
			"导入中":"导入中",
			"导入文件不能超过10MB":"导入文件不能超过10MB",
			"文件大小不超过":"文件大小不超过",
			"验证中":"验证中",
			"批次号":"批次号",
			"验证失败":"验证失败",
			"解析中":"解析中",
			"请选择导入模版！":"请选择导入模版！",
			"失败":"失败",
			"解析失败":"解析失败",
			"导入":"导入",
			"导入历史日志":"导入历史日志",
			"总行数":"总行数",
			"请选择模版！":"请选择模版！",
			"导入时间":"导入时间",
			"模版下载":"模版下载",
			"导入文件格式支持":"导入文件格式支持",
			"错误说明下载":"错误说明下载",
			"运单号":"运单号",
			"导入文件":"导入文件",
			"请输入":"请输入",
			"文件下载":"文件下载",
			"上传中":"上传中",
			"错误信息":"错误信息",
			"行号":"行号",
			"错误行数":"错误行数",
			"导入模版":"导入模版"
		},
		"custlogimport":{
			"历史日志":"历史日志",
			"成功":"成功",
			"状态":"状态",
			"导入中":"导入中",
			"上传失败":"上传失败",
			"导入文件不能超过10MB":"导入文件不能超过10MB",
			"运单号码":"运单号码",
			"验证中":"验证中",
			"验证失败":"验证失败",
			"解析中":"解析中",
			"请选择导入模版！":"请选择导入模版！",
			"失败":"失败",
			"解析失败":"解析失败",
			"导入":"导入",
			"导入历史日志":"导入历史日志",
			"总行数":"总行数",
			"请选择模版！":"请选择模版！",
			"客服日志导入成功":"客服日志导入成功",
			"导入时间":"导入时间",
			"导入成功才可下载":"导入成功才可下载",
			"模版下载":"模版下载",
			"错误说明":"错误说明",
			"导入文件":"导入文件",
			"请输入":"请输入",
			"文件下载":"文件下载",
			"上传中":"上传中",
			"行号":"行号",
			"错误行数":"错误行数",
			"导入模版":"导入模版"
		},
		"TMS076":{
			"修改":"修改",
			"寄件邮箱":"寄件邮箱",
			"单件取大不计抛":"单件取大不计抛",
			"净重":"净重",
			"收费重为0，不允许保存":"收费重为0，不允许保存",
			">设置的邮编目的地规则，收件邮编<":">设置的邮编目的地规则，收件邮编<",
			"请选择代收币别!":"请选择代收币别!",
			"原产地":"原产地",
			"录入件数为":"录入件数为",
			"助手返回任务id失败":"助手返回任务id失败",
			"已加入自动追踪任务":"已加入自动追踪任务",
			"指定路线":"指定路线",
			"{附加项目:":"{附加项目:",
			"收件税号":"收件税号",
			"保存":"保存",
			"根据指定路线<":"根据指定路线<",
			"总价":"总价",
			"尺寸复制":"尺寸复制",
			"包装类型":"包装类型",
			"寄件区县":"寄件区县",
			"操作":"操作",
			"包装项目":"包装项目",
			"存在不收件，请重新填写标红件！":"存在不收件，请重新填写标红件！",
			"寄件人":"寄件人",
			"付款方式":"付款方式",
			"注意":"注意",
			"确定删除当前所有单件信息？":"确定删除当前所有单件信息？",
			"件数":"件数",
			">分拣的目的地为<":">分拣的目的地为<",
			"寄件税号":"寄件税号",
			"包装说明":"包装说明",
			"当前指定路线的计抛方式发生变化，收费重由<":"当前指定路线的计抛方式发生变化，收费重由<",
			"件，是否清除多余的件数":"件，是否清除多余的件数",
			"净重必须大于等于0":"净重必须大于等于0",
			"取件员":"取件员",
			"追踪进行中，请稍候查询":"追踪进行中，请稍候查询",
			"币别":"币别",
			"收件城市":"收件城市",
			"序号":"序号",
			"分拣码":"分拣码",
			"出货重":"出货重",
			"当前指定路线的材积除以数由<":"当前指定路线的材积除以数由<",
			"单价":"单价",
			"删除":"删除",
			"全部清除":"全部清除",
			"运单信息":"运单信息",
			"运单号码<":"运单号码<",
			"数量":"数量",
			"寄件网点":"寄件网点",
			"收件州省":"收件州省",
			"目的地":"目的地",
			"毛重":"毛重",
			"寄件国家":"寄件国家",
			"进位后收费重:":"进位后收费重:",
			"英文品名不能为空":"英文品名不能为空",
			"其他科目":"其他科目",
			"结算备注":"结算备注",
			"转单号码":"转单号码",
			"提示":"提示",
			"请选择到付币别!":"请选择到付币别!",
			"存在为空数据,不允许保存和关闭":"存在为空数据,不允许保存和关闭",
			"材重":"材重",
			"报关方式":"报关方式",
			"收件区县":"收件区县",
			"单件进位规则":"单件进位规则",
			"收件备注":"收件备注",
			"导出":"导出",
			"取消":"取消",
			"同步复制实重":"同步复制实重",
			"以下录入的都为单件信息":"以下录入的都为单件信息",
			">变为<":">变为<",
			"出货实重":"出货实重",
			"收件邮箱":"收件邮箱",
			"长":"长",
			"配货信息":"配货信息",
			"请选择寄件日期":"请选择寄件日期",
			"税金付款":"税金付款",
			"海关编码":"海关编码",
			"确认删除当前单件信息？":"确认删除当前单件信息？",
			"费用结算":"费用结算",
			"运单号码":"运单号码",
			"出货备注":"出货备注",
			"包装费":"包装费",
			"运单":"运单",
			"寄件电话":"寄件电话",
			"收件邮编":"收件邮编",
			"请选择指定路线!":"请选择指定路线!",
			"分拣分区":"分拣分区",
			"请输入收费实重":"请输入收费实重",
			">改为<":">改为<",
			"请选择需要删除的单件信息!":"请选择需要删除的单件信息!",
			"物流助手初始化失败,请稍后重试":"物流助手初始化失败,请稍后重试",
			"收费材重":"收费材重",
			"信息":"信息",
			"收件地址":"收件地址",
			"寄件地址":"寄件地址",
			"到付款":"到付款",
			"毛重必须大于等于0":"毛重必须大于等于0",
			"寄件邮编":"寄件邮编",
			"当前指定路线为空改为<":"当前指定路线为空改为<",
			"英文品名":"英文品名",
			"显示":"显示",
			"存在为0数据,不允许保存和关闭":"存在为0数据,不允许保存和关闭",
			"货物信息":"货物信息",
			"除以数":"除以数",
			"申报价值":"申报价值",
			"收件公司":"收件公司",
			"单票计抛规则":"单票计抛规则",
			"单件信息":"单件信息",
			"宽":"宽",
			"修改成功！":"修改成功！",
			"收件人":"收件人",
			"当前指定路线的计抛方式发生变化，请重新保存单件信息":"当前指定路线的计抛方式发生变化，请重新保存单件信息",
			">，请重新保存单件信息":">，请重新保存单件信息",
			"出货材重":"出货材重",
			"件，而单件数为":"件，而单件数为",
			"寄件城市":"寄件城市",
			"实重材重同时为0，不允许保存和关闭":"实重材重同时为0，不允许保存和关闭",
			"最小重量":"最小重量",
			"未找到对应运单，请重新填写":"未找到对应运单，请重新填写",
			"寄件公司":"寄件公司",
			"高":"高",
			"根据计抛得出收费重:":"根据计抛得出收费重:",
			"单件信息件数与运单件数不一致，是否继续保存":"单件信息件数与运单件数不一致，是否继续保存",
			"客户":"客户",
			"请选择指定路线":"请选择指定路线",
			"代收款":"代收款",
			"寄件日期":"寄件日期",
			"追踪结束":"追踪结束",
			"参考编号":"参考编号",
			"确定":"确定",
			"实重":"实重",
			"单票进位规则":"单票进位规则",
			"收费重":"收费重",
			"--请求轨迹原数据失败--":"--请求轨迹原数据失败--",
			"收件国家":"收件国家",
			"保存&S":"保存&S",
			"收费实重":"收费实重",
			"全部删除":"全部删除",
			"生效类型":"生效类型",
			"收件电话":"收件电话",
			">收货中，限制修改!":">收货中，限制修改!",
			"货物类型":"货物类型",
			"中文品名":"中文品名",
			"请选择货物类型":"请选择货物类型",
			"确定删除此行吗？":"确定删除此行吗？",
			"寄件州省":"寄件州省",
			"金额":"金额"
		},
		"TMS063":{
			"历史日志":"历史日志",
			"成功":"成功",
			"状态":"状态",
			"导入中":"导入中",
			"上传失败":"上传失败",
			"导入文件不能超过10MB":"导入文件不能超过10MB",
			"适用于提前导入代理重量":"适用于提前导入代理重量",
			"文件大小不超过":"文件大小不超过",
			"运单号码":"运单号码",
			"验证中":"验证中",
			"导入时":"导入时",
			"导入重量小于收费重时":"导入重量小于收费重时",
			"批次号":"批次号",
			"验证失败":"验证失败",
			"解析中":"解析中",
			"请选择导入模版！":"请选择导入模版！",
			"失败":"失败",
			"解析失败":"解析失败",
			"导入":"导入",
			"请确认导入模板中表头的完整性":"请确认导入模板中表头的完整性",
			"导入历史日志":"导入历史日志",
			"总行数":"总行数",
			"请选择模版！":"请选择模版！",
			"导入时间":"导入时间",
			"模版下载":"模版下载",
			"运单修改标准模版":"运单修改标准模版",
			"导入文件格式支持":"导入文件格式支持",
			"错误说明":"错误说明",
			"导入文件":"导入文件",
			"请输入":"请输入",
			"导入成功":"导入成功",
			"不修改":"不修改",
			"文件下载":"文件下载",
			"上传中":"上传中",
			"行号":"行号",
			"错误行数":"错误行数",
			"导入模版":"导入模版",
			"新增模板":"新增模板"
		},
		"TMS062":{
			"&费用合计":"&费用合计",
			"取消审核成功！":"取消审核成功！",
			"&计抛规则":"&计抛规则",
			"审核人":"审核人",
			"变更状态":"变更状态",
			"运单号码":"运单号码",
			"&指定路线":"&指定路线",
			"请选择待审核的变更记录":"请选择待审核的变更记录",
			"审核时间":"审核时间",
			"&付款方式":"&付款方式",
			"查询":"查询",
			"&包装类型":"&包装类型",
			"&收费重":"&收费重",
			"全部审核":"全部审核",
			"&收费材重":"&收费材重",
			"全部审核成功！":"全部审核成功！",
			"&报关方式":"&报关方式",
			"审核成功！":"审核成功！",
			"&合计币别":"&合计币别",
			"审核失败！":"审核失败！",
			"&收费实重":"&收费实重",
			"&寄件日期":"&寄件日期",
			"笔运单的变更申请？":"笔运单的变更申请？",
			"&到付币别":"&到付币别",
			"对账员":"对账员",
			"&货物类型":"&货物类型",
			"请选择申请变更时间":"请选择申请变更时间",
			"变更来源":"变更来源",
			"&走货路线":"&走货路线",
			"&出货重":"&出货重",
			"取消变更":"取消变更",
			"重置":"重置",
			"查录单":"查录单",
			"寄件网点":"寄件网点",
			"取消审核失败！":"取消审核失败！",
			"&客户编码":"&客户编码",
			"请选择至少一行数据":"请选择至少一行数据",
			"客户":"客户",
			"&派件网点":"&派件网点",
			"批量审核":"批量审核",
			"申请人":"申请人",
			"寄件日期":"寄件日期",
			"参考编号":"参考编号",
			"确定":"确定",
			"自动审核":"自动审核",
			"转单号码":"转单号码",
			"&寄件网点":"&寄件网点",
			"请选择至少一行待审核数据":"请选择至少一行待审核数据",
			"提示":"提示",
			"&目的地":"&目的地",
			"其他费用":"其他费用",
			"请选择变更记录":"请选择变更记录",
			"申请变更时间":"申请变更时间",
			"导出":"导出",
			"取消":"取消",
			"确定取消":"确定取消",
			"&到付款":"&到付款"
		},
		"BMS012":{
			"汇总票数":"汇总票数",
			"注意：":"注意：",
			"票数为指定路线+月份汇总票数除以月工作日后的平均票数":"票数为指定路线+月份汇总票数除以月工作日后的平均票数",
			"更多条件":"更多条件",
			"月工作日平均票数":"月工作日平均票数",
            "默认系统时间":"默认系统时间",
				"尾程":"尾程",
				"路线大类":"路线大类",
				"全部路线大类":"全部路线大类",
				"名称":"名称",
				"附加费包括":"附加费包括",
				"路线分类":"路线分类",
				"指定路线":"指定路线",
				"查询":"查询",
				"报价生效日期":"报价生效日期",
				"收件邮编":"收件邮编",
				"请选择目的地":"请选择目的地",
				"运费单价":"运费单价",
				"材积除以数":"材积除以数",
				"查询报价":"查询报价",
				"渠道发货要求和目的地国家的限制条件都会记录在备注中":"渠道发货要求和目的地国家的限制条件都会记录在备注中",
				"包装类型":"包装类型",
				"总运费":"总运费",
				"请选择包装类型":"请选择包装类型",
				"下单":"下单",
				"安检费":"安检费",
				"本币金额合计":"本币金额合计",
				"温馨提示":"温馨提示",
				"科目名称":"科目名称",
				"公式":"公式",
				"其他费用明细":"其他费用明细",
				"货物重量":"货物重量",
				"业务类型":"业务类型",
				"全部业务类型":"全部业务类型",
				"时间":"时间",
				"件数":"件数",
				"起运地":"起运地",
				"指定路线编码":"指定路线编码",
				"报价备注":"报价备注",
				"防疫物资附加费等杂费":"防疫物资附加费等杂费",
				"请输入货物重量":"请输入货物重量",
				"宽":"宽",
				"收件城市":"收件城市",
				"币别":"币别",
				"序号":"序号",
				"旺季附加费":"旺季附加费",
				"停用时间":"停用时间",
				"单价":"单价",
				"关闭":"关闭",
				"重置":"重置",
				"参考时效":"参考时效",
				"计算公式的计算结果":"计算公式的计算结果",
				"收件州省":"收件州省",
				"目的地":"目的地",
				"高":"高",
				"本币金额":"本币金额",
				"本币":"本币",
				"头程":"头程",
				"原币运费":"原币运费",
				"附加费用明细":"附加费用明细",
				"附加费":"附加费",
				"计算公式(头程+尾程)":"计算公式(头程+尾程)",
				"生效日期":"生效日期",
				"收费重":"收费重",
				"具体发货前请仔细查看备注":"具体发货前请仔细查看备注",
				"头程运费":"头程运费",
				"费用项":"费用项",
				"报价分段":"报价分段",
				"计算公式":"计算公式",
				"报价备注说明":"报价备注说明",
				"请选择起运地":"请选择起运地",
				"总费用":"总费用",
				"应收客服费等杂费":"应收客服费等杂费",
				"收件区县":"收件区县",
				"货物类型":"货物类型",
				"请输入货物类型":"请输入货物类型",
				"运费":"运费",
				"尾程运费":"尾程运费",
				"禁运货物类型":"禁运货物类型",
				"金额":"金额",
				"长":"长",
				"客户":"客户",
            	"客户分组":"客户分组",
				"显示已停用路线":"显示已停用路线",
        },
		"BMS121":{
			"预计产生偏远费":"预计产生偏远费",
			"请输入收费重":"请输入收费重",
			"城市":"城市",
			"城市必填其一":"城市必填其一",
			"专线偏远根据邮编、地址、区县、城市判断，请填写其中任何一项！":"专线偏远根据邮编、地址、区县、城市判断，请填写其中任何一项！",
			"必填":"必填",
			"指定路线":"指定路线",
			"匹配规则":"匹配规则",
			"州省":"州省",
			"区县":"区县",
			"查询":"查询",
			"地址关键字模糊匹配":"地址关键字模糊匹配",
			"重置":"重置",
			"邮编":"邮编",
			"请选择目的地":"请选择目的地",
			"不偏远":"不偏远",
			"最多":"最多",
			"目的地":"目的地",
			"查询信息":"查询信息",
			"请选择指定路线":"请选择指定路线",
			"当前查询结果为":"当前查询结果为",
			"地址":"地址",
			"收费重":"收费重",
			"偏远":"偏远",
			"建议全部填写":"建议全部填写",
			"位小数":"位小数",
			"城市完全匹配":"城市完全匹配",
			"客户":"客户"
		},
		"MOA001":{
			"重复数据：":"重复数据：",
			"成功":"成功",
			"状态":"状态",
			"响应总笔数":"响应总笔数",
			"写入失败：":"写入失败：",
			"请选择":"请选择",
			"写入成功：":"写入成功：",
			"请求时间":"请求时间",
			"响应总笔数：":"响应总笔数：",
			"写入成功":"写入成功",
			"返回最大ID":"返回最大ID",
			"查询":"查询",
			"轨迹对接监控":"轨迹对接监控",
			"请求次数：":"请求次数：",
			"写入失败":"写入失败",
			"导出":"导出",
			"请求次数":"请求次数",
			"响应时间":"响应时间",
			"请求起始ID":"请求起始ID",
			"重复数据":"重复数据",
			"响应报文摘要":"响应报文摘要",
			"失败":"失败"
		},
		"spiderTrajectoryDetail":{
			"轨迹编码":"轨迹编码",
			"末端供应商":"末端供应商",
			"轨迹位置":"轨迹位置",
			"导出":"导出",
			"轨迹时间":"轨迹时间",
			"轨迹异常详情":"轨迹异常详情",
			"异常描述":"异常描述",
			"追踪单号":"追踪单号",
			"轨迹描述":"轨迹描述"
		},
		"MOA003":{
			"轨迹位置":"轨迹位置",
			"操作失败":"操作失败",
			"状态":"状态",
			"轨迹描述":"轨迹描述",
			"运单号码":"运单号码",
			"查询":"查询",
			"推送状态":"推送状态",
			"参考号码":"参考号码",
			"轨迹时间":"轨迹时间",
			"收费重(g)":"收费重(g)",
			"客户":"客户",
			"是否要进行推送":"是否要进行推送",
			"确定":"确定",
			"数据推送时间":"数据推送时间",
			"已推送":"已推送",
			"转单号码":"转单号码",
			"提示":"提示",
			"轨迹推送监控":"轨迹推送监控",
			"客户编码":"客户编码",
			"异常描述":"异常描述",
			"待推送":"待推送",
			"导出":"导出",
			"数据写入时间":"数据写入时间",
			"取消":"取消",
			"客户名称":"客户名称",
			"确认后，轨迹数据将会进行再次推送，请耐心等待":"确认后，轨迹数据将会进行再次推送，请耐心等待",
			"再次推送":"再次推送",
			"异常":"异常",
			"请选择异常数据进行推送":"请选择异常数据进行推送"
		},
		"MOA004":{
			"日志监控":"日志监控",
			"数据集":"数据集",
			"事件":"事件",
			"状态":"状态",
			"日期不能为空":"日期不能为空",
			"消费时间":"消费时间",
			"异常描述":"异常描述",
			"发送时间":"发送时间",
			"消费异常":"消费异常",
			"查询":"查询",
			"导出":"导出",
			"仅查询补发":"仅查询补发",
			"生产者":"生产者",
			"是否补发":"是否补发",
			"异常":"异常",
			"主数据单号":"主数据单号"
		},
		"MOA005":{
			"成功":"成功",
			"状态":"状态",
			"服务接口":"服务接口",
			"快递单号":"快递单号",
			"运单号码":"运单号码",
			"重新推送":"重新推送",
			"我是标题":"我是标题",
			"查询":"查询",
			"接口":"接口",
			"响应报文":"响应报文",
			"菜鸟":"菜鸟",
			"推送":"推送",
			"接口类型":"接口类型",
			"请求参数":"请求参数",
			"接口信息":"接口信息",
			"失败":"失败",
			"请选择数据":"请选择数据",
			"推送时间":"推送时间",
			"参考编号":"参考编号",
			"微软雅黑 Regular":"微软雅黑 Regular",
			"主单号数据":"主单号数据",
			"异常描述":"异常描述",
			"请求时间":"请求时间",
			"接口code":"接口code",
			"平台对接监控":"平台对接监控",
			"请求报文":"请求报文",
			"导出":"导出",
			"重新推送执行成功，请在页面查看推送结果":"重新推送执行成功，请在页面查看推送结果",
			"创建时间":"创建时间",
			"推送时间不能为空":"推送时间不能为空",
			"执行次数":"执行次数",
			"主数据单号":"主数据单号"
		},
		"MOA007":{
			"COD币别":"COD币别",
			"状态":"状态",
			"时间不能为空":"时间不能为空",
			"运单号码":"运单号码",
			"请选择要推送的数据":"请选择要推送的数据",
			"查询":"查询",
			"推送状态":"推送状态",
			"确认后，数据将会进行再次推送，请耐心等待":"确认后，数据将会进行再次推送，请耐心等待",
			"收件人电话":"收件人电话",
			"签收时间":"签收时间",
			"客户":"客户",
			"珊瑚":"珊瑚",
			"寄件日期":"寄件日期",
			"参考编号":"参考编号",
			"COD金额":"COD金额",
			"数据推送时间":"数据推送时间",
			"转单号码":"转单号码",
			"客户编码":"客户编码",
			"异常描述":"异常描述",
			"待推送:":"待推送:",
			"订单日期":"订单日期",
			"非异常数据不能推送":"非异常数据不能推送",
			"已推送:":"已推送:",
			"异常:":"异常:",
			"导出":"导出",
			"数据写入时间":"数据写入时间",
			"监控":"监控",
			"客户名称":"客户名称",
			"再次推送":"再次推送",
			"收件人":"收件人"
		},
		"MOA006":{
			"推送重量":"推送重量",
			"大包总票数":"大包总票数",
			"操作失败":"操作失败",
			"状态":"状态",
			"走货路线":"走货路线",
			"派送代理":"派送代理",
			"查询":"查询",
			"推送状态":"推送状态",
			"特殊单号":"特殊单号",
			"确认后，数据将会进行再次推送，请耐心等待":"确认后，数据将会进行再次推送，请耐心等待",
			"推送票数":"推送票数",
			"是否要进行推送":"是否要进行推送",
			"大包号":"大包号",
			"推送时间":"推送时间",
			"大包核重重量":"大包核重重量",
			"确定":"确定",
			"提示":"提示",
			"异常描述":"异常描述",
			"大包总实重":"大包总实重",
			"请求报文":"请求报文",
			"待推送:":"待推送:",
			"已推送:":"已推送:",
			"异常:":"异常:",
			"导出":"导出",
			"目的国家简码":"目的国家简码",
			"推送监控":"推送监控",
			"数据写入时间":"数据写入时间",
			"取消":"取消",
			"总运单":"总运单",
			"再次推送":"再次推送",
			"请选择异常数据进行推送":"请选择异常数据进行推送",
			"头程提单":"头程提单",
			"必须为异常的数据才允许再次推送":"必须为异常的数据才允许再次推送"
		},
		"MOA009":{

		},
		"outboundLogDtl":{
			"分拣码":"分拣码",
			"走货路线":"走货路线",
			"派送代理":"派送代理",
			"运单号码":"运单号码",
			"指定路线":"指定路线",
			"参考编号回车搜索":"参考编号回车搜索",
			"收件邮编":"收件邮编",
			"寄件网点":"寄件网点",
			"分拣分区":"分拣分区",
			"目的地":"目的地",
			"客户":"客户",
			"大包号":"大包号",
			"寄件日期":"寄件日期",
			"参考编号":"参考编号",
			"收费材重":"收费材重",
			"转单号码":"转单号码",
			"收费重":"收费重",
			"客户编码":"客户编码",
			"收费实重":"收费实重",
			"输入运单":"输入运单",
			"报关方式":"报关方式",
			"件数":"件数",
			"货物类型":"货物类型",
			"转单":"转单",
			"出货实重":"出货实重"
		},
		"bagdetails":{
			"确定要撤销运单吗？":"确定要撤销运单吗？",
			"排货状态":"排货状态",
			"分拣码":"分拣码",
			"走货路线":"走货路线",
			"运单号码":"运单号码",
			"指定路线":"指定路线",
			"参考编号回车搜索":"参考编号回车搜索",
			"查询":"查询",
			"请选择至少一行已排货运单数据":"请选择至少一行已排货运单数据",
			"重置":"重置",
			"收件邮编":"收件邮编",
			"寄件网点":"寄件网点",
			"目的地":"目的地",
			"分拣分区":"分拣分区",
			"选取运单异常":"选取运单异常",
			"请选择一行数据":"请选择一行数据",
			"请选择至少一行数据":"请选择至少一行数据",
			"撤销运单异常":"撤销运单异常",
			"客户":"客户",
			"入库时间不能为空":"入库时间不能为空",
			"大包号":"大包号",
			"派件网点":"派件网点",
			"寄件日期":"寄件日期",
			"撤销运单":"撤销运单",
			"参考编号":"参考编号",
			"收费材重":"收费材重",
			"确定":"确定",
			"入库时间":"入库时间",
			"选取运单成功！":"选取运单成功！",
			"转单号码":"转单号码",
			"提示":"提示",
			"收费重":"收费重",
			"客户编码":"客户编码",
			"收费实重":"收费实重",
			"输入运单":"输入运单",
			"报关方式":"报关方式",
			"件数":"件数",
			"关联总运单号":"关联总运单号",
			"货物类型":"货物类型",
			"选取运单":"选取运单",
			"转单":"转单",
			"取消":"取消",
			"撤销运单成功！":"撤销运单成功！",
			"选择运单":"选择运单",
			"出货实重":"出货实重"
		},

		"BMS807":{
			"确定要删除吗？":"确定要删除吗？",
			"修改":"修改",
			"刷新统计数据":"刷新统计数据",
			"已预报未转结算的订单":"已预报未转结算的订单",
			"仅统计已转结算的订单":"仅统计已转结算的订单",
			"刷新统计数据时":"刷新统计数据时",
			"请选择寄件月份刷新统计数据！":"请选择寄件月份刷新统计数据！",
			"说明":"说明",
			"分类编码":"分类编码",
			"指定路线":"指定路线",
			"刷新统计数据失败！":"刷新统计数据失败！",
			"寄件月份/月工作日":"寄件月份/月工作日",
			"查询":"查询",
			"结果四舍五入后取整":"结果四舍五入后取整",
			"保存":"保存",
			"不在统计范围之内":"不在统计范围之内",
			"可多选":"可多选",
			"未刷新月份的数据":"未刷新月份的数据",
			"新增寄件月份/月工作日":"新增寄件月份/月工作日",
			"建议按月份刷新":"建议按月份刷新",
			"工作日平均票数":"工作日平均票数",
			"选择月":"选择月",
			"用于计算工作日平均票数":"用于计算工作日平均票数",
			"修改寄件月份/月工作日":"修改寄件月份/月工作日",
			"工作日平均票数,起始值不能大于终止值！":"工作日平均票数,起始值不能大于终止值！",
			"天":"天",
			"删除成功！":"删除成功！",
			"则报价计算结果也为":"则报价计算结果也为",
			"指定路线分类":"指定路线分类",
			"按寄件月份":"按寄件月份",
			"工作日平均票数用于阶梯计费":"工作日平均票数用于阶梯计费",
			"客户名称":"客户名称",
			"汇总票数为":"汇总票数为",
			"修改成功！":"修改成功！",
			"统计的总票数":"统计的总票数",
			">已存在统计明细数据，变更月工作日后，请再次刷新统计数据！":">已存在统计明细数据，变更月工作日后，请再次刷新统计数据！",
			"获取寄件月份/月工作日树异常":"获取寄件月份/月工作日树异常",
			"增加":"增加",
			"寄件月份":"寄件月份",
			"刷新统计数据成功！":"刷新统计数据成功！",
			"删除":"删除",
			"关闭":"关闭",
			"则需要再次刷新统计数据":"则需要再次刷新统计数据",
			"重置":"重置",
			"报表说明":"报表说明",
			"月工作日已存在统计明细":"月工作日已存在统计明细",
			"汇总票数,起始值不能大于终止值！":"汇总票数,起始值不能大于终止值！",
			"客户":"客户",
			"分类名称":"分类名称",
			"寄件月份<":"寄件月份<",
			"确定":"确定",
			"阶梯票数汇总导出":"阶梯票数汇总导出",
			"月工作日":"月工作日",
			"提示":"提示",
			"内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
			"客户编码":"客户编码",
			"月工作日必须为正整数，且不能大于31天！":"月工作日必须为正整数，且不能大于31天！",
			"为避免无效数据产生，仅能刷新历史月份统计数据！":"为避免无效数据产生，仅能刷新历史月份统计数据！",
			"汇总票数":"汇总票数",
			"新增成功":"新增成功",
			"导出":"导出",
			"若重新设置月工作日":"若重新设置月工作日",
			"请输入":"请输入",
			"取消":"取消",
			"若寄件月份":"若寄件月份",
			"客户(可多选)":"客户(可多选)",
			"指定路线分类(可多选)":"指定路线分类(可多选)",
			"报表说明︾":"报表说明︾",
			"指定路线(可多选)":"指定路线(可多选)",
		},
		"BMS8071":{
			"包裹销毁":"包裹销毁",
			"航班抵达":"航班抵达",
			"入口清关扣件不放行":"入口清关扣件不放行",
			"收件人拒收":"收件人拒收",
			"运单号码":"运单号码",
			"指定路线":"指定路线",
			"入口清关开始清关":"入口清关开始清关",
			"出货批次":"出货批次",
			"收件邮编":"收件邮编",
			"入口清关解除扣查":"入口清关解除扣查",
			"已签收":"已签收",
			"工作日平均票数":"工作日平均票数",
			"入口清关收货":"入口清关收货",
			"大包号":"大包号",
			"收费材重":"收费材重",
			"COD金额":"COD金额",
			"入口清关准备移交":"入口清关准备移交",
			"已入库":"已入库",
			"包裹丢失":"包裹丢失",
			"已二次转寄":"已二次转寄",
			"包裹损坏":"包裹损坏",
			"包裹到达分拣中心":"包裹到达分拣中心",
			"退件派送服务-分拣仓入库":"退件派送服务-分拣仓入库",
			"申报价值":"申报价值",
			"订单成功上传":"订单成功上传",
			"退件派送服务-分拣仓出库":"退件派送服务-分拣仓出库",
			"退件派送服务-已揽收":"退件派送服务-已揽收",
			"退件派送服务-移交":"退件派送服务-移交",
			"收件人":"收件人",
			"出口清关成功":"出口清关成功",
			"交货到末公里":"交货到末公里",
			"到达派件站点":"到达派件站点",
			"末端转运中":"末端转运中",
			"二次转寄上架":"二次转寄上架",
			"转寄原单号":"转寄原单号",
			"离开分拣仓":"离开分拣仓",
			"最新轨迹时间":"最新轨迹时间",
			"寄件月份":"寄件月份",
			"入口清关扣查":"入口清关扣查",
			"退回海外仓":"退回海外仓",
			"包裹到达自提点":"包裹到达自提点",
			"目的地":"目的地",
			"预报重量":"预报重量",
			"客户":"客户",
			"参考编号":"参考编号",
			"目的地编码":"目的地编码",
			"月工作日":"月工作日",
			"转单号码":"转单号码",
			"收费重":"收费重",
			"出货":"出货",
			"入口清关重新装箱":"入口清关重新装箱",
			"派送异常":"派送异常",
			"汇总票数":"汇总票数",
			"收费实重":"收费实重",
			"报关方式":"报关方式",
			"收件电话":"收件电话",
			"入口清关移交卡车":"入口清关移交卡车",
			"货物类型":"货物类型",
			"最新轨迹状态":"最新轨迹状态",
			"最新轨迹描述":"最新轨迹描述",
			"运单状态":"运单状态",
			"中文品名":"中文品名",
			"关包":"关包",
			"入口清关成功":"入口清关成功",
			"总运单":"总运单",
			"预报袋号":"预报袋号",
			"航班起飞":"航班起飞",
			"首次派送":"首次派送",
			"最新轨迹地点":"最新轨迹地点",
			"寄件月份/月工作日":"寄件月份/月工作日",
		},
		"BIS031":{
			"产品码分类":"产品码分类",
			"产品码":"产品码",
			"分组数据(支持多选)":"分组数据(支持多选)",
			"查询":"查询",
			"重置":"重置",
			"导出":"导出",
			"数据更新时间":"数据更新时间",
			"入库日期":"入库日期",
			"总票数":"总票数",
			"总签收票数":"总签收票数",
			"总签收率":"总签收率",
			"未完成票数":"未完成票数",
			"未完成占比":"未完成占比",
			"失败票数":"失败票数",
			"失败占比":"失败占比",
			"平均签收时间":"平均签收时间",
			"最小签收时间":"最小签收时间",
			"最大签收时间":"最大签收时间",
			"平均上线时间":"平均上线时间",
			"平均首次派送时间":"平均首次派送时间",
			"H3D占比":"H3D占比",
			"H4D占比":"H4D占比",
			"H5D占比":"H5D占比",
			"H6D占比":"H6D占比",
			"H7D占比":"H7D占比",
			"H8D占比":"H8D占比",
			"H9D占比":"H9D占比",
			"H10D占比":"H10D占比",
			"H11D占比":"H11D占比",
			"H12D占比":"H12D占比",
			"H13D占比":"H13D占比",
		}
    }
};
export default zhCN;



// WEBPACK FOOTER //
// /home/jenkins/.jenkins/workspace/tms-saas/code/tms-front/test/tms-front/src/locale/page_zh-CN.js